import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationFI = {
  title: 'Oikeudellinen ilmoitus',
  subtitle: 'Saksan digitaalisia palveluja koskevan lain (DDG) 5 §:n mukaiset tiedot',
  serviceProvider: 'Palveluntarjoaja',
  contactTitle: 'Yhteystiedot',
  addressLabel: 'Osoite',
  contactLabel: 'Sähköpostiosoite',
  professionalTitle: 'Yritystiedot',
  professionLabel: 'Yhtiömuoto',
  businessTypeLabel: 'Toimiala',
  taxTitle: 'Verotiedot',
  liabilityTitle: 'Vastuunrajoitus',
  contentLiabilityTitle: 'Vastuu sisällöstä',
  contentLiability: 'Palveluntarjoajana vastaamme näiden sivujen omasta sisällöstämme yleisten lakien mukaisesti DDG:n 7 §:n 1 momentin nojalla. DDG:n 8–10 §:n mukaan meillä ei palveluntarjoajana kuitenkaan ole velvollisuutta valvoa välitettyjä tai tallennettuja ulkopuolisia tietoja eikä selvittää olosuhteita, jotka viittaavat lainvastaiseen toimintaan.',
  linkLiabilityTitle: 'Vastuu linkeistä',
  linkLiability: 'Sivustomme sisältää linkkejä kolmansien osapuolten ulkoisille verkkosivustoille, joiden sisältöön emme voi vaikuttaa. Siksi emme voi ottaa vastuuta näistä ulkopuolisista sisällöistä. Linkitettyjen sivujen sisällöstä vastaa aina kyseisen sivuston tarjoaja tai ylläpitäjä. Linkitetyt sivut tarkistettiin linkityshetkellä mahdollisten lainvastaisuuksien varalta. Lainvastaista sisältöä ei linkityshetkellä ollut havaittavissa.',
  copyrightTitle: 'Tekijänoikeus',
  copyright: 'Sivuston ylläpitäjien näille sivuille laatimat sisällöt ja teokset kuuluvat Saksan tekijänoikeuslain piiriin. Niiden kopiointi, muokkaaminen, levittäminen ja kaikenlainen hyödyntäminen tekijänoikeuden rajojen ulkopuolella edellyttää kyseisen tekijän tai laatijan kirjallista suostumusta. Sivujen lataaminen ja kopioiminen on sallittu vain yksityiseen, ei-kaupalliseen käyttöön.'
};

export const localeFI = {
  nav: {
    title: 'pAIoneer Labs GmbH',
    home: 'Etusivu',
    team: 'Tiimi',
    events: 'Tapahtumat',
    finance: 'Finanssitekoäly',
    teaching: 'Koulutus',
    agenticdev: 'IDD / agenttinen koodaus',
    iddLegacy: 'Vanhojen ohjelmistojen modernisointi',
    iddMethod: 'Intent-Driven Development',
    veridion: 'Veridion',
    kyveil: 'Anonymisointi',
    quantum: 'Kvantti',
    login: 'Kirjaudu sisään',
    openApp: 'Avaa sovellus',
    account: 'Tili',
    admin: 'Ylläpito',
    logout: 'Kirjaudu ulos',
    languageNames: { en: 'Englanti', de: 'Saksa', nl: 'Hollanti', uk: 'Ukraina', fr: 'Ranska', it: 'Italia', es: 'Espanja', sv: 'Ruotsi', fi: 'Suomi', ja: 'Japani', pl: 'Puola', bg: 'Bulgaria' }
  },
  admin: {
    datalake: {
      loading: "Ladataan …",
      loadFailed: "Data lake ei ole tavoitettavissa",
      refresh: "Päivitä",
      generatedAt: "Tilanne",
      notRolled: "Tätä aluetta ei ole vielä otettu käyttöön backendissä. Heti kun uudet rajapinnat ovat käytössä, tässä näkyy mitattu tila.",
      loadMore: "Lataa lisää",
      yes: "kyllä",
      no: "ei",
      none: "ei yhtään",
      close: "Sulje",
      summaryTitle: "Kaksi hypoteesia, yksi työpöytä",
      summaryBody: "Arkkitehtuurihypoteesi sanoo: matemaattinen astia ratkaisee, mitä mallista voi tulla — se on LLM-artikkelisivulla. Datahypoteesi sanoo: vasta linkitetty, verifioitu koulutusdata täyttää astian — sitä tämä sivu palvelee. Autopilotti täyttää datavarantoa jatkuvasti, käynnistää koulutuksen, kun artikkelin datasuunnitelma on saavutettu jokaisella alueella saksaksi ja englanniksi, mittaa tuloksen benchmark-sarjalla ja julkaisee mallin yksityisesti HuggingFaceen. Jokainen luku tässä on mitattu tai merkitty määritellyksi arvoksi.",
      summaryArchButton: "Arkkitehtuurihypoteesiin (LLM-artikkeli)",
      apTitle: "Autopilotti",
      tpTitle: "Tie koulutuksen alkuun",
      tpSubtitle: "Missä autopilotti on nyt: jokainen vaihe käynnissä olevaan koulutukseen tilan, ajan ja edistymisen kera.",
      tpNow: "Nyt",
      tpStep: "Vaihe",
      tpOf: "/",
      tpSince: "alkaen",
      tpFor: "käynnissä",
      tpHeartbeat: "viimeisin elonmerkki",
      tpDone: "valmis",
      tpRunning: "käynnissä",
      tpWaiting: "odottaa",
      tpFailed: "epäonnistui",
      tpSkipped: "ohitettu",
      tpProgress: "Edistyminen",
      tpRows: "riviä",
      tpRate: "sekunnissa",
      tpRemaining: "arvioitu jäljellä oleva aika",
      tpEstimateNote: "arvio mitatuista laskureista",
      tpPhaseReading: "lukee datapakettia",
      tpPhaseAdmission: "hyväksyntä (kaksoiskappaleet, entropia)",
      tpPhaseEncoding: "tokenisointi",
      tpNoTiming: "Tämä moottoriversio ei vielä raportoi aikoja.",
      tpBlockers: "Esteet ja virheet",
      tpNone: "Ei esteitä.",
      trTitle: "Koulutusajo (live)",
      trSubtitle: "Luetaan suoraan kouluttajan ajohakemistosta — toimii myös workerin uudelleenkäynnistyksen aikana.",
      trNoRun: "Ei vielä koulutusajoa, jolla olisi edistymistietoja.",
      trStateTraining: "kouluttaa",
      trStateStarting: "käynnistyy",
      trStateFinished: "valmis",
      trStateSilent: "hiljaa {age}",
      trStep: "Askel",
      trOf: "/",
      trRemaining: "Jäljellä oleva aika (arvio mitatun nopeuden perusteella)",
      trSecondsPerStep: "s askelta kohden",
      trProgress: "Suunniteltujen askelten edistyminen",
      trRun: "Ajo",
      trResumed: "jatkettu askeleesta {step}",
      trVersion: "Koulutusdatan versio",
      trModel: "Malli",
      trTokensPerSecond: "Tokenia/s",
      trTokensSeen: "Nähdyt tokenit",
      trVram: "GPU-muisti",
      trCap: "raja",
      trLastHeartbeat: "Viimeisin heartbeat",
      trAgo: "{age} sitten",
      trShardReads: "Shard-luvut paikallisesti / workerin kautta",
      trLossTitle: "Loss-kehitys",
      trLossTotal: "Yhteensä",
      trLossNtp: "Seuraava token",
      trLossMtp: "Monitoken",
      trChartEmpty: "Askelia ei ole vielä raportoitu.",
      trAxisNote: "Vaaka-akseli: koulutusaskel, pystyakseli: loss (luonnollinen logaritmi). Vie hiiri käyrän päälle nähdäksesi askeleen arvot.",
      trValue: "Arvo",
      trCurrentValue: "nykyinen",
      trPoints: "{count} mittauspistettä yhteensä",
      trStages: "Opetussuunnitelman vaiheet",
      trStageFoundation: "Perusta (raakateksti)",
      trStageCapability: "Kyvyt",
      trStageAnneal: "Anneal",
      trStageCurrent: "käynnissä",
      trStageDone: "valmis",
      trStageAhead: "tulossa",
      trShards: "shardia",
      trRows: "riviä",
      trCheckpoint: "Uusin checkpoint",
      trCheckpointNone: "ei vielä",
      trCheckpoints: "Täydelliset checkpointit levyllä",
      trCheckpointEvery: "{minutes} min välein",
      trKernels: "Aktiiviset kernelit",
      trDeviations: "Poikkeamat",
      trBlockStorage: "Kopio block storagessa",
      trBlockStorageNone: "ei vielä — ensimmäinen tulee ensimmäisen checkpointin jälkeen",
      trUploading: "lähetys käynnissä: askel {step}",
      treeCkRun: "Koulutusajo",
      treeCkCopy: "Checkpoint block storagessa, kopioitu {time}",
      treeCkLocal: "Checkpoint palvelimen levyllä",
      treeCkUploading: "kopioidaan parhaillaan block storageen",
      trKpiProgress: "Edistyminen",
      trKpiTokens: "Tokenit",
      trKpiThroughput: "Läpäisy",
      trKpiLoss: "Loss",
      trKpiLr: "Oppimisnopeus",
      trKpiGpu: "GPU-muisti",
      trEndAt: "päättyy n. {time}",
      trSeenPlanned: "nähty / suunniteltu",
      trBest: "paras {value}",
      trHourAgo: "{value} verrattuna 1 h sitten",
      trPerplexity: "perpleksiteetti {value}",
      trPhaseWarmup: "lämmitys",
      trPhaseCosine: "kosinilasku",
      trPhaseStable: "vakaa vaihe",
      trPhaseDecay: "jäähdytys",
      trKpiEpoch: "Epookki",
      trEpochValue: "{epoch} / {epochs}",
      trPlanTitle: "Ajosuunnitelma",
      trPlanExplain: "Lämmitys huippuoppimisnopeuteen, sitten vakiona korpuksen neljän sekoitetun epookin ajan; jäähdytysvaihe kouluttaa laadukkaimmalla seoksella (kyvykkyysnäytteet, oppikirjatekstit, anneal) ja laskee oppimisnopeuden nollaan.",
      trPlanPhase: "Vaihe",
      trPlanStableSteps: "Vakaan vaiheen suunnitellut askeleet",
      trPlanDecay: "Jäähdytys",
      trPlanDecayAhead: "askeleesta {step} · noin {time} kuluttua",
      trPlanDecayAheadNoTime: "askeleesta {step}",
      trPlanDecayRunning: "askeleesta {step} · {steps} askelta oppimisnopeuteen nolla",
      trPlanTokensPerStep: "Tokenia optimointiaskelta kohden",
      trPlanTokensPerStepValue: "{tokens} ({accum} mikroerää)",
      trPlanRecompute: "Aktivaatioiden uudelleenlaskenta",
      trPlanRecomputeOn: "päällä – mitattuna nopeampi suuremmalla mikroerällä",
      trPlanRecomputeOff: "pois – mitattuna nopeampi ilman",
      trPlanFim: "Fill-in-the-middle-muotoisia dokumentteja tähän mennessä",
      tbTitle: "Oppikirjaohjelma",
      tbSubtitle: "Opettajamallien oppikirjatekstiksi kirjoittamia foundation-tekstejä; jokaisen luvun ja erisnimen on esiinnyttävä lähteessä.",
      tbTokens: "Oppikirjatokenit",
      tbTokensSub: "{pct} % tavoitteesta {target}",
      tbSamples: "Hyväksytyt uudelleenkirjoitukset",
      tbJobs: "Valmiit työt",
      tbTeacher: "Opettajatokenia oppikirjatokenia kohden",
      tbCost: "Kustannus miljoonaa oppikirjatokenia kohden",
      tbCostNone: "yhdyskäytävä ei ilmoita kustannuksia; opettajatokenit lasketaan",
      tbExplain: "Kulkee koulutuksen rinnalla; myöhemmät epookit ja jäähdytys lukevat sen, mikä on siihen mennessä sinetöity.",
      trThroughputTitle: "Läpäisy (tokenia/s)",
      trCurriculumTitle: "Opetussuunnitelma",
      trStageTokens: "{tokens} tokenia",
      trStageBegins: "alkaa askeleesta {step}",
      trPlanWarningLabel: "Huomio",
      trPlanWarning: "Ajo päättyy {max} askeleen jälkeen vaiheessa ”{stage}” — kykydata alkaa vasta askeleesta {cap}. Täysi läpikäynti vaatisi {steps} askelta (≈ {days} päivää).",
      trPlanOk: "Suunnitellut askeleet ulottuvat vaiheeseen ”{stage}”.",
      trCheckpointsTitle: "Checkpointit",
      trNextCheckpoint: "Seuraava checkpoint",
      trInSpan: "{span} päästä",
      trResumes: "Jatkaminen",
      trNoResume: "ei",
      trConfig: "Kokoonpano",
      trHealth: "Tila",
      trMicroBatch: "Mikroerä / tokenia askelta kohden",
      trSeqLen: "Sekvenssin pituus",
      trLrPlan: "Oppimisnopeuden suunnitelma",
      trLrPlanValue: "huippu {lr}, lämmitys {warmup} askelta, kosini askeleeseen {max}",
      trSpikes: "Loss-piikit (viimeinen tunti)",
      trProgressSub: "askel {step} / {max} · koulutettu {elapsed}",
      trTokensSub: "suunnitellusta {planned}",
      trPathTrainingDetail: "{pct} % · askel {step} / {max} · päättyy n. {end}",
      trReadinessRunning: "Koulutus käynnissä: {pct} % valmis (askel {step} / {max}), loss {loss}, päättyy n. {end}.",
      tdvDraftsHistory: "Vanhemmat luonnokset, ei koskaan sinetöity ({count})",
      runsHistory: "Keskeytetyt ja epäonnistuneet ajot ({count})",
      trAxisStep: "Koulutusaskel",
      trAxisLoss: "Loss (luonnollinen logaritmi)",
      trCountdown: "{d} pv {h} h {m} min {s} s",
      trTimerWaiting: "Ajastin tulee ensimmäisten mittausten jälkeen.",
      trTimerStageEnds: "Vaihe ”{stage}” päättyy",
      trTimerAt: "klo {time}",
      trTimerNext: "Sen jälkeen ”{stage}”: {span}, alkaen {time}",
      trTimerRunEnds: "Ajo päättyy {span} kuluttua ({time})",
      trStepTimeSub: "{wall} s/askel mitattu · laskenta {compute} s",
      trEtaTitle: "Jäljellä oleva aika mitatusta askelkestosta",
      trEtaEpochEnds: "Epookki {epoch}/{epochs} päättyy",
      trEtaEpochAt: "{time} (askel {step})",
      trEtaNextEpoch: "Epookki {epoch}: alkaen {time} (askel {step})",
      trEtaDecay: "Jäähdytysvaihe alkaa {span} kuluttua ({time}, askel {step})",
      trEtaBasis: "Perusta: {wall} s/askel, viimeisten {n} askeleen keskiarvo ilman {pauses} taukoa (uudelleenkäynnistys, pysähdys); laskenta-aika kouluttajan mukaan {compute} s/askel.",
      devTitle: "Poikkeamat suunnitelmasta",
      devNone: "Ei poikkeamia — ajo noudattaa suunnitelmaa täysin.",
      devPlanned: "suunniteltu",
      devLimit: "rajoitus",
      devSeqLen: "Kontekstin pituus",
      devSeqLenText: "Koulutetaan {trained} tokenin kontekstilla suunnitelman {spec} sijaan. Pitkä konteksti tulee myöhemmässä vaiheessa.",
      devFim: "Aukkojen täyttö (FIM)",
      devFimText: "Aukkojen täyttö -tavoite ({rate} % lohkoista) on suunnitelmassa, mutta ei vielä käytössä tässä ajossa.",
      devTermination: "Lopetusluotain",
      devTerminationText: "Lopetusluotain ei ole koulutustavoite vaan oma tila koulutuksen jälkeen; se ajetaan myöhemmin valmiin checkpointin päällä.",
      devDecision: "Päätöstavoite",
      devDecisionText: "Päätöstavoite on käytössä, mutta tämän ajon jälkikoulutusvaiheisiin ei saapunut päätösmerkintöjä.",
      devKernelOff: "Kiihdytys pois",
      devKernelUnverifiedText: "Kerneliä ”{kernel}” ei vahvistettu luotaimessa, joten se ajetaan vakiolaskentana.",
      devKernelUnavailableText: "Kernel ”{kernel}” ei ole saatavilla tällä kortilla, joten se ajetaan vakiolaskentana.",
      devKernelFellBackText: "Kernel ”{kernel}” putosi ajon aikana vakiolaskentaan ({reason}).",
      devOptimizer: "Optimoija",
      devOptimizerText: "Optimoijan tilat ovat bfloat16-muodossa 8 bitin sijaan (bitsandbytes ei saatavilla) — enemmän muistia, sama matematiikka.",
      devScale: "Mallin koko",
      devScaleText: "Malli on instantioitu {scale} % suunnitelman koosta, koska täysi koko ei mahtunut mitattuun muistiin.",
      devMediaHeads: "Mediapäät",
      devMediaHeadsText: "Kuva-/äänipäät ovat kouluttamattomia, koska koulutusdata ei sisällä mediatokeneita — tekstisäikeelle suunniteltu.",
      devVision: "Kuvapolku",
      devVisionText: "Kuvapolku on rakennettu, mutta koulutettu nollalla kuvalla, koska data ei sisällä niitä.",
      devOther: "Muu",
      trStageShare: "{pct} % tästä vaiheesta valmis",
      cap_tool_calling: "Työkalukutsut",
      cap_deep_reasoning: "Syvä päättely",
      cap_software_engineering: "Ohjelmistokehitys",
      cap_office_finance: "Toimisto & talous",
      cap_doc_understanding: "Asiakirjojen ymmärtäminen",
      tpExplainThresholds: "Valitun säikeen jokaiselle kyvylle on oltava riittävästi tarkistettuja esimerkkejä data lakessa. Tavoite ja mittaus ovat tässä kykyä kohden.",
      tpThresholdsDetail: "{met} / {total} kykyä on saavuttanut tavoitteensa",
      tpThresholdRow: "{measured} esimerkkiä",
      tpForeignThresholds: "Ei tälle säikeelle: {list} — kuuluu toiseen säikeeseen eikä estä mitään.",
      tpStepTokenizerReleaseExplain: "Tokenisoija muuttaa tekstin numeroiksi. Se kiinnitetään kerran ja ilmoitetaan arkkitehtuurille, jotta data ja malli puhuvat samaa kieltä.",
      tpStepTokenizeTdvExplain: "Kaikki tarkistetut esimerkit käännetään numerosarjoiksi kiinnitetyllä tokenisoijalla.",
      tpStepTokenizeCorpusExplain: "Koko data laken raakateksti käännetään numerosarjoiksi — perustan massa.",
      tpStepTdvCreateExplain: "Kaikesta tokenisoidusta datasta kootaan kiinteä koulutusdataversio (TDV) opetussuunnitelmineen ja mitattuine tokenmäärineen.",
      tpStepTdvSealExplain: "Versio tehdään muuttumattomaksi ja kopioidaan kuvauksineen block storageen.",
      tpStepCompatExplain: "Kaksitoista sääntöä tarkistaa, että versio ja arkkitehtuuri sopivat yhteen (tokenisoija, kontekstin pituus, tavoitteet, muisti). Kaikkien on oltava vihreitä.",
      tpStepVramExplain: "Mittaa kortilta, onko GPU-muistia vapaana riittävästi ilmoitettuun tarpeeseen.",
      tpVramDetail: "{free} GB vapaana, {need} GB tarvitaan",
      tpStepTrainStartExplain: "Autopilotti käynnistää koulutusajon heti, kun kaikki ehdot täyttyvät.",
      tpStepTrainingExplain: "Ajo kouluttaa itsenäisesti checkpointeilla 30 minuutin välein ja jatkaa itse jokaisen keskeytyksen jälkeen. Tiedot sivulla ”Koulutus & julkaisu”.",
      tpVramRunning: "kortti käynnissä olevan koulutuksen käytössä ({need} GB tarve); täyttyi käynnistyksessä",
      trPathTrainingDetailNoEnd: "{pct} % · askel {step} / {max}",
      srTitle: "Datan valmius mallisäikeittäin",
      srSubtitle: "Kun yksi säie kouluttaa, data lake valmistelee muiden dataa edelleen — omaan sinetöityyn versioon asti, ilman koulutuksen käynnistystä.",
      srTrainingNow: "kouluttaa nyt",
      srSelected: "valittu",
      srDataReady: "data valmis",
      srPreparing: "valmistelussa",
      srModalities: "syöte: {in} · tuloste: {out}",
      srThresholds: "tavoitteet: {met} / {total} saavutettu",
      srCorpus: "Tokenisoitu korpus",
      srCorpusValue: "{tokens} tokenia {shards} datapaketissa",
      srVersion: "Uusin versio",
      srNoVersion: "ei vielä",
      srLacking: "Puuttuu vielä",
      srLacksNothing: "ei mitään — versio odottaa säiettään",
      srLackThresholds: "tavoitteita ei saavutettu",
      srLackCodec: "kuva-/äänikoodekkia ei julkaistu",
      srLackTokenizer: "tokenisoijaa ei ilmoitettu",
      srLackVersion: "ei sinetöityä versiota",
      srSelectedNote: "Tämä säie kouluttaa nyt; sen polku on yllä.",
      srSelectedIdleNote: "Tämä säie on valittu seuraavaan koulutukseen; sen polku on yllä.",
      srUnselectedNote: "Tämä säie ei käynnistä koulutusta, kun toinen on valittu — sen data valmistellaan silti kokonaan.",
      modText: "teksti",
      modImage: "kuva",
      modAudio: "ääni",
      modVideo: "video",
      tpStepThresholds: "Tavoitteiden saavuttaminen",
      tpStepPlan: "Artikkelin datasuunnitelman saavuttaminen",
      tpExplainPlan: "Artikkeli määrää, kuinka monta yksilöllistä, tarkistettua tokenia kukin alue tarvitsee. Saksa ja englanti kantavat kumpikin vähintään puolet siitä; koodi lasketaan ilman kieltä. Laskettavat ovat hyväksytyt tokenit kaksoiskappaleiden poiston jälkeen, eivät raaka-arviot.",
      tpPlanDetail: "{met}/{total} aluetta saavutettu",
      tpPlanRowLang: "{have} / {target} · saksa {de} / {half} · englanti {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "avoinna: {langs}",
      tpLangDe: "saksa",
      tpLangEn: "englanti",
      tpPlanProvisional: "Laskettu alustavasti aiemmalla tokenisoijalla; ratkaiseva on uusi koulutettu.",
      tpStepOwnTokenizer: "Säikeen oma tokenisoija",
      tpStepOwnTokenizerExplain: "Säie koulutetaan omalla tokenisoijalla, joka on opittu tasapainoisesta korpuksesta koodin kanssa. Vasta sen tokeneina datasuunnitelma lasketaan lopullisesti.",
      tpPlanCat_knowledge: "Tieto",
      tpPlanCat_code: "Koodi",
      tpPlanCat_mathematics: "Matematiikka",
      tpPlanCat_domain: "Ammattitekstit",
      tpPlanCat_textbook: "Oppikirja",
      tpPlanCat_agentic: "Agenttiset esimerkit",
      tpPlanFlow: "tulovirta {rate} tunnissa",
      tpPlanEtaDays: "noin {n} päivää jäljellä",
      tpPlanEtaHours: "noin {n} tuntia jäljellä",
      tpPlanNoFlow: "ei tulovirtaa viimeisen 24 tunnin aikana",
      tpPlanBinding: "pullonkaula",
      tpBind_download: "lataus",
      tpBind_allowance: "block storagen päiväkiintiö",
      tpBind_ingest: "sisäänotto",
      tpBind_teachers: "opettajamallit",
      thrPlanTitle: "Esimerkit kyvyittäin (mitattu)",
      thrPlanNote: "Tämän säikeen tavoitteet määrää sen artikkeli: datasuunnitelma alueittain, saksaksi ja englanniksi, polulla koulutuksen alkuun. Kykykohtaiset kynnykset koskevat vain säikeitä, joilla ei ole datasuunnitelmaa; tässä näkyy, mitä kullakin kyvyllä on mitattuna.",
      thrPlanRow: "{samples} esimerkkiä · {tokens} tokenia",
      srDataPlan: "Artikkelin datasuunnitelma: {met}/{total} aluetta saavutettu",
      srLackDataPlan: "datasuunnitelmaa ei saavutettu",
      srPlanOpen: "avoinna: {areas}",
      tpBind_source: "ei lähdettä tällä kielellä",
      tpBind_paused: "lataus tauolla",
      tdvPlanEmpty: "Aktiivisen spesifikaation dataversiota ei vielä ole. Autopilotti rakentaa ja sinetöi sen, kun artikkelin datasuunnitelma on saavutettu.",
      compatPlanNone: "Ei vielä tarkistusta: aktiivisen spesifikaation dataversio tarkistetaan, kun se sinetöidään.",
      mixPlanTitle: "Sekoitus artikkelin mukaan",
      mixPlanNote: "Jokainen koulutusaskel ottaa alueet näissä kiinteissä osuuksissa; vaimenemisvaihe nostaa korkealaatuisen osuuden enintään puoleen. Kykykohtaiset sekoitustavoitteet koskevat vain säikeitä, joilla ei ole datasuunnitelmaa.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Tilannekuva",
      sitSubtitle: "Missä koulutus on yhdellä silmäyksellä: mitä artikkelin kultakin alueelta vielä puuttuu, mitä nyt on käynnissä ja mitä seuraa.",
      sitHeadlineDays: "Koulutus voi alkaa aikaisintaan noin {time} kuluttua; pisimpään kestää {area} (pullonkaula: {bottleneck}).",
      sitHeadlineBlocked: "Näin datasuunnitelmaa ei saavuteta: kohteella {items} ei ole lähdettä. Asiaa työstetään: avoimia aineistoja etsitään tai käännetään tarkistettuna.",
      sitHeadlineReached: "Datasuunnitelma on saavutettu; seuraavaksi tokenisoija, uusi tokenisointi, sinetöinti ja tarkistukset.",
      sitHeadlineUnknown: "Loppuosan tulovirtaa ei ole vielä mitattu.",
      sitHold: "Aloitus on lisäksi pysäytetty, kunnes jokainen rakennuspalikka on tarkistettu.",
      sitArea: "Alue",
      sitTotal: "Yhteensä",
      sitFlow: "Tulovirta",
      sitLeft: "Jäljellä",
      sitBottleneck: "Pullonkaula",
      sitNoLanguage: "ei kieltä",
      sitNoSource: "ei lähdettä",
      sitReached: "saavutettu",
      sitDays: "{n} päivää",
      sitHours: "{n} t",
      sitPerHour: "{value} tunnissa",
      sitPerHourTokens: "{value} tokenia tunnissa",
      sitRunningTitle: "Mitä nyt on käynnissä",
      sitDownloads: "Lataukset",
      sitIngest: "Käsittely tekstipaloiksi",
      sitTokenize: "Tokenisointi",
      sitGenerate: "Tuotanto opettajamalleilla",
      sitIdle: "levossa",
      sitNextTitle: "Mitä seuraa",
      sitNextSteps: "Tokenisoijan koulutus koodilla → koko korpuksen uusi tokenisointi → version sinetöinti → tarkistukset → koulutuksen aloitus",
      sitProvisional: "Määrät on laskettu alustavasti aiemmalla tokenisoijalla; lopullisesti laskee uusi koulutettu.",
      tpPlanSeeSituation: "Alueet, kielet ja jäljellä olevat ajat ovat yllä olevassa tilannekuvassa.",
      sitHeadlineBlocks: "Koulutus ei voi vielä alkaa: rakennuspalikoita puuttuu, ja ne on vielä rakennettava ({items}). Data kasvaa sillä välin.",
      sitDuration: "Koulutuksen kesto: noin {days} päivää {budget} tokenille mitatulla nopeudella {rate} tokenia sekunnissa samassa verkossa.",
      sitBlocksTitle: "Koulutuksen rakennuspalikat",
      sitStateNotBuilt: "ei vielä rakennettu",
      sitStateWaiting: "odottaa",
      sitStateReady: "valmis",
      sitBlockWaitsFor: "odottaa: {items}",
      sitBenchProgress: "{made}/{total} tarkistettua tehtävää",
      sitBlockParts: "rakennettu: {built} · avoinna: {open}",
      part_graph_bundles: "linkitetyt dokumentit",
      part_repository_bundles: "kokonaiset repositoriot",
      part_long_context: "pitkä konteksti",
      part_fine_tuning: "hienosäätö",
      part_reinforcement_learning: "vahvistusoppiminen",
      part_real_folding: "todellinen kontekstin taittaminen",
      sitBlock_data: "Data artikkelin suunnitelman mukaan",
      sitBlock_tokenizer: "Tokenisoija koodilla",
      sitBlock_bench: "Artikkelin benchmark-sarja",
      sitBlock_trainer: "Kouluttaja: ikkunavaiheet, kiinteä budjetti, kiinteä sekoitus",
      sitBlock_bundles: "Niput: linkitetyt dokumentit ja kokonaiset repositoriot",
      sitBlock_post_training: "Jälkikoulutus: pitkä konteksti, hienosäätö, palkkio-oppiminen",
      tpStepTokenizerRelease: "Tokenizerin julkaisu",
      tpStepTokenizeTdv: "Koulutusesimerkkien tokenisointi",
      tpStepTokenizeCorpus: "Korpuksen tokenisointi",
      tpStepTdvCreate: "Dataversion luominen",
      tpStepTdvSeal: "Dataversion sinetöinti",
      apAfterSealLabel: "Jatka automaattisesti sinetöinnin jälkeen",
      apAfterSealOn: "PÄÄLLÄ",
      apAfterSealOff: "POIS",
      apAfterSealConfirmOn: "Jatketaanko automaattisesti sinetöinnin jälkeen? Polku koulutuksen alkuun jatkuu silloin ilman taukoa: yhteensopivuustarkistus, GPU-tarkistukset ja koulutuksen aloitus.",
      apAfterSealConfirmOff: "Pysähdytäänkö taas sinetöinnin jälkeen? Autopilotti pysähtyy silloin tarkastusta varten, kun dataversio on sinetöity.",
      apAfterSealTurnedOn: "Polku koulutuksen alkuun jatkuu automaattisesti sinetöinnin jälkeen.",
      apAfterSealTurnedOff: "Autopilotti pysähtyy sinetöinnin jälkeen.",
      apAfterSealWaiting: "Dataversio sinetöity – autopilotti on tauolla tarkastusta varten.",
      apAfterSealStep: "Sinetöidyn dataversion tarkastus",
      apAfterSealHint: "Sinetöinnin jälkeen kaikki data on käsiteltynä lohkotallennuksessa. Kun kytkin on pois, autopilotti pysähtyy siihen tarkastusta varten; päällä polku jatkuu automaattisesti.",
      tpStepCompat: "Yhteensopivuustarkistus",
      tpStepVram: "VRAM-testi",
      tpStepTrainStart: "Koulutuksen aloitus",
      tpStepTraining: "Koulutus käynnissä",
      apSubtitle: "Yksi kytkin koko kierrolle: datan keruu, käsittely ja linkitys, esimerkkien tuotanto, koulutus kun artikkelin datasuunnitelma on saavutettu, benchmarkit ja yksityinen julkaisu. Jokainen este nimetään sen sijaan, että se ohitettaisiin.",
      apOn: "Autopilotti PÄÄLLÄ",
      apOff: "Autopilotti POIS",
      apTurnOn: "Kytke autopilotti päälle",
      apTurnOff: "Kytke autopilotti pois",
      apConfirmOn: "Kytketäänkö autopilotti päälle? Se täydentää dataa jatkuvasti sinetöityyn dataversioon asti; sen jälkeen se pysähtyy tarkastusta varten, ellei ”Jatka automaattisesti sinetöinnin jälkeen” ole päällä.",
      apConfirmOff: "Kytketäänkö autopilotti pois? Käynnissä oleva työ päättyy hallitusti; mitään ei hylätä.",
      apEnabled: "Autopilotti kytketty päälle",
      apDisabled: "Autopilotti kytketty pois",
      apPause: "Keskeytä",
      apResume: "Jatka",
      apResumed: "Autopilottia jatkettu",
      apPausedNote: "Autopilotti keskeytetty",
      apPausedPill: "keskeytetty",
      apPhaseLabel: "Vaihe",
      apPhaseSince: "alkaen {time}",
      apCycleId: "Kierros",
      apBlockedLabel: "Estetty",
      apCycleTitle: "Käynnissä olevan kierroksen eteneminen",
      apCycleEmpty: "Ei aktiivista kierrosta.",
      colPhase: "Vaihe",
      colPending: "Odottaa",
      colRunning: "Käynnissä",
      colDone: "Valmis",
      colFailed: "Epäonnistui",
      thrTitle: "Kynnykset kyvykkyyksittäin",
      thrSubtitle: "Näistä määristä alkaen autopilotti sinetöi koulutusdataversion ja käynnistää koulutuksen; palkit näyttävät mitatun etenemisen.",
      thrMet: "täyttynyt",
      thrNotMet: "avoin",
      thrDefault: "esiasetettu oletus",
      thrForeign: 'ei valitulle haaralle',
      staleSince: 'Työläinen ei vastaa juuri nyt — viimeisin mitattu tila ajalta',
      staleHint: 'Autopilotti jatkaa; näkymä päivittyy heti kun työläinen vastaa taas.',
      idxTitle: 'Vektori-indeksi ja deduplikointi',
      idxSubtitle: 'Järven oma HNSW-indeksi graafin linkitykseen ja päällekkäisten chunk-shardien mitattu poisto.',
      idxConfigured: 'Indeksi määritetty',
      idxReachable: 'Indeksi tavoitettavissa',
      idxPoints: 'Indeksipisteet',
      idxBackfill: 'Täyttö embeddings-taulusta',
      idxBackfillDone: 'valmis',
      idxBackfillOpen: 'käynnissä / avoin',
      ddLastPass: 'Viimeisin dedup-ajo',
      ddChecked: 'tarkistetut aineistot',
      ddDropped: 'poistetut päällekkäiset shardit',
      ddRows: 'poistetut chunk-rivit',
      ddRemaining: 'jäljellä olevat ehdokkaat',
      ddNone: 'ei vielä ajoa',
      gsTitle: 'Graafin vaiheet',
      gsSubtitle: 'Graafin teacher-vaiheet — embedding ja väittämien poiminta — palvelevat graafista johdettua esimerkkien synteesiä; siksi ne ottavat chunkit leveyssuunnassa aineistojen yli sijajärjestyksessä: sija 0 omistajan asiakirjat ja työkalutuonnit, sija 1 asiantuntijatieto (tiede, tekniikka, kirjat, päättely, German Commons, Wikipedia), sija 2 yleinen teksti (Wikisource, Gutenberg, verkkokorpukset, transkriptit), sija 3 koodi (vain embedding, ei koskaan väittämien poimintaa). Perusmassa päätyy token-korpukseen ilman teacher-ajoa.',
      gsMeasuredAt: 'Mitattu klo',
      gsRanksTitle: 'Sijajärjestys',
      gsRanksEmpty: 'Sijasuunnitelmaa ei ole vielä raportoitu.',
      gsColRank: 'Sija',
      gsColLabel: 'Lähdeluokka',
      gsColSources: 'Lähteet',
      gsColAssets: 'Aineistot',
      gsColPendingExtract: 'Odottaa poimintaa',
      gsColPendingEmbed: 'Odottaa embeddingiä',
      gsRankOwner: 'Omistajan asiakirjat ja työkalutuonnit',
      gsRankExpert: 'Asiantuntijatieto',
      gsRankGeneral: 'Yleinen teksti',
      gsRankCode: 'Koodi (vain embedding)',
      gsRankShort: 'sija {n}',
      gsLoopsTitle: 'Jokaisen silmukan viimeisin kierros',
      gsColLoop: 'Silmukka',
      gsColSource: 'Lähde',
      gsColChunks: 'Chunkit käsitelty',
      gsColClaims: 'Väittämät',
      gsColEdges: 'Särmät',
      gsColSeconds: 'Sekunnit',
      gsColLast: 'Viimeisin kierros',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: 'Väittämien poiminta',
      gsLoopLink: 'Linkitys',
      gsUngrounded: '{n} ilman perustetta',
      gsNoRound: 'ei vielä kierrosta',
      gsClaims: 'Väittämiä yhteensä',
      gsAssetsWithClaims: 'Aineistot, joissa väittämiä',
      gsDangling: 'Orvot chunk-solmut',
      gsStuck: 'Jumiutuneet aineistot (käsittelyssä ilman käynnissä olevaa ingestiä)',
      gsConcurrency: 'Poiminnan rinnakkaisuus',
      gsOrphansLast: 'Viimeisin siivousajo',
      gsOrphansNone: 'ei vielä ajoa',
      gsOrphansStatusCleaned: 'siivottu',
      gsOrphansDropped: 'solmuja poistettu',
      gsOrphansRemaining: 'jäljellä',
      gsOrphansHint: 'Täällä ei ole tehtävää: autopilotti suunnittelee rajatun siivousajon itse niin kauan kuin on chunk-solmuja ilman shardia. Yhteenveto näyttää viimeisimmän ajon.',
      thrSamplesBar: "Esimerkit",
      thrTokensBar: "Tokenit (arvio)",
      thrNoMinimum: "mitattu, ei vähimmäismäärää",
      thrEditTitle: "Muokkaa kynnyksiä",
      thrEditSubtitle: "Tallennus korvaa kaikki kynnykset kokonaan; esiasetetut oletukset pätevät vain, kunnes tähän asetetaan omat arvot.",
      thrMinSamples: "Väh. esimerkit",
      thrMinTokens: "Väh. tokenit (arvio)",
      thrEnabled: "käytössä",
      thrAdd: "Lisää rivi",
      thrSave: "Tallenna kynnykset",
      thrSaved: "Kynnykset tallennettu",
      thrEmpty: "Kynnyksiä ei ole vielä määritelty — ilman käytössä olevia kynnyksiä autopilotti ei sinetöi mitään ja ilmoittaa sen esteenä.",
      capability: "Kyvykkyys",
      modSignature: "Signatuuri",
      removeRow: "Poista",
      budgetsTitle: "Päiväbudjetit",
      budgetsSubtitle: "Kulutus ylärajaa vasten alueittain ja päivittäin — budjetit rajaavat opettaja- ja embedding-kutsut.",
      budgetScope: "Alue",
      budgetDay: "Päivä",
      budgetSpent: "Kulutettu",
      budgetCap: "Yläraja",
      budgetsEmpty: "Budjetteja ei ole ilmoitettu.",
      eventsTitle: "Tapahtumat",
      eventsSubtitle: "Mitä autopilotti viimeksi teki tai ilmoitti, uusin ensin.",
      eventsEmpty: "Ei vielä tapahtumia.",
      storageTitle: "Pilvitallennus",
      storageSubtitle: "Yhteys Block Storage -tallennustilaan ja kansiorakenteen alustus — toistettavissa ilman sivuvaikutuksia.",
      connect: "Yhdistä Block Storage",
      backendLabel: "Kylmävaraston backend",
      backendBlockStorage: "Block Storage",
      backendLocal: "Paikallinen tallennustila",
      connectedLabel: "Yhteys",
      connectedYes: "yhdistetty",
      connectedNo: "ei yhdistetty",
      accountLabel: "Tili",
      signinValidUntil: "Kirjautuminen voimassa",
      oauthClientLabel: "OAuth-asiakas",
      clientConfigured: "määritetty",
      clientNotConfigured: "ei määritetty",
      bootstrapRun: "Alusta rakenne",
      bootstrapDone: "Alustus suoritettu",
      bootstrapReportTitle: "Viimeisin ajo",
      bootstrapNoRun: "Tässä istunnossa ei ole vielä suoritettu bootstrapia.",
      bootstrapLine: "Luodut kansiot: {folders} · tiedostoja kylmävarastossa: {files} · toisto ilman muutoksia: {idempotent}",
      treeTitle: "Kansiopuu",
      treeSubtitle: "Puu on versioitu määrittely: täällä määrittelet kansiot, autopilotti saa vain lisätä. Suojatut moottorikansiot ja ei-tyhjät kansiot moottori hylkää perustellen. Block Storagesta poistetaan vain kiinteiden sääntöjen mukaan, esimerkiksi vanhemmat checkpoint-kopiot (kaksi uusinta säilyy); koko latauksen aikana poistot ja päällekirjoitukset odottavat, kunnes se päättyy.",
      treeActiveVersion: "Aktiivinen versio v{version}",
      treePath: "Polku",
      treePurpose: "Tarkoitus",
      treeCreatedBy: "Luonut",
      treeShards: "Shardit",
      treeBytes: "Koko",
      treeActions: "Toiminnot",
      treeRetire: "Poista käytöstä",
      treeRetired: "Kansio poistettu käytöstä",
      treeAddFolder: "Lisää kansio",
      treeFolderAdded: "Kansio luotu",
      treeVersionsTitle: "Versiot",
      treeEmpty: "Kansioita ei ole vielä määritelty.",
      treePlanned: "Suunniteltu — puumäärittely v{version}",
      treeFiles: "Tiedostot",
      treeSizesMeasured: "Koot mitattu {measured}; kansiot, joita katalogi ei kirjaa, laskettiin Block Storagessa viimeksi {walked}. 1 GB = 10⁹ tavua.",
      treeSizesNoWalk: "Koot mitattu {measured}; kansioita, joita katalogi ei kirjaa, ei ole vielä laskettu. 1 GB = 10⁹ tavua.",
      treeExpand: "Näytä {count} alikansiota",
      treeCollapse: "Piilota alikansiot",
      treeShowMore: "Näytä {count} kansiota lisää",
      treeSourceCatalog: "Katalogista: mukana vain objektit, jotka todella ovat Block Storagessa",
      treeSourceWalk: "Laskettu Block Storagen läpikäynnissä",
      bsUsageTitle: "Block Storagen tila",
      bsUsageSubtitle: "Block Storage -tilin käytetty tila, raja ja vapaa tila sekä data laken osuus siitä; arvot ovat enintään kymmenen minuuttia vanhoja. 1 GB = 10⁹ tavua.",
      bsUsed: "Käytetty",
      bsLimit: "Raja",
      bsFree: "Vapaana",
      bsNoLimit: "ei kiinteää rajaa",
      bsTrash: "Roskakorissa",
      bsLake: "Siitä data lake",
      bsLakeLine: "{size}, {files} tiedostoa · {share} käytetystä tilasta",
      bsMeasuredAt: "Mitattu",
      bsNotConnected: "Block Storagea ei ole yhdistetty; tila näkyy heti, kun yhteys on muodostettu.",
      bsBarLake: "Data lake",
      bsBarOther: "Muu tilin sisältö",
      bsDlTitle: "Koko lataus",
      bsDlSubtitle: "Lataa koko Block Storagen tiedosto kerrallaan samaan kansiorakenteeseen, ilman arkistoa. Latauksen aikana suojatila on voimassa: kirjattujen tiedostojen poistot ja päällekirjoitukset odottavat, kunnes se päättyy; uusia tiedostoja kirjoitetaan edelleen, eivätkä ne kuulu tähän lataukseen. Käynnissä olevaa koulutusta ei koskaan hidasteta.",
      bsDlButton: "Lataa koko Block Storage",
      bsDlFolderHint: "Valitset kohdekansion kerran; alikansiot luodaan sinne. Jo valmiit tiedostot ohitetaan, keskeytyneet jatkuvat pituudestaan.",
      bsDlScriptHint: "Tämä selain ei voi kirjoittaa kansioita. Saat latausskriptin, joka luo saman kansiorakenteen ja hakee jokaisen tiedoston jatkettavasti.",
      bsDlWindowsNames: "Merkit, joita Windows ei salli nimissä (kuten ”>”), näkyvät kohdekansiossa %-koodina, esimerkiksi %3E.",
      bsDlActiveNote: "Lataus on ollut käynnissä {time} alkaen. Yllä oleva painike jatkaa sitä tässä selaimessa; valmiit tiedostot ohitetaan.",
      bsDlBuilding: "Tiedostoluetteloa laaditaan: tähän mennessä {files} tiedostoa, {size}.",
      bsDlManifest: "Tiedostoluetteloa ladataan: {done}/{total} merkintää.",
      bsDlFolder: "Kohdekansio",
      bsDlFiles: "Tiedostot",
      bsDlData: "Data",
      bsDlOf: "{done}/{total}",
      bsDlRate: "Nopeus",
      bsDlEta: "Aikaa jäljellä",
      bsDlEtaUnknown: "lasketaan",
      bsDlCurrent: "Ladataan nyt",
      bsDlSkipped: "{count} jo valmiina, ohitettu",
      bsDlFailed: "{count} tiedostoa epäonnistui",
      bsDlPausedNote: "Tauolla. Aloitetut tiedostot jatkuvat pituudestaan, kun jatkat; suojatila säilyy niin kauan kuin tämä sivu on auki.",
      bsDlPause: "Tauko",
      bsDlContinue: "Jatka",
      bsDlRetryFailed: "Lataa epäonnistuneet uudelleen",
      bsDlFinish: "Päätä",
      bsDlStop: "Pysäytä",
      bsDlStateBuilding: "tiedostoluettelo valmisteilla",
      bsDlStateRunning: "lataa",
      bsDlStatePaused: "tauolla",
      bsDlStateIncomplete: "kesken",
      bsDlStateScript: "skripti valmis",
      bsDlStateFinished: "päätetty",
      bsDlStateStopped: "päättynyt",
      bsDlStateActive: "aktiivinen",
      bsDlFinished: "Kaikki {files} tiedostoa ({size}) ovat kohdekansiossa; lataus on päätetty.",
      bsDlFinishedNote: "Lataus on päätetty; pidätetyt poistot ja päällekirjoitukset suoritetaan nyt.",
      bsDlStopped: "Lataus on pysäytetty; pidätetyt poistot ja päällekirjoitukset suoritetaan nyt. Jo ladatut tiedostot säilyvät.",
      bsDlEnded: "Palvelin päätti latauksen, esimerkiksi kolmenkymmenen minuutin ilman elonmerkkiä jälkeen. Uusi napsautus käynnistää sen uudelleen; valmiit tiedostot ohitetaan.",
      bsDlSession: "Kirjautuminen on vanhentunut. Kirjaudu uudelleen; sen jälkeen yllä oleva painike jatkaa latausta.",
      bsDlDiskFull: "Kohdekansiossa ei ole enää tilaa. Vapauta tilaa ja jatka sitten.",
      bsDlPickFailed: "Kohdekansiota ei voitu avata.",
      bsDlScriptPosix: "Skripti Linuxille ja macOS:lle",
      bsDlScriptWindows: "Skripti Windowsille",
      bsDlScriptRun: "Tallenna skripti kohdekansioon ja käynnistä se siellä: Windowsissa kaksoisnapsauttamalla .cmd-tiedostoa tai komentokehotteessa, Linuxissa ja macOS:ssä päätteessä komennolla ”sh <tiedosto>”.",
      bsDlScriptKeyValid: "Skriptin avain on voimassa {time} asti, vain tälle lataukselle ja vain lukemiseen.",
      bsDlScriptHeartbeat: "Niin kauan kuin tämä sivu on auki, se ilmoittaa palvelimelle, että lataus on yhä käynnissä. Napsauta ”Päätä”, kun skripti on valmis.",
      bsDlProtection: "Suojatila",
      bsDlProtectionState: "Tilanne",
      bsDlProtectionOn: "aktiivinen {time} alkaen",
      bsDlProtectionOff: "ei aktiivinen",
      bsDlScope: "Latauksen laajuus",
      bsDlScopeValue: "{files} tiedostoa, {size}",
      bsDlDeferredDeletes: "Pidätetyt poistot",
      bsDlDeferredOverwrites: "Pidätetyt päällekirjoitukset",
      bsDlAddedSince: "Lisätty käynnistyksen jälkeen",
      bsDlLastActivity: "Viimeisin elonmerkki",
      acqTitle: "Datalähteet",
      acqSubtitle: "Kuratoidut avoimen lisenssin lähteet: lähteittäin lisenssi, tietosuoja-arvio, kieli, modaliteetti, tavutavoite ja mitattu eteneminen. Pois kytketyt lähteet nimeävät syynsä sen sijaan että puuttuisivat hiljaa.",
      acqGdprNote: "GDPR-periaate: koulutusdataa hyväksytään vain lähteistä, joilla on avoin lisenssi ja dokumentoitu tietosuoja-arvio; saapuvien data käy läpi PII-puhdistuksen ennen esimerkkien muodostusta (laskuri \"PII-puhdistettu\" näyttää sen).",
      acqSource: "Lähde",
      acqModality: "Modaliteetti · kieli",
      acqLicense: "Lisenssi",
      acqProtection: "Tietosuoja",
      acqProgress: "Eteneminen",
      acqDocs: "{count} tiedostoa/objektia vastaanotettu",
      acqTargetReached: "tavoite saavutettu",
      acqExhausted: "lähde ehtynyt (listaus ei tarjoa enempää)",
      acqEnabledPill: "käytössä",
      acqWaitingBuffer: "odottaa: puskuri täynnä, lataus kuroo kiinni",
      acqDisabledPill: "pois käytöstä",
      acqEnable: "Ota käyttöön",
      acqDisable: "Poista käytöstä",
      acqEnabledMsg: "Lähde otettu käyttöön",
      acqDisabledMsg: "Lähde poistettu käytöstä",
      acqTargetLabel: "Tavoite (GB)",
      acqSetTarget: "Tallenna tavoite",
      acqTargetSaved: "Tavoite tallennettu",
      acqEmpty: "Lähteitä ei ole vielä rekisteröity.",
      balanceTitle: "Kielitasapaino saksa/englanti",
      balanceSubtitle: "Ladatut tavut modaliteeteittain ja kielittäin — siemenläheissä saksa ei saa jäädä englannin taakse.",
      balanceEmpty: "Ei vielä mittauksia.",
      modText: "Teksti",
      modAudio: "Ääni",
      modImage: "Kuva",
      modVideo: "Video",
      prepTitle: "Esikäsittely",
      prepSubtitle: "Lasketut liukuhihnan vaiheet rekisteröidystä raakadokumentista koulutusesimerkkiin — jokainen luku katalogista; virheet ja tukematon on nimetty.",
      prepRegistered: "rekisteröity",
      prepScrubbed: "PII-puhdistettu",
      prepChunked: "pilkottu",
      prepEmbedded: "upotettu",
      prepExtracted: "poimittu",
      prepLinked: "linkitetty",
      prepSamples: "esimerkit",
      prepByLang: "Kielittäin",
      prepUnsupported: "Ei tuettu",
      prepAwaiting: "Odottaa vaihetta",
      prepFailures: "Virheet",
      inboxTitle: "Raakadatan saapuvat",
      assetWhat: "Sisältö",
      assetFromSource: "lähteestä {source}",
      assetFromUpload: "ladattu käsin",
      mediaParquet: "Taulukkodata (Parquet)",
      treeShardsHint: "Shardit ovat katalogin Parquet-datapaketteja: jokainen rivi on paketti alkuperineen, kielineen ja tarkoituksineen — tarkoitus-sarake kertoo kansion sisällön.",
      mediaWords: {
        text: "Teksti",
        audio: "Ääni",
        video: "Video",
        image: "Kuva",
        application: "Tiedosto",
      },
      inboxSubtitle: "Anna omaa raakadataa lakeen: lataa tähän tai pudota suoraan pilvikansioon raw/inbox/. Täsmäytys rekisteröi jokaisen tiedoston; \"Käsittele nyt\" käynnistää saman polun, jonka autopilotti kulkee itsestään.",
      uploadButton: "Lataa tiedosto",
      uploadHint: "Enintään 512 Mt tiedostoa kohden. Ladatut päätyvät kylmävarastoon ja käsittelyssä ne pilkotaan, upotetaan ja linkitetään tietograafiin.",
      uploadTooLarge: "Tiedosto on suurempi kuin 512 Mt.",
      uploadDone: "Tiedosto vastaanotettu",
      processNow: "Käsittele nyt",
      processStarted: "Käsittely käynnistetty",
      reconcileNow: "Täsmäytä pilvikansio",
      reconcileDone: "Täsmäytys suoritettu",
      unprocessedCount: "{count} käsittelemättä",
      inboxEmpty: "Saapuvat on tyhjä.",
      assetName: "Tiedosto",
      assetType: "Tyyppi",
      assetSize: "Koko",
      assetState: "Tila",
      assetLang: "Kieli",
      assetRegistered: "Rekisteröity",
      assetStates: {
        raw_stored: "raakadata tallennettu",
        awaiting_stt: "odottaa puheentunnistusta",
        awaiting_content_fetch: "odottaa osoitteen takana olevaa sisältöä",
        awaiting_image_codec: "odottaa kuvakoodekkia",
        awaiting_audio_codec: "odottaa äänikoodekkia",
        awaiting_video_codec: "odottaa videokoodekkia",
        chunked: "paloiteltu ja graafissa",
        processed: "käsitelty",
        registered: "rekisteröity",
        queued: "odottaa",
        processing: "käsittelyssä",
        ingested: "vastaanotettu",
        linked: "linkitetty",
        unsupported: "ei tuettu",
        failed: "epäonnistui",
      },
      graphTitle: "Tietograafi",
      graphSubtitle: "Linkitetty raaka-aineisto: solmut ja särmät laskettuina katalogista — näistä yhteyksistä syntyvät koulutusesimerkit.",
      graphEmbedded: "Upotetut solmut",
      graphModel: "Embedding-malli",
      graphClusters: "Klusterit",
      graphAssetsLinked: "Linkitetty raakadata",
      graphLastLink: "Viimeisin linkitys",
      graphNodesTitle: "Solmut lajeittain",
      graphEdgesTitle: "Särmät lajeittain",
      graphEmpty: "Graafi on vielä tyhjä — se syntyy ensimmäisen käsitellyn tiedoston myötä.",
      kindCol: "Laji",
      countCol: "Määrä",
      neighborsTitle: "Solmun naapurit",
      nodeIdLabel: "Solmun ID",
      neighborsRun: "Hae naapurit",
      neighborsEmpty: "Naapureita ei löytynyt.",
      nodeCol: "Solmu",
      edgeKindCol: "Särmä",
      weightCol: "Paino",
      gapTitle: "Kattavuus- ja aukkomatriisi",
      gapSubtitle: "Mitattu varanto asetettuja sekoitustavoitteita vasten kyvykkyyksittäin, signatuureittain ja tasoittain — SQL-näkymä katalogiin, ei koskaan kovakoodattu.",
      tier: "Taso",
      gapHave: "Nyt",
      gapTarget: "Tavoite",
      gapWeight: "Paino",
      gapPriority: "Prioriteetti",
      targetsTitle: "Määritä sekoitustavoitteet",
      targetsSubtitle: "Tavoitteet kantavat tekijän ja ajankohdan; ilman tavoitteita matriisi näyttää rehellisesti tyhjän tilan.",
      addTargetRow: "Lisää rivi",
      saveTargets: "Tallenna tavoitteet",
      targetsSaved: "Tavoitteet tallennettu",
      statusCol: "Tila",
      tdvTitle: "Sinetöity dataversio",
      tdvSubtitle: "Dataversio on muuttumaton ja koottu sinetöidyistä shardeista; uusi korvaa edellisen.",
      createTdv: "Luo TDV-luonnos",
      tdvCreated: "TDV-luonnos luotu",
      tdvId: "TDV",
      tdvName: "Nimi",
      tdvMembers: "Jäsenet",
      tdvCreatedAt: "Luotu",
      tdvSealedAt: "Sinetöity",
      tdvStatusDraft: "luonnos",
      tdvStatusSealed: "sinetöity",
      sealTdv: "Sinetöi",
      tdvSealed: "TDV sinetöity",
      tdvEmpty: "Ei vielä Train Data Versionia — se kootaan sinetöidyistä shardeista.",
      compatTitle: "Arkkitehtuurin ja datan yhteensopivuustarkastus",
      compatSubtitle: "Säännöt R1–R12 kahden koneluettavan dokumentin yli; kojelauta näyttää moottorin tallentaman raportin eikä laske omaa tuomiota.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "ei ALL-GREEN",
      compatRun: "Suorita tarkastus",
      compatChecked: "Tarkastus suoritettu",
      compatSelectTdv: "Valitse TDV yllä olevasta luettelosta nähdäksesi sen raportin.",
      compatNoReport: "Tälle TDV:lle ei ole vielä tallennettua yhteensopivuusraporttia.",
      compatDraftNote: "Arkkitehtuurin datarajapinta on luonnos — tokenizer- ja codec-artefakteja ei vielä ole; tarkastus aktivoituu ensimmäisen tokenizer-julkaisun ja ensimmäisen sinetöidyn TDV:n myötä.",
      compatRule: "Sääntö",
      compatTitleCol: "Otsikko",
      compatKind: "Laji",
      compatEvidence: "Vertaillut arvot (näyttö)",
      kindHard: "kova",
      kindWarn: "huomautus",
      reportsTitle: "Tallennetut raportit",
      reportsEmpty: "Yhteensopivuusraportteja ei ole vielä tallennettu.",
      phaseLabel: "Koulutusvaihe",
      phaseA: "Vaihe A — valmius ja evoluutio",
      phaseB: "Vaihe B — koulutus käynnissä, arkkitehtuuri jäädytetty",
      checklistTitle: "Koulutusvalmius (vaiheen A tarkistuslista)",
      checklistSubtitle: "Ehdot lasketaan suorana; käynnistys pysyy estettynä, kunnes jokainen kohta on vihreä, ja jokainen täyttymätön kohta nimetään.",
      checklistReady: "valmis",
      checklistUnmet: "{count} kohtaa täyttämättä",
      checklistUnavailable: "Tarkistuslista ei ole tavoitettavissa.",
      itemSatisfied: "täytetty",
      itemUnsatisfied: "täyttämättä",
      startTraining: "Käynnistä vaihe B",
      strandTitle: 'Koulutushaara',
      strandSubtitle: 'Mikä mallihaara koulutetaan, kun kaikki edellytykset täyttyvät; valitsematon haara valmistelee dataa edelleen mutta ei koskaan käynnisty.',
      strandSelectedBadge: 'valittu',
      strandExplain: 'Autopilotti kouluttaa haaran {selected}. {other} jatkaa keräämistä ja valmistelua, mutta ei käynnisty, kun sitä ei ole valittu.',
      strandSwitched: 'Valinta tallennettu.',
      strandSwitchFailed: 'Vaihto epäonnistui.',
      strandUnavailable: 'Tämä backend ei vielä tarjoa haaroja; valitsin ilmestyy seuraavan core-julkaisun jälkeen.',
      trainingStarted: "Vaihe B käynnistetty",
      startBlocked: "Käynnistys estetty — täyttämättä: {items}",
      selectedTdvLabel: "Valittu dataversio",
      computedAt: "Laskettu",
      runsTitle: "Koulutusajot",
      runsSubtitle: "Vain todellisia ajoja katalogista; simuloitua koulutusprosessia ei ole.",
      runId: "Ajo",
      archVersion: "Arkkitehtuuri",
      presetCol: "Esiasetus",
      seqLenCol: "Sekvenssin pituus",
      stepCol: "Askel",
      lossCol: "Loss",
      runStarted: "Aloitettu",
      runFinished: "Päättynyt",
      runsEmpty: "Ei vielä koulutusajoa.",
      abortRun: "Keskeytä",
      confirmAbort: "Keskeytetäänkö tämä koulutusajo?",
      runAborted: "Keskeytys pyydetty",
      benchLink: "Benchmark",
      benchTitle: "Benchmark-raportit",
      benchSubtitle: "Jäädytetty, versioitu sarja ajetaan automaattisesti jokaisen koulutuksen jälkeen; jokainen raportti säilyy lakessa ja näkyy tässä.",
      benchEmpty: "Ei vielä benchmark-raporttia.",
      suiteVersion: "Sarja",
      benchOpen: "Avaa",
      benchReportFor: "Benchmark-raportti ajolle {run}",
      benchNoMarkdown: "Tässä raportissa ei ole renderöityä dokumenttia; raakatulokset ovat alla.",
      exportsTitle: "Viennit",
      exportsSubtitle: "Latauksia on olemassa yksinomaan valmistuneiden todellisten koulutusajojen vienneille.",
      exportId: "Vienti",
      exportSize: "Koko",
      exportSha: "SHA-256",
      download: "Lataa",
      exportsEmpty: "Ei vielä vientiä — se syntyy vasta valmistuneesta todellisesta koulutusajosta.",
      hfTitle: "HuggingFace-julkaisut",
      hfSubtitle: "Jokainen lataus on yksityinen; näkyvyys varmennetaan API:n kautta latauksen jälkeen. Ei-yksityinen tulos on virhetila, joka pysäyttää kierron.",
      hfEmpty: "Ei vielä julkaisua.",
      hfRepo: "Repositorio",
      hfState: "Tila",
      hfVisibility: "Näkyvyys",
      hfPrivateVerified: "yksityinen — varmennettu",
      hfUnverified: "ei vielä varmennettu",
      hfVerifiedAt: "Varmennettu",
      connectTitle: "Yhdistä Block Storage",
      connectSubtitle: "Kirjautuminen tallennustilan tarjoajan kirjautumisikkunassa; tallennustila yhdistyy vahvistavaan tiliin.",
      webConnectStart: "Yhdistä tallennustilan tarjoajan kautta",
      webConnectWaiting: "Odotetaan vahvistusta tallennustilan tarjoajan kirjautumisikkunassa…",
      webConnectHint: "Vahvistuksen jälkeen tallennustila yhdistyy automaattisesti; ikkuna päivittyy itse.",
      publicIdentity: "Julkinen sovellusidentiteetti (rclone, jaettu kiintiö)",
      publicIdentityNote: "Tallennustilan tarjoajan kirjautumisikkuna näyttää pyytäväksi sovellukseksi ”rclone” — julkisesti jaettu identiteetti; oma client ID (GDRIVE_OAUTH_CLIENT_ID) korvaa sen milloin tahansa.",
      manualHint: "Vahvistuksen jälkeen selain näyttää tavoittamattoman localhost-sivun. Kopioi code=-parametrin arvo osoiteriviltä ja liitä se tähän (koko osoitteen liittäminen käy myös).",
      manualCodeLabel: "Valtuutuskoodi",
      manualSubmit: "Lunasta koodi",
      deviceInstead: "Käytä sen sijaan laitekoodia",
      licenseAcceptLink: "Vahvista lisenssi Hugging Facessa",
      deviceFlowTitle: "Yhdistä Block Storage (device flow)",
      deviceFlowSubtitle: "Moottori käynnistää tarjoajan laitekirjautumisen; vahvistus tapahtuu toisella laitteella ja sitä kysellään rajatuin välein.",
      deviceFlowStart: "Käynnistä kirjautuminen",
      deviceFlowCode: "Laitekoodi",
      deviceFlowOpenUrl: "Avaa vahvistussivu",
      deviceFlowWaiting: "Odotetaan vahvistusta — kysely noudattaa tarjoajan määräämää väliä.",
      deviceFlowAuthorized: "Yhdistetty",
      deviceFlowExpired: "Laitekoodi on vanhentunut — käynnistä kirjautuminen uudelleen.",
      readinessTitle: "Valmius koulutukseen",
      readinessSubtitle: "Mitattu polku ensimmäiseen koulutusajoon, vaihe vaiheelta.",
      readinessCounter: "{green} / {total} täytetty",
      readinessReady: "Valmis koulutukseen",
      unblockLabel: "Seuraava askel",
      readinessUnavailable: "Valmiuskatsausta ei ole vielä otettu käyttöön backendissä. Heti kun päätepiste on käytössä, mitattu tila näkyy tässä.",
      stageStates: {
        ok: "täytetty",
        active: "käynnissä",
        waiting: "odottaa",
        blocked: "estetty",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'ei saatavilla',
      equilibrium: 'Optimaalinen toimintatila saavutettu: kaikkiin tiedusteluihin on vastattu, kaikki tehtävänsiirrot on käsitelty ja päällekkäisyydet on vältetty.',
      standby: 'valmiustila',
      defTitle: 'Tiimin Operatiivinen Koordinointi & Suorituskykymittarit',
      defSubtitle: 'Kaikkien tekoälyroolien operatiivisen viestintä- ja luovutuslaadun mittaus: painopiste todennetuissa tuloksissa tuottamattoman toiminnan sijaan.',
      defPlayers: 'Osallistuvat Roolit & Järjestelmät',
      defPlayersText: 'Kymmenen erikoistunutta tekoälyroolia Webex-botteineen sekä ihmispäättäjät, jotka määrittelevät toimeksiannot ja linjaukset.',
      defStrategies: 'Viestintä- & Toimintaperiaatteet',
      defStrategiesText: 'Suora vastaaminen kysymyksiin, yksiselitteiset ja täydelliset tehtävänsiirrot, päällekkäisyyksien välttäminen sekä avointen työpakettien johdonmukainen loppuunsaattaminen.',
      defPayoff: 'Operatiivinen Nettotulos (Nettohyöty)',
      defPayoffText: 'Valmistuneet työpaketit, onnistuneesti käsitellyt tehtävänsiirrot ja vastatut kysymykset — vähennettynä kitkahäviöillä (päällekkäisyydet, käsittelemättömät siirrot, vastaamattomat kysymykset).',
      defEquilibrium: 'Optimaalinen Toimintatila (Koordinaatiotasapaino)',
      defEquilibriumText: 'Yhteistyön tavoitetila: jokaiseen tiedusteluun vastataan ajoissa, jokainen tehtävänsiirto otetaan vastaan, mitään tietoa ei lähetetä kahdesti eikä mikään työpaketti jää jumiin.',
      playersTitle: 'Suorituskykykatsaus Rooleittain (Tehtävät)',
      playersSubtitle: 'Operatiiviset viestintä- ja toimitusmittarit rooleittain: asiantuntijapuheenvuorot ja siirrot (viimeiset 7 pv) sekä kokoukset ja valmistuneet työpaketit (viimeiset 30 pv).',
      playersHint: 'Nettohyöty = 3 × valmistuneet työpaketit + käsitellyt siirrot − kitkahäviöt (käsittelemättömät siirrot lasketaan kaksinkertaisina). Negatiivinen arvo osoittaa koordinointitarvetta.',
      player: 'Rooli / Tehtävä',
      contributions: 'Puheenvuorot',
      meetingTurns: 'Kokoukset',
      handovers: 'Luovutukset',
      consumedShort: 'käsitelty',
      refusedShort: 'hylätty',
      delivery: 'Toimitus',
      pausedTurns: 'Keskeytetyt vuorot',
      pausedTurnsHint: 'Vuorot, jotka on tallennettu kollegan omaan postilaatikkoon, koska mallit eivät voineet palvella niitä heti. Eivät ole luovutuksia.',
      closedOpen: 'suljetut / avoimet',
      noise: 'Kitkahäviö',
      utility: 'Nettohyöty',
      meetingsLine: '{held} kokousta, {turns} puheenvuoroa, {u} vastaamatonta puhuttelua (30 päivää).',
      interactionsTitle: 'Roolien Väliset Tehtävänsiirrot (Handover-matriisi)',
      interactionsSubtitle: 'Suunnatut tehtävänsiirrot postilaatikoiden välillä (viimeiset 7 pv): määrä, toimitusaika sekä käsitellyt ja hylätyt siirrot.',
      interactionsHint: 'Tehtävänsiirto katsotaan valmiiksi vasta, kun vastaanottaja on käsitellyt sen; hylätyt tai käsittelemättömät siirrot merkitään prosessipoikkeamiksi.',
      interactionsEmpty: 'Ei luovutuksia ikkunassa.',
      from: 'Keneltä',
      to: 'Kenelle',
      messages: 'Viestit',
      consumed: 'käsitelty',
      refused: 'hylätty',
      deviationsTitle: 'Prosessipoikkeamat & Avoimet Pullonkaulat',
      deviationsSubtitle: 'Nykyiset koordinointipuutteet: vastaamattomat kysymykset, käsittelemättömät tehtävänsiirrot, päällekkäiset viestit tai estyneet työpaketit.',
      dev_unanswered_question: 'Vastaamaton kysymys (aikakatkaisu ylitetty)',
      dev_dead_air: 'Tehtävänsiirto ilman kuittausta',
      dev_repetition: 'Toistoa kokouksessa',
      dev_meeting_unanswered: 'Suora tiedustelu ilman vastausta',
      dev_work_blocked: 'Työ jumissa',
      dev_handover_hop_budget_reached: 'Luovutusten hyppyraja saavutettu',
      dev_commitment_unkept: 'Sprintin sitoumusta ei pidetty',
      devWithheld: 'pidätetty',
      devRepetition: 'toisto',
      devDeadAir: 'käsittelemätön siirto',
      devMeetingUnanswered: 'ilman vastausta',
      effectiveThresholdCol: 'Kynnysarvo',
      excessHopsLabel: 'ylimääräiset hypyt',
      timeTitle: 'Läpimenoajat & Tuottavuusvertailu (Tekoäly vs. manuaalinen työ)',
      timeSubtitle: 'Valmistuneiden kehitystehtävien mitattu tekoälykäsittelyaika verrattuna arvioituun ihmistyömäärään.',
      timeHint: 'Laskennalliset viitearvot työmääräarviointiin; johdon muokattavissa.',
      avgCycle: 'Keskim. tekoälysykli',
      fromTasks: '{n} tehtävästä',
      speedup: 'Nopeutus',
      speedupHint: 'oletuksena {h} ihmistyötuntia kappaleelta',
      humanDelivered: 'Toimitetut ihmistyöpäivät',
      humanDays: 'ihmistyöpäivää',
      forecast: 'Ennuste avoimesta työstä: {d} ihmistyöpäivää',
      sizes: 'Koot',
      sizeSmall: 'pieni',
      sizeMedium: 'keskikokoinen',
      sizeLarge: 'suuri',
      scrumTitle: 'Scrum',
      scrumSubtitle: 'Sprintti, sen story pointit ja velocity, yrityksen omista tiedoista',
      sprintLabel: 'Sprintti {n}',
      ends: 'päättyy',
      committedPts: 'Sitoutetut pisteet',
      deliveredPts: 'Toimitetut pisteet',
      remainingPts: 'Jäljellä olevat pisteet',
      burndownTitle: 'Burndown (jäljellä olevat pisteet päivittäin)',
      velocityTitle: 'Suljettujen sprinttien velocity',
      predictability: 'ennustettavuus',
      forecastLine: 'Liukuva velocity {v} pistettä per sprintti · backlog {b} pistettä ≈ {s} sprinttiä',
      noSprint: 'Sprintti ei ole käynnissä; seuraava suunnittelu avaa sellaisen.',
      noItems: 'Mitään ei ole vielä sitouduttu; sprintti ottaa sen, mitä ihmiset tuovat.',
      colItem: 'Työ',
      colOwner: 'Vastuussa',
      colPoints: 'Pisteet',
      colState: 'Tila',
      itemDone: 'toimitettu',
      itemOpen: 'avoin',
      unestimated: 'arvioimatta',
      addedBy: 'lisännyt {who}',
      setGoal: 'Sprintin tavoite',
      sprintDaysLabel: 'Sprintin pituus (päivää)',
      save: 'Tallenna',
      endSprint: 'Päätä sprintti nyt',
      confirmEndSprint: 'Päätetäänkö sprintti nyt? Katselmointi, retrospektiivi ja seuraava suunnittelu pidetään heti.',
      planNow: 'Pidä ensimmäinen suunnittelu nyt',
      confirmPlanNow: 'Pidetäänkö sprintin suunnittelu nyt? Se avaa ensimmäisen sprintin tilassa pAIoneer-scrum.',
      sprintPointsCol: 'Sprintin pisteet',
      ceremonySpaceLabel: 'Seremoniatila',
      scrumOfScrums: 'Pidä Scrum of Scrums nyt',
      confirmScrumOfScrums: 'Pidetäänkö Scrum of Scrums tilassa pAIoneer-scrum nyt?',
      lastScrumOfScrumsTitle: 'Viimeisin Scrum of Scrums',
      escalatedImpedimentsTitle: 'Eskaloidut esteet (tiimirajat ylittävät)',
      unitBreakdownTitle: 'Erittely yksiköittäin',
      colUnit: 'Yksikkö',
      colWip: 'Käynnissä oleva työ',
      colImpediments: 'Esteet',
    },
    nav: {
      groups: {
        gametheory: 'Tiimikoordinointi & Scrum',
        demos: 'Live-esikatselut',
        sovereign: 'Suvereeni LLM',
        today: 'Päiväkatsaus & Ohjauskeskus',
        organisation: 'Organisaatio',
        work: 'Työ',
        communication: 'Viestintä',
        memory: 'Muisti',
        platform: 'Alusta',
        products: 'Tuotteet',
        identity: 'Identiteetti',
      },
      pages: {
        gametheory: 'Tiimikoordinointi & Scrum',
        demos: 'Live-esikatselut',
        llm: 'LLM-arkkitehtuuri — artikkeli',
        training: 'Data Lake & Tekoälymallin koulutus',
        today: 'Päiväkatsaus & Ohjauskeskus',
        work: 'Työpaketit ja projektit',
        coding: 'Ohjelmointitehtävät',
        gitlab: 'GitLab & Image-käännökset',
        agents: 'Agentit ja luonnokset',
        research: 'Selvitykset',
        webex: 'Webex-tilat',
        mailboxes: 'Postilaatikot',
        conversations: 'Puhelut ja keskustelut',
        meetings: 'Kokoukset',
        engines: 'Tekoälymoottorit & GPU',
        usage: 'Kulutus ja budjetit',
        workloads: 'Konttipalvelut',
        orchestrator: 'Veridion MCP -orkestroija',
      },
      sections: {
        demos: {
          previews: 'Live-esikatselut',
        },
        llm: {
          paper: 'Artikkeli',
          monitoring: 'Valvonta',
        },
        training: {
          autopilot: "Autopilotti",
          storage: "Pilvitallennus & kansiopuu",
          acquisition: "Datanhankinta & esikäsittely",
          data: "Data & tietograafi",
          training: "Koulutus & julkaisu",
        },
        platform: {
          nodes: 'Klusterisolmut',
          events: 'Tapahtumat',
        },
        smtm: {
          runtime: 'Ajonaikainen ohjaus',
          prediction: 'Ennusteiden ohjaus',
          status: 'Datan tila',
          reporting: 'Signaalit',
          training: 'Mallit',
          console: 'Koulutuskonsoli',
        },
        agentic: {
          overview: 'Yleiskatsaus',
          tools: 'Työkalut',
          mcp: 'MCP-palvelimet',
          activity: 'Toiminta',
        },
        'company-memory': {
          content: 'Sisältö',
          search: 'Haku ja tilannekuvat',
          facts: 'Faktat',
          entity: 'Entiteetit',
          remember: 'Tallenna',
          audit: 'Tarkastusloki',
          console: 'Kyselykonsoli',
          stores: 'Tietovarastot',
          graph: 'Tietoverkko (Knowledge Graph)',
          day: 'Päivä',
            bubbles: 'Yksiköiden tietoalueet & Tutkimus'
        },
        organisation: {
          chart: 'Organisaatiokaavio',
          colleagues: 'Tekoälykollegat ja postilaatikot',
          voices: 'Äänet',
          people: 'Henkilöt ja tilat',
          approvals: 'Hyväksynnät ja aikataulut',
          edit: 'Muokkaa organisaatiota',
        },
        work: {
          items: 'Työpaketit',
          projects: 'Kehitettävät projektit',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Image-käännökset',
        },
        agents: {
          agents: 'Agentit',
          designs: 'Agenttiluonnokset',
          definitions: 'Määritykset',
        },
        usage: {
          identities: 'Identiteeteittäin',
          budgets: 'Token-budjetit',
          company: 'Yrityksen instanssi',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Ajoympäristö',
          mcp: 'MCP-palvelimet',
          tools: 'Työkalut',
          activity: 'Toiminta',
        },
      },
      attentionTitle: 'Vaatii toimia',
      attentionSubtitle: 'Kaikkien osa-alueiden tilat, jotka vaativat puuttumista. Napsautus avaa osion.',
      attentionNone: 'Mikään ei vaadi toimia.',
      stateTitle: 'Käyttötila',
      none: 'ei mitään',
      readyOf: '{ready} / {total} valmiina',
      connectedOf: '{connected} / {total} yhdistetty',
      registeredOf: '{registered} / {total} rekisteröity',
      showMore: 'Näytä lisää',
      shownOf: '{shown} / {total}',
      expand: 'Avaa',
      collapse: 'Sulje',
      service: 'Palvelu',
      serviceLinks: 'Linkit',
      controlsTitle: 'Veridion Coren ohjaus',
      confirmRemove: 'Poistetaanko {what}?',
      companyIdentitiesTitle: 'Yrityksen instanssin yhdyskäytäväidentiteetit',
      companyIdentitiesSubtitle: 'Orkestroijan ja Veridion Coren tokenit yhdyskäytävän käynnissä olevassa ikkunassa, jokainen identiteetti budjetteineen.',
      conversationsTitle: 'Keskustelut hallintapaneelista',
      conversationsSubtitle: 'Tekoälykollegoittain kirjalliset keskustelut hallintapaneelista; kirjoittaminen ja soittaminen avaavat valintaikkunan sivun päälle.',
      conversationCount: 'Viestit',
      conversationLastWritten: 'Viimeksi kirjoitettu',
      conversationLastAnswered: 'Viimeksi vastattu',
      exchangesTitle: 'Viestit ja vastaukset',
      exchangesSubtitle: 'Jokainen hallintapaneelin viesti tekoälykollegan vastauksineen, uusin ensin.',
      conversationMessage: 'Viesti',
      conversationAnswer: 'Vastaus',
      today: {
        wordTitle: 'Voimassa oleva johdon ohjeistus',
        wordNone: 'Avointa johdon ohjeistusta ei ole tällä hetkellä asetettu.',
        sinceTitle: 'Tapahtumat edellisen käynnin jälkeen',
        sinceState: 'alkaen {time}',
        workTitle: 'Aktiiviset tehtävät & Vastuut',
        workNone: 'Yksikään työpaketti ei ole työn alla.',
        nextMeeting: 'Seuraava kokous',
        lastMeeting: 'Edellinen kokous',
      },
      work: {
        title: 'Työpaketit',
        subtitle: 'Jokainen yritysmuistin avoin työpaketti vastuuhenkilöineen, tiloineen, prioriteetteineen, määräpäivineen ja skenaarioidensa tuloksineen; otsikko avaa sen graafissa.',
        item: 'Työpaketti',
        kind: 'Laji',
        owner: 'Vastuussa',
        status: 'Tila',
        priority: 'Prioriteetti',
        due: 'Määräpäivä',
        scenarios: 'Skenaariot',
        updated: 'Päivitetty',
        none: 'Ei avoimia työpaketteja.',
        all: 'Kaikki vastuulliset',
      },
      meetings: {
        subtitle: 'Tekoälykollegoiden kokoukset Veridion Coren kirjaamina: aikaväli, yhteenveto ja sitoumukset, joista tuli työtä.',
        slot: 'Aikaväli',
        kind: 'Laji',
        started: 'Alkoi',
        ended: 'Päättyi',
        summary: 'Yhteenveto',
        commitments: 'Sitoumukset',
        hold: 'Pidä kokous nyt',
        held: 'Kokous on kutsuttu koolle.',
        notHeld: 'Kokous on käynnissä tai pidettiin viimeisen puolen tunnin aikana.',
        holdFailed: 'Kokousta ei voitu kutsua koolle',
        none: 'Kokouksia ei ole vielä kirjattu.',
      },
      research: {
        title: 'Selvitykset',
        subtitle: 'Tekoälykollegoiden selvitykset yrityksen aikajanalta, uusin ensin.',
      },
      attention: {
        toneError: 'Häiriö',
        toneWarning: 'Huomautus',
        state: {
          platform: '{ready} / {workloads} workloadia valmiina, {nodes} / {total} solmua valmiina, {restarts} uudelleenkäynnistystä.',
          gateway: '{state}; {models} mallia reititetty, {backends} / {total} palvelevaa backendia valmiina.',
          engine: '{engine}: {running} käynnissä, {waiting} odottaa',
          usage: '{tokens} tokenia {identities} identiteetillä ikkunassa {window}.',
          smtm: 'Ennusteportti {gate}, uudelleenrakennus {rebuild}; {online} / {models} mallia verkossa, {failed} epäonnistunut.',
          smtmSignals: '{open} avointa signaalia, {resolved} ratkaistu, {failed} toimitusta epäonnistui.',
          smtmVeridion: '{connected} / {servers} MCP-palvelinta yhdistetty.',
          company: 'Orkestroija {status}; {ready} / {workloads} workloadia valmiina; Veridion Core {core}; {agents} agenttia käynnissä, {waiting} odottaa.',
          companyWebex: '{registered} / {bots} bottien webhookia rekisteröity.',
          approvals: '{approvals} avointa hyväksyntää; {tasks} koodaustehtävää odottaa henkilöä tai katselmointia.',
          sessions: '{users} kirjautunutta käyttäjää, {sessions} istuntoa, {mfa} vahvistettua, {total} tiliä.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'Alustan tilaa ei voi lukea.',
        nodeNotReady: 'Solmu {name} ei ole valmis.',
        nodePressure: 'Solmu {name} ilmoittaa resurssipulasta: {pressure}.',
        workloadDown: '{name} ({namespace}): {ready}/{desired} valmiina.',
        gatewayNotProgrammed: 'Tekoälyyhdyskäytävää ei ole ohjelmoitu.',
        smtmGateClosed: 'Ennusteportti on suljettu.',
        smtmRebuild: 'Uudelleenrakennus on merkitty.',
        smtmHint: 'Datan tila: {hint}.',
        smtmDeliveryFailed: 'Epäonnistuneita signaalitoimituksia: {count}.',
        smtmModelsFailed: 'Virheen ilmoittavia malleja: {count}.',
        mcpUnreachable: 'Instanssin {instance} MCP-palvelin {server} ei vastaa.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} ei vastaa.',
        parts: {
          orchestrator: 'orkestroija',
          webex: 'Webex-silta',
          knowledge: 'tietopankki',
          core: 'Veridion Core',
          mcp: 'MCP-palvelimet',
          usage: 'kulutuskirjanpito',
          gateway: 'yhdyskäytävän kulutus',
        },
        emergencyStop: 'Veridion Coren hätäpysäytys on päällä.',
        coreMisconfigured: 'Veridion Coresta puuttuu asetuksia: {missing}.',
        agentsWaiting: 'Vastausta odottavia agentteja: {count}.',
        hostedNotRunning: '{agent} ei ole käynnissä.',
        webhookMissing: 'Botin {bot} webhookia ei ole rekisteröity.',
        readerNotAuthorised: 'Yrityksen tilojen lukemista ei ole valtuutettu.',
        approvalOpen: 'Avoin hyväksyntä ({position}): {question}',
        taskWaiting: 'Koodaustehtävä odottaa ihmistä: {title}',
        taskReview: 'Merge request valmis tarkastettavaksi: {title}',
      },
    },
    ops: {
      showDetails: 'Tiedot',
      hideDetails: 'Sulje',
      mcpVersion: 'Versio',
      mcpUrl: 'Osoite',
      mcpProtocol: 'Siirto ja protokolla',
      mcpLastRefresh: 'Viimeksi kysytty',
      mcpError: 'Virhe',
      noTools: 'Työkaluja ei ilmoitettu.',
      toolServer: 'Alkuperä',
      toolAccess: 'Pääsy',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'lukee',
      accessWrites: 'kirjoittaa',
      accessDestructive: 'muuttaa tietoja',
      accessUndeclared: 'ei ilmoitettu',
      usageTitle: 'Kulutus',
      smtmUsageSubtitle: 'Mallikutsut, tokenit ja palveluntarjoajan ilmoittamat kulut viimeisten 30 päivän ajalta.',
      usageByPerson: 'Henkilöittäin',
      usageByModel: 'Malleittain',
      usageByDay: 'Päivittäin',
      model: 'Malli',
      day: 'Päivä',
      promptTokens: 'Syötetokenit',
      completionTokens: 'Tulostetokenit',
      noUsage: 'Kulutusta ei ole kirjattu.',
      runtimeTitle: 'Ajonaikainen tila',
      runtimeSubtitle: 'Miten tämän instanssin orkestroija käyttää mallejaan ja liittää työkalunsa.',
      executionMode: 'Suoritus',
      providerProtocol: 'Protokolla malliin',
      contextWindow: 'Konteksti-ikkuna',
      requestTimeout: 'Aikaraja pyyntöä kohden',
      diagnostics: 'Diagnostiikka',
      diagnosticsOn: 'päällä',
      diagnosticsOff: 'pois (suorituskykytila)',
      externalServers: 'Yhdistetyt MCP-palvelimet',
      mcpEndpoint: 'MCP-päätepiste',
      workloadsTitle: 'Kuormat',
      workloadsSubtitle: 'Nimiavaruuden paioneer-veridion kuormat Kubernetesin ilmoittamina.',
      botsTitle: 'Botit',
      botsSubtitle: 'Organisaation botit kukin webhookeineen sekä sillan palvelut.',
      botAddress: 'Osoite',
      cardWebhook: 'Korttien webhook',
      webhookState: 'Tila',
      noBots: 'Silta ei ilmoita botteja.',
      bridgeServices: {
        knowledgeBase: 'Tietopankki',
        webResearch: 'Verkkohaku',
        osint: 'OSINT',
        anonymizer: 'Anonymisointi',
      },
      connected: 'liitetty',
      notConnected: 'ei liitetty',
      activeRooms: 'Aktiiviset huoneet',
      allowedRooms: 'Sallitut huoneet',
      surface: 'Pinta',
      missingSettings: 'Puuttuvat asetukset',
      none: 'ei mitään',
      instanceToolsTitle: 'Orkestroijan työkalut',
      instanceToolsSubtitle: 'Työkalut, jotka yritysinstanssin orkestroija on rekisteröinyt.',
      openMailbox: 'Postilaatikko',
      positionMailboxHint: 'Tekoälykollegat käsittelevät muiden tekoälykollegojen luovutuksia; tehtävä tekoälykollegalle annetaan sen Webex-tilassa.',
      mailboxesTitle: 'Postilaatikot',
      mailboxesSubtitle: 'Agenteittain: mitä postilaatikossa odottaa, on toimitettu ja on luettu. Rivin napsautus suodattaa viestit.',
      readAt: 'Luettu',
      refresh: 'Päivitä',
      mailbox: 'Postilaatikko',
      mailboxKind: 'Laji',
      mailboxKinds: {
        position: 'Tekoälykollega',
        hosted: 'Isännöity agentti',
        graph: 'Agentti',
      },
      lastMessage: 'Viimeisin viesti',
      noMailboxes: 'Yhtään postilaatikkoa ei voi lukea.',
      messagesTitle: 'Viestit',
      messagesSubtitle: 'Viestit, komennot ja luovutukset uusimmasta alkaen. Napsautus näyttää koko tekstin.',
      allMailboxes: 'Kaikki postilaatikot',
      allStates: 'Kaikki tilat',
      time: 'Aika',
      from: 'Lähettäjä',
      to: 'Vastaanottaja',
      messageKind: 'Laji',
      content: 'Sisältö',
      reply: 'Vastaus',
      noMessages: 'Ei viestejä.',
      messageKinds: {
        message: 'Viesti',
        handover: 'Luovutus',
        command: 'Komento',
        resume: 'Jatkaminen',
        subagent_result: 'Aliagentin tulos',
        review: 'Tarkastus',
      },
      buildsTitle: 'Koonnit',
      buildsSubtitle: 'Kuvat, jotka Veridion Core on koonnut agenteille, uusimmasta alkaen.',
      image: 'Kuva',
      started: 'Aloitettu',
      finished: 'Valmis',
      noBuilds: 'Ei koonteja.',
      coreToolsTitle: 'Agenttien työkalut',
      coreToolsSubtitle: 'Orkestroijan työkalut, joita Veridion Core tarjoaa agenteilleen.',
      description: 'Kuvaus',
      coreDailyTitle: 'Kulutus päivittäin ja malleittain',
      coreDailySubtitle: 'Veridion Coren mallikutsut viimeisten 30 päivän ajalta agenteittain ja malleittain.',
      coreActivityTitle: 'Veridion Coren toiminta',
      coreActivitySubtitle: 'Agenttien, tekoälykollegojen ja luovutusten tapahtumat Veridion Coressa uusimmasta alkaen.',
      event: 'Tapahtuma',
      tool: 'Työkalu',
      detail: 'Tieto',
    },
    tabCompanyMemory: 'Yrityksen muisti',
    llmPaper: {
      subtitle: 'Suvereenin malliarkkitehtuurin generoitu tieteellinen kuvaus — muodostettu paper-dokumentista, jota Veridion Core ylläpitää aktiiviselle spesifikaatiolle.',
      summaryTitle: 'Mitä tämä sivu näyttää',
      summaryBody: 'Veridion Core ylläpitää aktiiviselle malliarkkitehtuurille generoitua tieteellistä dokumenttia: otsikko, tiivistelmä, numeroidut osiot, arkkitehtuurikaavio, taulukot ja lähteet tulevat backendista muuttumattomina; suunnitteluarvot on merkitty sellaisiksi, eikä sivu keksi mitään.',
      refresh: 'Päivitä',
      exportPdf: 'Vie PDF-muodossa',
      strandTraining: 'koulutuksessa',
      strandSelected: 'valittu',
      lcTitle: "Toteutus ja elinkaari",
      lcSelectedTrains: "koulutetaan seuraavaksi",
      lcCollectsOnly: "kerää ja valmistelee — ei käynnisty",
      lcSpec: "Spesifikaatio",
      lcFrozen: "jäädytetty",
      lcArtifacts: "Artefaktit (tokenisoija/koodekki)",
      lcReleased: "julkaistu",
      lcNotReleased: "ei vielä rakennettu",
      lcCodecOpen: "koodekki avoinna",
      lcData: "Datakynnykset",
      lcThresholdsMet: "täytetty",
      lcAreasReached: "datasuunnitelma: {met}/{total} aluetta saavutettu",
      lcNoLake: "datajärvi ei saatavilla",
      lcStage_trainer_image: "Kouluttajan levykuva",
      lcStage_sealed_tdv: "TDV sinetöity",
      lcStage_compat_all_green: "Yhteensopivuus ALL-GREEN",
      lcStage_vram_budget: "VRAM-budjetti",
      lcTraining: "Koulutus",
      lcAuto: "käynnistyy automaattisesti kun kynnykset täyttyvät",
      lcBench: "Vertailutesti",
      lcBenchRows: "mittausta",
      lcNoneYet: "ei vielä",
      lcRelease: "Vienti · Hugging Face (yksityinen) · rekisteri",
      lcReleaseRows: "artefaktia",
      lcReleaseNote: "koulutuksen jälkeen: yksityiseksi varmennettu lataus + rekisterimerkintä",
      lcPipeline: "Koulutusputki",
      lcDone: "valmis",
      lcActive: "käynnissä",
      lcWaiting: "odottaa",
      lcBlocked: "estetty",
      lcCapability: "Kyvykkyys",
      lcSamples: "Näytteet",
      lcByLanguage: "kielittäin",
      lcForeign: 'toinen haara',
      lcCorpus: 'Korpuksen tokenit',
      lcCorpusNone: 'ei vielä tokenisoitu',
      loading: 'Ladataan …',
      unavailable: 'Dokumentti ei ole saavutettavissa.',
      noPaper: 'Tämä Veridion Core -versio ei vielä tarjoa paper-dokumenttia. Siksi sivu ei näytä mitään keksittyä.',
      abstract: 'Tiivistelmä',
      references: 'Lähteet',
      appendix: 'Liite',
      figure: 'Kuva',
      lastUpdated: 'Viimeksi päivitetty',
      empty: 'Ei merkintöjä.',
    },
    llmMonitor: {
      summary: "Mallin käytönvalvonta: tila, data, GPU, kernelit ja läpäisy, arvioinnit ja tapahtumat — mitattu Veridion Coresta ja data lakesta, mitään keksimättä.",
      archTitle: 'Arkkitehtuurin tila',
      archSubtitle: "Aktiivinen arkkitehtuuri, datarajapinnan tila ja jäädytystila.",
      version: 'Versio',
      codename: 'Koodinimi',
      statusLabel: 'Tila',
      interfaceStatus: 'Datarajapinta',
      specSha: 'Spesifikaation tiiviste (SHA-256, lyhennetty)',
      promotedAt: 'Ylennetty',
      frozenLabel: 'Jäädytetty',
      frozenYes: 'Kyllä',
      frozenNo: 'Ei',
      stateWord_active: "aktiivinen",
      stateWord_draft: "luonnos",
      stateWord_released: "julkaistu",
      stateWord_candidate: "ehdokas",
      stateWord_retired: "päättynyt",
      gpuModel: "Näytönohjain",
      gpuTotal: "Grafiikkamuisti yhteensä",
      gpuWindow: "Koulutusikkuna (mitattu)",
      gpuMeasuredAt: "Mitattu",
      gpuSource: "Mittauslähde",
      gpuServing: "Palvelu",
      gpuInferenceTarget: "Yhden kortin päättelytavoite",
      vramTitle: 'GPU- ja VRAM-budjetti',
      vramSubtitle: 'Näytönohjaimen mitattu VRAM-budjetti sellaisena kuin Veridion Core sitä ylläpitää.',
      vramNone: 'Tietueessa ei ole VRAM-budjettia.',
      gateTitle: 'Ylennysportti',
      gateSubtitle: 'Käytäntö, jonka mukaan kandidaattiarkkitehtuuri korvaa aktiivisen, vaadittuine metriikoineen ja painoineen.',
      metric: 'Metriikka',
      weight: 'Paino',
      gateNone: 'Vaadittuja metriikoita ei ole kirjattu.',
      candidatesTitle: 'Kandidaatit',
      candidatesNone: 'Ei kandidaattiarkkitehtuureja.',
      evidenceTitle: 'Arvioinnit',
      evidenceNone: 'Ei vielä mitattuja arviointeja.',
      benchmark: 'Vertailutesti',
      suite: 'Sarja',
      score: 'Tulos',
      evaluator: 'Arvioija',
      date: 'Päivämäärä',
      changelogTitle: 'Muutoshistoria',
      changelogNone: 'Historiassa ei ole vielä arkkitehtuuriversioita.',
      summaryLabel: 'Yhteenveto',
      createdAt: 'Luotu',
      supersededAt: 'Korvattu',
      eventsTitle: 'Tapahtumat',
      eventsNone: 'Tapahtumia ei ole kirjattu.',
      implTitle: 'Haaran toteutustila',
      implSubtitle: "Mitatut tosiasiat: datarajapinnan artefaktit, valinta, token-korpus ja vektori-indeksi; datasuunnitelma alueittain on tilannekuvassa.",
      implSelected: 'Koulutushaara',
      implSelectedYes: 'valittu — koulutetaan seuraavaksi',
      implSelectedNo: 'vain valmistelee (ei koskaan käynnisty)',
      implTokenizer: 'Tokenisoijan artefakti',
      implCodec: 'Koodekin artefakti',
      implNotReleased: 'ei vielä julkaistu',
      implCapability: 'Kyky',
      implSamples: 'Esimerkit (mitattu/tavoite)',
      implNoDatalake: 'Esimerkkien edistymistä ei juuri nyt voi lukea (data-altaan rajapinta ei vastaa).',
      implSwitchHint: 'Koulutushaaran valinta vaihdetaan koulutussivulla.',
      implSituationLink: "Missä data on ja mitä koulutukselta vielä puuttuu: tilannekuva koulutussivulla",
      kernelTitle: 'Ydinten kiihdytys & läpimeno',
      kernelSubtitle: 'Mitä ydinluotain mittasi kortilla: jokainen ydin vertailuunsa nähden, attention-taustajärjestelmä, valitun spesifikaation läpimeno — ja aikasuunnitelma mitatuista tokeneista ja mitatusta läpimenosta laskettuna.',
      kernelNone: 'Tällä kortilla ei ole vielä ajettu ydinluotainta; mitään ei oleteta.',
      kernelName: 'Ydin',
      kernelVerified: 'Todennettu',
      kernelYes: 'kyllä',
      kernelNo: 'ei',
      kernelSpeedup: 'Nopeutus',
      kernelMaxErr: 'Suurin virhe',
      kernelError: 'Havainto',
      kernelAttention: 'Attention-taustajärjestelmä',
      kernelDocMask: 'Dokumenttirajojen peittäminen',
      kernelThroughput: 'Mitattu läpimeno (tokenia/s)',
      kernelMicroBatch: 'Mikroerä',
      kernelMeasuredAt: 'Mitattu',
      kernelImage: 'Trainer-levykuva (digest)',
      kernelRunPath: 'Viimeisimmän ajon ydinpolku',
      kernelRunNone: 'Ei vielä yhtään koulutusajoa, jossa olisi ydintietoja.',
      kernelPlanTitle: 'Aikasuunnitelma (laskutoimitus mittauksista)',
      kernelPlanTokens: 'Tokenimassa',
      kernelPlanTokensSource: 'Tokenimassan lähde',
      kernelPlanDays: 'Arvioidut päivät yhdelle läpikäynnille',
      kernelPlanNone: 'Ei vielä mitattu — ilman mitattua läpimenoa tai mitattua tokenimassaa aikasuunnitelmaa ei keksitä.',
      kernelSourceTdv: 'sinetöity koulutusdataversio',
      kernelSourceCorpus: 'korpus tähän mennessä (ei sinetöity)',
      kernelSourcePlan: "artikkelin budjetti",
      implForeign: 'kuuluu toiseen haaraan',
      implIndex: 'Vektori-indeksi (graafin linkitys)',
      implIndexNone: 'indeksiä ei raportoitu',
      implIndexDown: 'määritetty, ei vastaa',
      implIndexPoints: 'pistettä',
      implIndexBackfillDone: 'täyttö valmis',
      implIndexBackfillOpen: 'täyttö käynnissä',
      implIndexLink: 'Indeksi ja deduplikointi järvimonitorissa',
      implCorpus: 'Token-korpus (raakateksti)',
    },
    software: {
      arch: {
        execTitle: "Suvereeni malliarkkitehtuuri",
        execSubtitle: "Veridion Coren ainoa aktiivinen arkkitehtuurimäärittely: jokainen luku on joko todennettu viitatulla mittausartefaktilla tai backendin merkitsemä suunnittelutavoitteeksi (ei mitattu).",
        openDatalake: "Avaa Data Lake ja tekoälymallin koulutus",
        unavailableArch: "Arkkitehtuuridata ei ole tavoitettavissa.",
        frozen: "Jäädytetty — koulutusajo on käynnissä",
        notFrozen: "Vapautettu (vaihe A)",
        version: "Versio",
        codename: "Koodinimi",
        statusLabel: "Tila",
        createdAt: "Luotu",
        promotedAt: "Ylennetty",
        specSha: "Määrittelyn tiiviste (SHA-256)",
        contextWindow: "Konteksti-ikkuna (suunnitelma, tokenit)",
        dataInterface: "Datarajapinta",
        diStatus: {
          draft: "luonnos",
          complete: "täydellinen",
          missing: "puuttuu",
        },
        paramsTitle: "Parametritase",
        trainingVramTitle: "Koulutus-VRAM (ilmoitettu, Gt)",
        inferenceTitle: "Inferenssi-VRAM (ilmoitettu, Gt)",
        declaredTotal: "Ilmoitettu summa",
        budgetTitle: "GPU:n VRAM-budjetti (mitattu)",
        budgetGpu: "GPU",
        budgetTotal: "VRAM yhteensä (MiB)",
        budgetFreed: "Vapaa koulutusbudjetti (Gt)",
        budgetInferenceTarget: "Yhden GPU:n inferenssitavoite (Gt)",
        diagramTitle: "Generoitu arkkitehtuurikaavio",
        diagramSubtitle: "Deterministisesti generoitu tallennetusta määrittelystä; datan rinnalla ei ole käsin kirjoitettua kaaviota.",
        noDiagram: "Vastaus ei sisällä kaaviota.",
        stagesTitle: "Arkkitehtuurin vaiherakenne",
        stagesSubtitle: "Suoraan tallennetusta määrittelystä; parametriluvut ovat suunnitteluarvoja.",
        stageCol: "Vaihe",
        layersCol: "Kerrokset",
        mechanismCol: "Mekanismi",
        paramsCol: "Fyysiset parametrit (mrd.) ja ensisijaislähteet",
        paramsCross: "läpileikkaava — laskettu vaiheisiin",
        researchTitle: "Kvantti- ja frontier-tekoälyn tutkimusarkisto",
        researchSubtitle: "Suoria rivejä Veridion Coren tutkimusarkistosta; uudet julkaisut tulevat kvanttikollegan työkalun kautta, jokaisen alkuperä näkyvissä.",
        researchEmpty: "Arkistossa ei ole vielä julkaisuja.",
        evidenceTitle: "Arviointinäytöt",
        evidenceSubtitle: "Täällä näkyvät vain mitatut, viitatut arvioinnit; ilman näyttöä ei ole pistemäärää.",
        evalMetric: "Mittari",
        evalBenchmark: "Benchmark",
        evalSuite: "Sarja",
        evalScore: "Arvo",
        evalEvaluator: "Arvioija",
        evalDate: "Mitattu",
        evalArtifact: "Näyttöartefakti",
        gateTitle: "Ylennyssäännöt (näyttöportti)",
        gateMetrics: "Pakolliset mittarit",
        gateEpsilon: "Toleranssi (epsilon)",
        gateConfigVersion: "Portin konfiguraatio (versio)",
        candidatesTitle: "Ehdokasjono",
        candidatesSubtitle: "Jätetyt arkkitehtuuriehdokkaat näyttöjensä tiloineen; jättö tapahtuu tutkimusympäristön kautta, ei koskaan kojelaudalta.",
        candidateSubmittedBy: "Jättäjä",
        candidateEvidence: "Näytöt (on / vaaditaan)",
        candidatesEmpty: "Ehdokkaita ei ole jätetty.",
        changelogTitle: "Suunnittelun muutosloki",
        changelogSubtitle: "Korvatut suunnitteluiteraatiot — tarkoituksella ilman lukuja: niille ei koskaan mitattu mitään.",
        changelogSummary: "Tiivistelmä",
        changelogEmpty: "Ei korvattua suunnitelmaa.",
        supersededAt: "Korvattu",
        eventsTitle: "Portin tapahtumat",
        eventsSubtitle: "Jätöt, ylennykset, hylkäykset ja jäädytyssiirtymät sellaisina kuin portti ne kirjasi.",
        eventsEmpty: "Ei vielä tapahtumia.",
      },
      title: 'Ohjelmistokehitys',
      subtitle: 'Koodausagentin tehtävät, yrityksen GitLab ja sen synkronointi Azure DevOpsista, katselmointia odottavat merge requestit ja GitLab-solmun rajat.',
      openGitlab: 'Avaa GitLab',
      openSonar: 'Avaa SonarQube',
      loading: 'Ladataan …',
      failed: 'Se ei onnistunut',
      done: 'Valmis',
      unavailable: 'Ei tavoitettavissa',
      capacityTitle: 'GitLab-solmu',
      capacitySubtitle: 'Vartija asettaa solmun rajat joka minuutti palvelimen kuorman mukaan; tuotanto pitää varauksensa.',
      stateLabel: 'Tila',
      memory: 'Muisti',
      cpu: 'CPU',
      disk: 'Levy',
      hostFree: 'Vapaana palvelimella',
      reserve: 'Varaus tuotannolle',
      codingSlots: 'Koodaustehtäviä yhtä aikaa',
      pipelineQuota: 'Putken työt',
      recentActions: 'Vartijan viimeisimmät toimet',
      syncTitle: 'Synkronointi Azure DevOpsista',
      syncSubtitle: 'GitLabin master seuraa Azuren masteria; commitit, jotka olivat vain GitLabissa, säilyvät tagin replaced/<aika> alla.',
      syncNow: 'Synkronoi nyt',
      syncStarted: 'Synkronointi käynnistetty',
      azureCommit: 'Azuren master',
      gitlabCommit: 'GitLabin master',
      lastChange: 'Viimeisin muutos',
      lastRun: 'Viimeisin ajo',
      replaced: 'Säilytetty tagien alla',
      noneReplaced: 'ei mitään',
      jobs: 'Viimeisimmät ajot',
      error: 'Virhe',
      readyTitle: 'Katselmointiin valmiit merge requestit',
      readySubtitle: 'Vain merge requestit, joiden putki on vihreä; yhdistäminen tehdään GitLabissa.',
      noReady: 'Yksikään merge request ei odota katselmointia.',
      tasksTitle: 'Koodaustehtävät',
      tasksSubtitle: 'Jokainen koodausagentin ohjelmointityö tilan, merge requestin ja tokenien kanssa.',
      showFinished: 'Näytä päättyneet tehtävät',
      task: 'Tehtävä',
      requester: 'Tilaaja',
      statusLabel: 'Tila',
      mergeRequest: 'Merge request',
      pipeline: 'Putki',
      tokens: 'Tokenit',
      updated: 'Päivitetty',
      noTasks: 'Ei vielä koodaustehtäviä.',
      phase: 'Vaihe',
      repository: 'Repositorio',
      branch: 'Haara',
      openQuestion: 'Avoin kysymys',
      result: 'Tulos',
      sendMessage: 'Kirjoita tehtävälle',
      answerQuestion: 'Vastaa kysymykseen',
      urgent: 'Kiireellinen: ohjaa käynnissä olevaa vaihetta heti',
      send: 'Lähetä',
      messageSent: 'Toimitettu tehtävälle',
      confirmCancel: 'Perutaanko tehtävä? Avoin merge request suljetaan.',
      course: 'Istunnon kulku',
      messages: 'Viestit',
      events: 'Tapahtumat',
      none: 'ei mitään',
      close: 'Sulje',
      newTitle: 'Uusi tehtävä',
      newSubtitle: 'Anna koodausagentille tehtävä täältä; seuraa sitä täällä ja sen Webex-kortilla.',
      brief: 'Mitä agentin pitää tehdä?',
      issue: 'YouTrack-tiketti (valinnainen)',
      create: 'Luo tehtävä',
      created: 'Tehtävä luotu',
      usersTitle: 'Ylläpitäjät GitLabissa',
      usersSubtitle: 'Jokaisella ylläpitäjällä on GitLab-käyttäjä ylläpitäjän oikeuksin; housekeeping pitää ne Keycloakin tahdissa.',
      email: 'Sähköposti',
      gitlabUser: 'GitLab-käyttäjä',
      lastHousekeeping: 'Viimeisin housekeeping',
      sonarDeleted: 'Poistettujen haarojen SonarQube-projektit poistettu',
      previewsTitle: 'Kehityksessä olevat projektit',
      previewsSubtitle: 'Jokainen kehityksessä oleva projekti ajetaan tasan kerran ensimmäisestä mergestä alkaen: Veridion Core käynnistää päähaaran (migration tai master) uusimman vihreän tilan kontteihin pääkäyttäjän kirjautumisen taakse, uusii sen jokaisen vihreän pipelinen jälkeen, ja kontit käynnistetään, pysäytetään ja uudelleenkäynnistetään tässä. Projekti, jonka pipeline ei rakenna mitään ajettavaa, näkyy tässä syyn kanssa.',
      previewsSummaryTitle: 'Mitä tämä näkymä näyttää',
      previewsSummaryBody: 'Jokainen kehityksessä oleva projekti pyörii omassa esikatselukontissaan ylläpitäjän kirjautumisen takana. Ylhäällä oleva lista näyttää kunkin projektin uusimman ajokelpoisen tilan, alla oleva taulukko käynnissä olevat kontit tiloineen, osoitteineen ja ohjauksineen: avaa, käynnistä, pysäytä, käynnistä uudelleen.',
      previewProject: 'Projekti',
      previewState: 'Ajossa oleva tila',
      previewSince: 'Alkaen',
      previewAddress: 'Osoite',
      previewMergedAt: 'Yhdistetty',
      noPreviews: 'Mikään projekti ei ole käynnissä.',
      reasonsLabel: 'Estävät syyt & Diagnostiikka',
      noProjects: 'Ei projekteja kehityksessä.',
      qualityCoverage: 'Testikattavuus',
      qualityBugs: 'Bugit',
      qualitySmells: 'Code smellit',
      qualityDuplication: 'Päällekkäisyys',
      qualityHotspots: 'Avoimet hotspotit',
      qualityUnavailable: 'Ei SonarQube-mittauksia',
      openPreview: 'Avaa',
      startPreview: 'Käynnistä kontit',
      stopPreview: 'Pysäytä kontit',
      previewStarted: 'Kontit käynnistetty',
      previewStopped: 'Kontit pysäytetty',
      restartPreview: 'Käynnistä kontit uudelleen',
      previewRestarted: 'Kontit käynnistetty uudelleen',
      previewControl: 'Kontit',
      resultTitle: 'Tulos GitLabissa',
      resultJobs: 'Työt ja artefaktit',
      resultSonar: 'SonarQube',
      resultDelivered: 'Toimitettu',
      previewStatus: {
        starting: 'käynnistyy',
        running: 'käynnissä',
        stopped: 'pysäytetty',
        failed: 'epäonnistui',
      },
      capacityStates: {
        ok: 'rajojen sisällä',
        tight: 'tiukkaa: tuotanto tarvitsee tilan',
        full: 'täynnä: ei uutta työtä',
        node_down: 'solmu ei ole käynnissä',
      },
      status: {
        queued: 'odottaa vapaata paikkaa',
        working: 'työn alla',
        waiting: 'odottaa vastausta',
        review: 'katselmoinnissa',
        merged: 'yhdistetty GitLabissa',
        done: 'valmis',
        needs_person: 'tarvitsee ihmisen',
        rejected: 'suljettu ilman yhdistämistä',
        paused: 'keskeytetty',
        cancelled: 'peruttu',
        failed: 'epäonnistui',
      },
      commands: {
        pause: 'Keskeytä',
        resume: 'Jatka',
        cancel: 'Peru',
      },
      repositoryChoice: {
        auto: 'Agentti päättää',
        company: '{project} (ihminen yhdistää)',
        own: 'Oma projekti ryhmässä {group}',
      },
      userState: {
        ok: 'tahdissa',
        created: 'luotu',
        unblocked: 'avattu',
        'made administrator': 'tehty ylläpitäjäksi',
        blocked: 'estetty',
      },
    },
    org: {
      write: 'Kirjoita',
      call: "Soita",
      callTitle: "Puhelu: {bot}",
      writeTitle: 'Viesti kollegalle {bot}',
      callConfirmEnd: 'Lopetetaanko puhelu?',
      callSubtitle: 'Mikrofoni on päällä koko puhelun ajan. Botti tervehtii omalla äänellään, vastaa lyhyesti, kysyy tarkentavasti avoimista kohdista ja sen voi keskeyttää. Jokainen lause näkyy myös Webexissä, suorassa huoneessa botin kanssa.',
      callRinging: "Soi …",
      callConnected: "Yhdistetty",
      callEnded: "Päättynyt",
      callEndedHangup: "Lopetit puhelun",
      callEndedClosed: "Yhteys katkesi",
      callEndedSilence: "90 sekuntia hiljaisuutta",
      callEndedLimit: "30 minuutin raja täyttyi",
      callEndedError: "Virhe päätti puhelun",
      callHangUp: "Lopeta puhelu",
      callLevel: "Mikrofonin taso",
      callYou: "Sinä",
      callSpeaking: "Botti puhuu …",
      callThinking: 'Vastausta muodostetaan …',
      callOvertaken: "seuraava kysymyksesi ohitti sen, ei puhuttu",
      callNothingHeard: "Sanoja ei kuultu.",
      callMicDenied: "Selain kielsi mikrofonin; salli se tälle sivulle ja soita uudelleen.",
      callNoVoice: "Ääni ei ole juuri nyt käytettävissä; vastaus on tekstinä.",
      callRefused: "Puhelua ei otettu vastaan: lippu oli virheellinen tai vanhentunut; soita uudelleen.",
      callFailed: "Puhelu epäonnistui",
      voice: "Ääni",
      voiceHint: "Ääni, jolla tämä kollega puhuu: Webexissä, kun henkilö pyytää kuulla vastauksen, ja puhelimessa. Oletuksena on OpenRouterin äänimallin puhuja; oma, kloonattu ääni äänivarastosta puhuu alustan äänimoottorin kautta.",
      voiceSave: "Tallenna ääni",
      voiceDefault: "oletus",
      voiceNone: "ei ääntä",
      voiceCloud: "OpenRouter-puhujat (oletus)",
      voiceOwn: "Omat äänet (kloonatut)",
      voiceUploadTitle: "Lähetä ääninäyte tälle kollegalle",
      voiceUploadHint: "Ääni tai video, enintään 25 MB; Core muuntaa näytteen, pitää enintään 20 sekuntia, kuulee sen sanat ja tallentaa vain viiteleikkeen. Kollega puhuu heti tällä äänellä.",
      voiceUploadName: "Äänen nimi",
      voiceUploadConsent: "Vahvistan, että minulla on oikeus käyttää tätä ääntä yritykselle: se on omani tai henkilö on antanut suostumuksensa.",
      voiceUploadButton: "Lähetä näyte",
      voiceUploadDone: "Ääni tallennettu",
      voiceTooLarge: "Tiedosto on suurempi kuin 25 MB.",
      voicesTitle: "Äänet",
      voicesSubtitle: "Jokainen yrityksen ääni on viiteleike Veridion Coren äänivarastossa; äänimoottori kloonaa sen aina, kun botti puhuu. Yhdeksän aiempaa puhujaa ovat siinä tallennettuina leikkeinä.",
      voiceSeconds: "Sekuntia",
      voiceSource: "Alkuperä",
      voiceSourcePreset: "tallennettu puhuja",
      voiceSourceUpload: "lähetetty näyte",
      voiceAddedBy: "Lisännyt",
      voiceConsentBy: "Suostumuksen vahvistanut",
      voiceWords: "Leikkeen sanat",
      voiceDelete: "Poista",
      voiceConfirmDelete: "Poistetaanko tämä ääni? Sitä käyttävät kollegat puhuvat taas oletusäänellään.",
      voiceCapture: "Tallenna esiasetusmoottorin puhujat",
      voiceCaptureHint: "Puhuu yhden kiinteän lauseen puhujaa kohden esiasetusmoottorin kautta ja tallentaa sen leikkeenä; ajetaan ennen moottorin vaihtoa.",
      voiceCaptured: "Tallennettu",
      voiceEnginePresets: "Äänimoottori tarjoaa kiinteät puhujat; äänivarastoa ei käytetä.",
      chartTitle: "Organisaatiokaavio",
      executiveTitle: 'Johtotaso',
      unitsTitle: 'Liiketoimintayksiköt',
      unitLead: 'Vetäjä',
      unitSupporting: 'Tukena',
      unitMission: 'Tehtävä',
      unitPrefix: 'Ketjun etuliite',
      standingActive: 'aktiivinen',
      standingStandby: 'valmiustila',
      standbyOn: 'Aseta valmiustilaan',
      standbyOff: 'Aktivoi',
      standbyHint: 'Valmiustilassa kollega ei tee yhtään yrityksen omasta aloitteesta syntyvää vuoroa eikä kuluta tokeneita; henkilön suora viesti saa yhä vastauksen.',
      confirmStandby: 'Asetetaanko {name} valmiustilaan?',
      confirmActivate: 'Aktivoidaanko {name}?',
      activity: 'Toiminta',
      runtime: 'Ajoympäristö',
      modelCloud: 'pilvimalli',
      modelGpu: 'yrityksen moottori',
      callModel: 'Puhelinmalli',
      calls30: 'Puhelut, viimeiset 30 päivää',
      telemetryLine: '{model} · {prompt}+{completion} tokenia · {cost} · korva {asr} ms · mieli {llm} ms · ääni {tts} ms · yhteensä {total} ms{deferred}',
      telemetryDeferred: ' · {count} lykätty',
      chartSubtitle: "Veridionin tekoälykollegat: agentteja Veridion Coressa, jokainen tavoitettavissa omana Webex-bottinaan, alueittain; niiden yläpuolella ihmispäätöksentekijät, alapuolella agentit ilman omaa bottia ja yrityksen tilat, luettuina suoraan Veridion Coresta ja Webexistä.",
      chartPeople: "Päätöksentekijät",
      chartPeopleText: "Ihmispäätöksentekijät päättävät kaikesta ja toimivat tilassa {space}.",
      chartAgentsTitle: "Agentit ilman omaa bottia: koodausagentti, Veridion MCP -orkestroija ja arkkitehdin rakentamat agentit työskentelevät tekoälykollegan puolesta ja puhuvat sen botin kautta",
      chartDesigned: "Arkkitehdin kanssa suunnitellut agentit",
      chartFor: "Toimeksiantaja",
      chartSystemsTitle: "Liitetyt järjestelmät",
      chartSpaceHome: "Alueen kotitila",
      chartSpacePurpose: "Tarkoitus",
      chartRoomsTitle: "Yrityksen tilat Webexissä",
      room: "Tila",
      roomBots: "Botit",
      positionsTitle: "Tekoälykollegat",
      positionsSubtitle: "Jokainen tekoälykollega vastaa omalla botillaan ja lukee omat tilansa. Sen kuvaus on ohje, jonka mukaan se työskentelee.",
      bot: "Botti",
      position: "Työtehtävä",
      statusLabel: "Tila",
      tokensUsed: "Käytetyt tokenit",
      tokens30: "Tokenit, viimeiset 30 päivää",
      edit: "Muokkaa",
      close: "Sulje",
      description: "Tekoälykollegan kuvaus",
      save: "Tallenna",
      resetDescription: "Palauta oletuskuvaus",
      interests: "Kiinnostusprofiili",
      interestsHint: "Millaiset asiat ja aiheet koskevat tätä tekoälykollegaa ja milloin se ei ole osallinen. Tekoälykollega arvioi jokaisen tilojensa viestin tätä vasten.",
      threshold: 'Kynnys pyytämättömille puheenvuoroille',
      thresholdHint: '1–5: kuinka vahvasti viestin täytyy koskea tekoälykollegaa, ennen kuin se puhuu pyytämättä. Arvolla 1 se puhuu jo vähäisellä merkityksellä, arvolla 5 vain suurella.',
      saveProfile: "Tallenna profiili",
      tools: "Työkalut",
      decisionMakersTitle: "Päätöksentekijät",
      decisionMakersSubtitle: "Kuka tahansa heistä voi antaa minkä tahansa hyväksynnän ja vastata tekoälykollegan kysymykseen Webexissä.",
      email: "Sähköpostiosoite",
      add: "Lisää",
      remove: "Poista",
      confirmRemove: "Poistetaanko tämä päätöksentekijä?",
      readerTitle: "Yrityksen tilojen lukeminen",
      readerSubtitle: "Botti näkee vain viestit, joissa se mainitaan. Veridion lukee jokaisen yrityksen tilojen viestin sellaisen tilin valtuutuksella, joka on kaikkien tilojen jäsen.",
      notConfigured: "Integraatiota ei ole määritetty",
      authorised: "Valtuutettu",
      notAuthorised: "Ei valtuutettu",
      account: "Tili",
      validUntil: "Käyttötunnus voimassa",
      renewUntil: "Valtuutus uusittavissa",
      authorise: "Valtuuta lukeminen",
      authoriseAgain: "Valtuuta uudelleen",
      linkOpened: "Webex-kirjautuminen avautui uuteen välilehteen.",
      found: "löytyi",
      notFound: "ei löytynyt",
      botsInSpace: "botit",
      transcripts: "Kokousten tekstitykset",
      yes: "kyllä",
      no: "ei",
      approvalsTitle: "Avoimet hyväksynnät",
      approvalsSubtitle: "Hyväksynnät ja kysymykset, joita tekoälykollegat ovat pyytäneet ja joihin kukaan ei ole vielä vastannut.",
      originSpace: "Tila",
      directRoom: "suora keskustelu",
      approvalKinds: { review: "hyväksyntä", question: "kysymys" },
      schedulesTitle: "Aikataulut",
      schedulesSubtitle: "Toistuva työ, jota joku pyysi tilassa; se jatkuu, kunnes joku lopettaa sen.",
      createdBy: "pyytäjä",
      lastRun: "viimeksi suoritettu",
      end: "Lopeta",
      confirmEnd: "Lopetetaanko tämä aikataulu?",
      none: "Ei yhtään",
      loading: "Ladataan…",
      failed: "Epäonnistui",
      working: "Käynnissä…",
      done: "Valmis",
      memoryTitle: "Organisaatio",
      memorySubtitle: "Yrityksen ihmiset ja tekoälykollegat sekä muistialue, jossa kukin tekoälykollega työskentelee.",
      memoryMember: "Jäsen",
      area: "Alue",
      decisionMaker: "Päätöksentekijä",
      status: { running: "käynnissä" },
    },
    core: {
      conversationTitle: 'Keskustelu hallintapaneelista',
      conversationHint: 'Jokainen viesti ja vastaus sanotaan myös Webexissä: agentin työn ketjussa, muuten suorassa huoneessasi botin kanssa.',
      conversationEmpty: 'Ei vielä viestejä hallintapaneelista.',
      writeToAgent: 'Viesti tälle agentille',
      answerPending: 'Vastaus odottaa',
      title: 'Veridion Core',
      subtitle: 'Yritysbotin taustalla toimiva agenttinen käyttöjärjestelmä: sen agentit, niiden viestit ja tokenkulutus, määritelmät, arkkitehti ja organisaatio.',
      done: 'Valmis.',
      failed: 'Se ei onnistunut',
      loading: 'Ladataan …',
      working: 'Käsitellään …',
      none: 'Ei mitään.',
      unavailable: 'Veridion Core ei ole tavoitettavissa',
      errors: {
        AGENT_FINISHED: 'Agentti on päättynyt eikä ota vastaan enempää viestejä',
        EMERGENCY_STOP: 'Hätäpysäytys on päällä',
        DEFINITION_INVALID: 'Määritelmä ei ole kelvollinen',
        TOO_MANY_AGENTS: 'Käynnissä on liian monta agenttia',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Corea ei ole määritetty',
        MESSAGE_EMPTY: 'Viesti on tyhjä',
      },
      status: {
        building: 'levykuvaa rakennetaan',
        starting: 'käynnistyy',
        running: 'käynnissä',
        waiting: 'odottaa',
        idle: 'valmiina',
        paused: 'keskeytetty',
        completed: 'valmis',
        failed: 'epäonnistui',
        cancelled: 'peruttu',
        stopped: 'pysäytetty',
        not_deployed: 'ei käyttöönotettu',
      },
      statusLabel: 'Tila',
      owner: 'Omistaja',
      definition: 'Määritelmä',
      parent: 'Yläagentti',
      tokens: 'Tokenit',
      progress: 'Edistyminen',
      close: 'Sulje',
      openQuestion: 'Avoin kysymys',
      result: 'Tulos',
      answerQuestion: 'Vastaa kysymykseen',
      sendMessage: 'Viesti agentille',
      urgent: 'Kiireellinen: keskeytä meneillään oleva vaihe',
      send: 'Lähetä',
      messageSent: 'Toimitettu agentille.',
      commands: {
        pause: 'Keskeytä',
        resume: 'Jatka',
        cancel: 'Peruuta',
        kill: 'Lopeta heti',
      },
      confirmKill: 'Lopetetaanko tämä agentti ja sen aliagentit heti?',
      subAgents: 'Aliagentit',
      graph: 'Graafi',
      messages: 'Viestit',
      messageStatus: {
        queued: 'jonossa',
        delivered: 'toimitettu',
        consumed: 'luettu',
        refused: 'hylätty',
      },
      events: 'Tapahtumat',
      containerLog: 'Kontin loki',
      version: 'Versio',
      activeAgents: 'Käynnissä olevat agentit',
      updated: 'Päivitetty',
      archived: 'arkistoitu',
      noDefinitions: 'Ei vielä määritelmiä.',
      versions: 'Versiot',
      from: 'lähde',
      startInput: 'Käynnistyssyöte JSON-muodossa',
      agentStarted: 'Agentti käynnistetty.',
      startAgent: 'Käynnistä agentti',
      editAsJson: 'Muokkaa JSON-muodossa',
      confirmArchive: 'Arkistoidaanko tämä määritelmä? Käynnissä olevat agentit jatkavat toimintaansa.',
      archive: 'Arkistoi',
      definitionJson: 'Määritelmä JSON-muodossa',
      definitionJsonHint: 'Määritelmä Veridionin graafikielellä. Validointi näyttää sen puutteet ja graafin; tallennus tallentaa sen uutena hyväksyttynä versiona.',
      checked: 'Tarkistettu.',
      validate: 'Validoi',
      saved: 'Tallennettu uutena versiona.',
      saveVersion: 'Tallenna uutena versiona',
      valid: 'Määritelmä on kelvollinen.',
      you: 'Sinä',
      architect: 'Arkkitehti',
      architectPlaceholder: 'Kuvaile, mitä agentin pitää tehdä …',
      newDesign: 'Uusi luonnos',
      unitKinds: {
        company: 'yritys',
        department: 'osasto',
        team: 'tiimi',
        project: 'projekti',
      },
      partOf: 'osa yksikköä',
      confirmRemove: 'Poistetaanko tämä yksikkö? Sen jäsenet menettävät tämän alueen.',
      remove: 'poista',
      addUnit: 'Lisää yksikkö',
      unitId: 'Tunniste (pienet kirjaimet, yhdysmerkit)',
      unitName: 'Nimi',
      add: 'Lisää',
      addMember: 'Lisää jäsen',
      memberKinds: {
        person: 'henkilö (sähköpostiosoite)',
        agent: 'agentti (tunniste)',
        definition: 'määritelmä (tunniste)',
      },
      memberId: 'Sähköpostiosoite tai tunniste',
      role: 'Rooli',
      confirmEmergencyOn: 'Pysäytetäänkö kaikki agentit nyt? Botti vastaa edelleen.',
      confirmEmergencyOff: 'Vapautetaanko hätäpysäytys?',
      emergencyStop: 'Hätäpysäytys',
      emergencyRelease: 'Vapauta hätäpysäytys',
      emergencyActive: 'hätäpysäytys on päällä',
      autopilotOn: 'Kytke autopilotti päälle',
      autopilotOff: 'Kytke autopilotti pois',
      autopilotActive: 'Autopilotti on päällä: Veridion Core vastaa itse jokaiseen ihmisille osoitettuun korttiin',
      autopilotUnitsTitle: 'Automaattiohjaus liiketoimintayksiköittäin',
      autopilotUnitsHint: 'Kytkee automaattiohjauksen päälle tai pois yksitellen kullekin liiketoimintayksikölle ja johtotasolle. Pidätettyyn työhön ei kosketa.',
      autopilotUnitOn: 'Autopilot päällä',
      autopilotUnitOff: 'Autopilot pois',
      limitsBuilds: 'Kuvakoonnit kollegaa ja päivää kohden',
      limitsDesigns: 'Agenttisuunnitelmat kollegaa ja päivää kohden',
      limitsSave: 'Aseta päivärajat',
      limitsNone: '0 = ei rajaa',
      confirmAutopilotOn: 'Kytketäänkö autopilotti päälle? Veridion Coren oma päätöksentekijä vastaa silloin heti jokaiseen avoimeen ja uuteen korttiin tilassa pAIoneer-humans-and-bots, näkyvästi kortin ketjussa.',
      confirmAutopilotOff: 'Kytketäänkö autopilotti pois? Sen jälkeen ihmiset päättävät taas.',
      model: 'Malli',
      codingModel: 'Koodausmalli',
      modelsTitle: 'Mallit rooleittain',
      modelsSubtitle: 'Millä mallilla kukin Veridion Coren rooli ajattelee: yrityksen kasvot ja ohjaus, puhelin, arkkitehti ja vaatimusten tuomari. Valittavissa ovat vain mallit, jotka yhdyskäytävä reitittää; tyhjä tarkoittaa konfiguraation oletusta.',
      roleCoordinator: 'Koordinaattori (kasvot ja ohjaus)',
      roleCall: 'Puhelin',
      roleArchitect: 'Arkkitehti',
      roleRequirementsJudge: 'Vaatimusten tuomari',
      roleJudge: 'Coren arviot',
      roleEar: 'Puhelimen korva',
      roleStt: 'Webex-korva',
      modelGroupVllm: 'vLLM (oma kortti)',
      modelGroupAudio: 'Ääni (oma kortti / pilvi)',
      modelGroupCloud: 'OpenRouter (pilvi)',
      directLlmTitle: 'Suora LLM-yhteys',
      directLlmSubtitle: 'Puhu suoraan vLLM:n tai pilvimallin kanssa, ilman botteja, agentteja tai Webexiä',
      directLlmHint: 'Ylläpitäjän suora yhteys: valittu malli vastaa raakana, kirjataan nimellä “console”, ilman laneja, rooleja tai työkaluja.',
      directLlmModel: 'Malli',
      directLlmSystem: 'Järjestelmäkehote (valinnainen)',
      directLlmSystemPlaceholder: 'esim. Olet …',
      directLlmPrompt: 'Viesti',
      directLlmPromptPlaceholder: 'Mitä haluat kysyä mallilta suoraan?',
      directLlmSend: 'Lähetä',
      directLlmSending: 'Lähettää …',
      directLlmUsage: '{prompt}+{completion} tokenia · {cost}',
      modelCurrent: 'Käytössä',
      modelDefault: 'Oletus',
      modelChosen: 'Valittu',
      modelDefaultOption: 'konfiguraation oletus',
      modelNotRouted: 'yhdyskäytävä ei reititä',
      modelSave: 'Tallenna',
      engineSilver: 'Yrityksen moottori (hopea)',
      engineGold: 'Yrityksen moottori (kulta, orkestroijan)',
      callsTitle: 'Puhelut',
      callsSubtitle: 'Jokainen puhelimen puhuttu vuoro, kirjattu erillään kollegoiden työstä: tokenit, kustannus sekä korvan, mielen ja äänen viemä aika, kollegoittain ja malleittain, viimeiseltä 30 päivältä ja tältä päivältä; alla uusimmat vuorot.',
      callsTurns: 'Vuorot',
      callsCalls: 'Puhelut',
      callsAvgTotal: 'Ø yhteensä ms',
      callsAvgAsr: 'Ø korva ms',
      callsAvgLlm: 'Ø mieli ms',
      callsAvgTts: 'Ø ääni ms',
      callsDeferred: 'Lykätty',
      callsToday: 'Tänään',
      callsWindow: 'Viimeiset 30 päivää',
      callsRecent: 'Uusimmat vuorot',
      callsPerson: 'Henkilö',
      callsRounds: 'Kierrokset',
      callsNone: 'Yhtään puhelua ei ole vielä kirjattu.',
      unitKindExecutive: 'Johtotaso',
      unitKindBusinessUnit: 'Liiketoimintayksikkö',
      orgSynced: 'Johtotaso ja liiketoimintayksiköt on määritelty Veridion Coren organisaatiossa ja synkronoitu tänne; niitä muutetaan siellä, ei tällä sivulla.',
      memory: 'Muisti',
      ready: 'valmis',
      notReady: 'ei valmis',
      factExtraction: 'faktojen poiminta päällä',
      cluster: 'Klusterin käyttöoikeus',
      agentsRunning: 'Käynnissä olevat agentit',
      agentsWaiting: 'odottaa',
      definitions: 'Määritelmät',
      gatewayIdentity: 'Gatewayn identiteetti',
      gatewayTokens: 'Gatewayn tokenit aikaikkunassa',
      hostedTitle: 'Isännöidyt agentit',
      hostedSubtitle: 'Tekoälysovellukset, jotka Veridion Core käynnistää ja joita se ylläpitää omissa konteissaan.',
      agent: 'Agentti',
      actions: 'Toiminnot',
      confirmHosted: '{action}: {agent}?',
      hostedActions: {
        start: 'käynnistä',
        stop: 'pysäytä',
        restart: 'käynnistä uudelleen',
      },
      open: 'avaa',
      agentsTitle: 'Agentit',
      agentsSubtitle: 'Jokainen agentti ja aliagentti toimii omassa kontissaan. Avaa agentti lähettääksesi sille viestin tai ohjataksesi sitä.',
      showFinished: 'Näytä päättyneet agentit',
      noAgents: 'Ei agentteja.',
      definitionsTitle: 'Määritelmät',
      definitionsSubtitle: 'Hyväksytyt agenttigraafit versioineen.',
      designsTitle: 'Agenttiluonnokset',
      designsSubtitle: 'Jokainen arkkitehdin suunnittelema agentti, henkilölle tai tekoälykollegan työhön: mihin ja miksi, jokainen kysymys vastauksineen, testiajot skenaarioita vastaan, hyväksyntä ja ajot.',
      design: 'Luonnos',
      designFor: 'Kenelle',
      designWork: 'Työ',
      designState: 'Tila',
      designApprovedBy: 'Hyväksyjä',
      designAgent: 'Rakennettu agentti',
      filterState: 'Tila',
      filterAll: 'Kaikki',
      filterOpen: 'Avoimet',
      filterDone: 'Valmiit',
      filterFailed: 'Epäonnistuneet',
      filterCurrent: 'Aktiiviset ja äskettäin epäonnistuneet',
      filterActive: 'Aktiiviset',
      filterFinished: 'Päättyneet',
      filterPosition: 'Tekoälykollega',
      pagePrev: 'Edellinen',
      pageNext: 'Seuraava',
      pageLabel: 'Sivu',
      searchLabel: 'Hae',
      showMore: 'Näytä lisää',
      noDesigns: 'Agenttia ei ole vielä suunniteltu.',
      designReason: 'Miksi työkalut eivät riittäneet',
      designRecord: 'Kulku',
      designAgents: 'Luonnoksen agentit',
      designTestRun: 'Testiajo',
      designRun: 'Ajo',
      designStatus: { designing: 'suunnitteilla', testing: 'testissä', asking: 'odottaa vastausta', approval: 'odottaa hyväksyntää', running: 'käynnissä', done: 'valmis', failed: 'epäonnistui', cancelled: 'peruttu' },
      builtBy: 'Rakentaja',
      builtFor: 'Työhön',
      viaCodingTask: 'koodausagentin kautta',
      designTests: 'Testiajot',
      designRuns: 'Ajot',
      designByPerson: 'henkilö keskustelussa',
      diagramsTitle: 'Kaaviot',
      diagramsSubtitle: 'Kulkujen, arkkitehtuurien ja suunnitelmien kuvat, jotka tekoälykollegat, agentit ja koodausagentti piirsivät, otsikon, selitteen ja Mermaid-koodin kanssa.',
      noDiagrams: 'Ei vielä kaaviota.',
      diagramAuthor: 'Tekijä',
      diagramBasedOn: 'Laajentaa',
      diagramCode: 'Mermaid-koodi',
      architectTitle: 'Arkkitehti',
      architectSubtitle: 'Suunnittele agentti keskustelemalla. Arkkitehti kysyy sen, mitä se ei voi itse ratkaista, ja luo agentin vasta hyväksyntäsi jälkeen.',
      orgTitle: 'Organisaatio',
      orgSubtitle: 'Osastot, tiimit ja projektit jäsenineen; yrityksen muisti jaetaan tämän rakenteen mukaisesti.',
      usageTitle: 'Käyttö agenteittain',
      usageSubtitle: 'Mallikutsut, tokenit ja raportoidut kustannukset viimeisten 30 päivän ajalta.',
      calls: 'Kutsut',
      source: 'Lähde',
      gpuTokens: 'Tokenit näytönohjaimella',
      cloudTokens: 'Tokenit pilvessä',
      usageByModel: 'Kollegan ja mallin mukaan',
      cost: 'Kustannukset',
    },
    memory: {
      archOverviewTitle: "Arkkitehtuurikatsaus: miten yritysmuisti on rakennettu",
      archOverviewText: "Veridion Core tallettaa yrityksen tiedon kolmeen kerrokseen: Neo4j ajallisena tietograafina faktoille, päätöksille ja työpaketeille, PostgreSQL agenttien, postilaatikoiden ja sprinttien transaktionaalisille tiloille sekä Qdrant vektorihakuun yrityksen dokumenteista. Jokainen liiketoimintayksikkö työskentelee eristetyssä tietoalueessa; yksiköiden väliset tulokset kulkevat kirjattujen luovutusten kautta.",
      clustersTitle: "Liiketoimintayksiköiden tietoalueet",
      clustersSubtitle: "Jokainen liiketoimintayksikkö työskentelee rajatussa Neo4j-tietoalueessa; solmu- ja kaarimäärät tulevat suorana Neo4j:stä, kuvaukset merkitystä alkutäytöstä. Klikkaus avaa alueen tietograafissa.",
      clusterCode: "Tunnus",
      clusterName: "Tietoalue",
      clusterId: "Tunniste",
      clusterRoles: "Roolit",
      clusterBridges: "Luovutussillat",
      clusterPolicy: "Aihepiiri ja eristyssääntö",
      clusterCounts: "Solmut / kaaret (suorana)",
      clusterInsights: "Havainnot (alkutäyttö)",
      clusterOpenButton: "Avaa tietograafissa",
      countsUnavailable: "Neo4j ei tavoitettavissa — ei laskentaa",
      researchTitle: "Kvantti- ja frontier-tekoälyn tutkimusarkisto",
      researchSubtitle: "Tieteelliset avainjulkaisut ja arkkitehtuuriviitteet — suoria rivejä Veridion Coresta; jokaisen rivin alkuperä näkyy.",
      researchEmpty: "Arkistossa ei ole vielä julkaisuja.",
      researchIngestNote: "Uudet julkaisut lisää kvanttikollega työkalullaan; kojelauta vain lukee arkistoa.",
      researchPublication: "Julkaisu",
      researchMechanism: "Avainmekanismi",
      researchRelevance: "Merkitys arkkitehtuurille",
      researchOrigin: "Alkuperä",
      researchSeeded: "alkutäyttö",
      researchMotivates: "Perustelee version",
      title: 'Yrityksen muisti',
      subtitle: 'Mitä Veridion Core säilyttää Neo4j:ssä: muistot alueittain, faktat voimassaoloaikoineen ja auditointiloki agenttien toimista.',
      failed: 'Se ei onnistunut',
      loading: 'Ladataan …',
      unavailable: 'Muisti ei ole tavoitettavissa',
      database: 'Tietokanta',
      ready: 'valmis',
      notReady: 'ei valmis',
      factExtraction: 'Faktojen poiminta',
      episodesQueued: 'Odottavat jaksot',
      lastError: 'Viimeisin virhe',
      contentTitle: 'Sisältö',
      contentSubtitle: 'Solmut nimiöittäin ja muistot alueittain ja lajeittain.',
      label: 'Nimiö',
      count: 'Määrä',
      empty: 'Ei vielä mitään.',
      scope: 'Alue',
      kind: 'Laji',
      kinds: {
        fact: 'fakta',
        decision: 'päätös',
        task: 'tehtävä',
        procedure: 'menettely',
        note: 'muistiinpano',
        episode: 'jakso',
      },
      searchTitle: 'Haku',
      searchSubtitle: 'Agenttien käyttämä haku: merkitys, sanat ja poimitut faktat.',
      searchPlaceholder: 'Hakusana tai kysymys',
      allScopes: 'kaikki alueet',
      search: 'Hae',
      noResults: 'Mitään ei löytynyt.',
      text: 'Teksti',
      validFrom: 'Voimassa alkaen',
      source: 'Lähde',
      extracted: 'poimittu',
      recorded: 'kirjattu',
      rememberTitle: 'Tallenna muistiin',
      rememberSubtitle: 'Tallenna fakta, päätös, tehtävä, menettely tai muistiinpano alueelle.',
      remembered: 'Tallennettu.',
      remember: 'Tallenna',
      created: 'Luotu',
      validity: 'Voimassaolo',
      invalid: 'ei voimassa',
      confirmInvalidate: 'Merkitäänkö tämä muisto enää voimassa olemattomaksi?',
      invalidate: 'merkitse ei voimassa olevaksi',
      forget: 'unohda',
      confirmForget: 'Unohdetaanko tämä merkintä pysyvästi? Se poistetaan muistista eikä sitä voi palauttaa.',
      forgotten: 'Unohdettu.',
      factsTitle: 'Faktat ajan mittaan',
      factsSubtitle: 'Keskusteluista ja agenttien tuloksista poimitut faktat; kumotulle faktalle merkitään päättymispäivä.',
      noFacts: 'Faktoja ei ole vielä poimittu.',
      briefsTitle: 'Tekoälykollegojen tilannekuvat',
      briefsSubtitle: 'Mitä kukin tekoälykollega lukee ensin: avoimet sitoumukset, voimassa olevat päätökset, käynnissä olevat asiat ja asiakkaat, kirjoitettu joka yö muistista.',
      brief: 'Tilannekuva',
      updated: 'Päivitetty',
      noBriefs: 'Tilannekuvia ei ole vielä kirjoitettu.',
      fact: 'Fakta',
      from: 'Mistä',
      to: 'Mihin',
      validUntil: 'Voimassa asti',
      stillValid: 'edelleen voimassa',
      entityTitle: 'Lähiympäristö',
      entitySubtitle: 'Mihin tehtävä, projekti, henkilö, järjestelmä tai entiteetti on yhdistetty.',
      entityPlaceholder: 'Nimi, tehtävän tunniste, sähköpostiosoite tai tunniste',
      show: 'Näytä',
      auditTitle: 'Auditointi',
      auditSubtitle: 'Agenttien malli- ja työkalukutsut, viestit ja käynnistetyt aliagentit.',
      auditPlaceholder: 'Agentin tunniste (tyhjä: kaikki)',
      filter: 'Suodata',
      time: 'Aika',
      agent: 'Agentti',
      event: 'Tapahtuma',
      toolOrModel: 'Työkalu tai malli',
      status: 'Tila',
      detail: 'Lisätieto',
      consoleTitle: 'Kyselykonsoli',
      consoleSubtitle: 'Vain lukeva Cypher; kirjoittavat lauseet hylätään.',
      run: 'Suorita',
      truncated: 'lisärivejä katkaistiin',
      graph: {
        clusterPickTitle: "Kohdista tietoalue graafissa",
        clusterPickHint: "Klikkaus liiketoimintayksikköön kohdistaa sen aligraafin rooleineen ja luovutussiltoineen vuorovaikutteisessa graafissa.",
        allClusters: "Kaikki alueet (koko graafi)",
        activeCluster: "Aktiivinen tietoalue",
        publicationsTitle: "Tutkimusarkiston julkaisut",
        storesTitle: 'Yritysmuistin tietovarastot',
        storesSubtitle: 'Mitä kukin yrityksen muistin tietovarasto sisältää, luettuna suoraan: graafi Neo4j:ssä, Veridion Coren tila Postgresissa, tietämyskannan vektorit Qdrantissa.',
        storeNeo4j: 'Neo4j (graafi)',
        storeNeo4jHolds: 'Yrityksen muisti: muistot alueineen, Graphitin poimimat entiteetit ja faktat voimassaoloaikoineen, työkohteet merkityksineen, ohjelmistotyö ja agenttien auditointi.',
        storePostgres: 'Postgres (relaatio)',
        storePostgresHolds: 'Veridion Coren transaktionaalinen tila: agenttien prosessitaulu, postilaatikot, keskustelut, tarkistuspisteet, koodaustehtävät, hyväksynnät, organisaatio ja kulutus.',
        storeQdrant: 'Qdrant (vektorit)',
        storeQdrantHolds: 'Yrityksen tietämyskanta: ylläpitäjän lisäämien dokumenttien upotetut kappaleet, joista orkestroija hakee, kun keskusteluvuoro tarvitsee tietämyskantaa.',
        nodes: 'solmua',
        relationships: 'suhdetta',
        relationshipType: 'Suhdetyyppi',
        tables: 'taulua',
        table: 'Taulu',
        rows: 'riviä',
        purpose: 'Mitä se sisältää',
        documents: 'dokumenttia',
        session: 'Istunto',
        collection: 'Kokoelma',
        role: 'Rooli',
        roleDocuments: 'dokumentit',
        roleCurated: 'kuratoidut kysymys-vastaus-parit',
        title: 'Graafi',
        subtitle: 'Yritysmuistin graafi Neo4j:ssä: aloita hakuosumasta, uusimmista muistoista tai työkohteista; napsauta solmua lukeaksesi sen, laajenna sen naapurit, järjestä vetämällä, zoomaa vierittämällä.',
        startNewest: 'Uusimmat muistot',
        startWork: 'Työkohteet',
        searchPlaceholder: 'Graafista etsittävä nimi, teksti tai tunniste',
        find: 'Hae',
        noHits: 'Ei tuloksia.',
        name: 'Nimi',
        sources: { memory: 'muisto', entity: 'poimittu entiteetti', node: 'projektimuisti', episode: 'episodi' },
        show: 'näytä',
        shown: '{nodes} solmua ja {edges} suhdetta graafissa',
        truncated: 'katkaistu rajalla; laajenna solmua tai hae tarkemmin',
        selected: 'Valittu solmu',
        selectHint: 'Napsauta solmua graafissa.',
        expand: 'Laajenna naapurit',
        expandTwo: 'Laajenna kaksi tasoa',
        centre: 'Keskitä tähän solmuun',
        facts: 'Tämän entiteetin faktat',
        degree: 'Suhteet',
        direction: 'Suunta',
        out: 'lähtevä',
        in: 'saapuva',
        noRelationships: 'Ei suhteita.',
        property: 'Ominaisuus',
        value: 'Arvo',
        noProperties: 'Ei ominaisuuksia.',
        factsOf: 'Faktat:',
        factsSubtitle: 'Mitä Graphiti on poiminut tästä entiteetistä, kunkin faktan voimassaoloaikoineen; kumottu fakta kantaa päättymispäivän.',
        relation: 'Suhde',
        other: 'Toinen entiteetti',
        newestTitle: 'Uusimmat muistot',
        newestSubtitle: 'Viimeksi kirjoitetut muistot aiheineen; ”näytä” piirtää yhden linkkeineen.',
        about: 'Aihe',
        workTitle: 'Työkohteet',
        workSubtitle: 'Jokainen vahvistettu työ tiloineen, omistajineen, tiketteineen ja skenaarioidensa tuloksineen; ”näytä” piirtää yhden merkityksineen, tiketteineen, koodaustehtävineen ja sille rakennettuine agentteineen.',
        allStates: 'kaikki tilat',
        states: { confirmed: 'vahvistettu', in_progress: 'työn alla', blocked: 'estetty', done: 'valmis', failed: 'epäonnistui', dropped: 'hylätty' },
        workItem: 'Työkohde',
        owner: 'Omistaja',
        issue: 'Tiketti',
        scenarios: 'Skenaariot',
        results: { passed: 'läpäisty', failed: 'epäonnistui', pending: 'avoin' },
      },
      day: {
        title: 'Yrityksen päivä',
        subtitle: 'Veridion Coren kirjaamien tapahtumien aikajana: ihmisten sanat, kortit, työ, luovutukset, tutkimukset, agentit, koodaustehtävät, projektit, häiriöt ja kokoukset, uusin ensin.',
        sinceToday: 'tänään',
        sinceDay: 'viimeiset 24 tuntia',
        sinceWeek: 'viimeiset 7 päivää',
        allKinds: 'kaikki lajit',
        refresh: 'Päivitä',
        count: '{n} tapahtumaa',
        time: 'Aika',
        actor: 'Toimija',
        happening: 'Tapahtuma',
        work: 'Työ',
        empty: 'Tällä aikavälillä ei ole kirjattu mitään.',
        kinds: { word: 'sana', request: 'pyyntö', card: 'kortti', work: 'työ', handover: 'luovutus', research: 'tutkimus', agent: 'agentti', task: 'koodaustehtävä', project: 'projekti', incident: 'häiriö', schedule: 'aikataulu', meeting: 'kokous', message: 'viesti' },
      },
    },
    title: 'Hallintapaneeli',
    adminKicker: 'Käyttötoiminta',
    smtmStatusTitle: 'SMTM-data ja ennusteet',
    smtmStatusSubtitle: 'Valvoo välittäjän aikasarjoja, julkaistuja malleja, ennustetuotosta ja RSS-syötteitä.',
    smtmStatusUnavailable: 'SMTM-tila ei ole saatavilla',
    smtmGeneratedAt: 'Luotu',
    smtmMinimumRows: 'Koulutusrivien vähimmäismäärä',
    smtmBaseFrames: 'Perusaikasarjat',
    smtmTrainableFrames: 'Raakadata valmiina',
    smtmWaitingHistory: 'Odottaa historiaa',
    smtmPredictionTrackedInstruments: 'Seuratut instrumentit',
    smtmPredictionEnabledCount: 'Ennusteet käytössä',
    smtmPredictionDisabledCount: 'Ennusteet tauolla',
    smtmMlFrames: 'ML-tietojoukot',
    smtmOnlineModels: 'Verkossa olevat mallit',
    smtmModelsWithArtifacts: 'Mallit artefakteineen',
    smtmPredictionFrames: 'Ennustesarjat',
    smtmMissingPredictions: 'Sarjat ilman ennusteita',
    smtmBlobArtifacts: 'Blob-artefaktit',
    smtmStalePredictions: 'Vanhentuneet ennusteet',
    smtmRssFrames: 'RSS-syötteet',
    smtmDataframesTotal: 'Tietojoukkoja yhteensä',
    smtmLatestModelUpload: 'Viimeisin mallin lataus',
    smtmLatestPredictionWrite: 'Viimeisin ennustekirjoitus',
    smtmRuntimeHints: 'Ajonaikaiset huomiot',
    smtmNoHints: 'Ei avoimia SMTM-huomioita.',
    smtmInstrument: 'Instrumentti',
    smtmBaseData: 'Perusdata',
    smtmMlFrame: 'ML-tietojoukko',
    smtmModelPublish: 'Mallin tila',
    smtmArtifacts: 'Artefaktit',
    smtmPredictionFrame: 'Ennustesarja',
    smtmIssues: 'Ongelmat',
    smtmNoIssues: 'Ei ongelmia',
    smtmNoFrames: 'SMTM-instrumentteja ei löytynyt.',
    smtmPredictionControlTitle: 'SMTM-ennusteiden ohjaus',
    smtmPredictionControlSubtitle: 'Päätä instrumenttikohtaisesti, laskeeko SMTM uusia koneoppimisennusteita vai kerääkö se vain perusdataa.',
    smtmPredictionSettingsUnavailable: 'SMTM-ennusteiden ohjaus ei ole saatavilla',
    smtmPredictionControlHint: 'Tauolla olevat instrumentit säilyttävät historiansa. Niille ei enää luoda uusia ML-tietojoukkoja, koulutuksia eikä ennusteita.',
    smtmPredictionMode: 'Ennustetila',
    smtmPredictionToggle: 'Ylläpitäjän ohjaus',
    smtmPredictionToggleLabel: 'Ota ennusteet käyttöön tai keskeytä ne',
    smtmPredictionEnabled: 'Ennuste käytössä',
    smtmPredictionDisabled: 'Ennuste tauolla',
    smtmPredictionSaving: 'Tallennetaan...',
    smtmPredictionSettingsSaved: 'SMTM-ennusteiden ohjaus tallennettu.',
    smtmPredictionSaveChanges: 'Tallenna muutokset',
    smtmPredictionResetChanges: 'Hylkää muutokset',
    smtmPredictionPendingChanges: 'odottavaa muutosta',
    smtmPredictionPendingBadge: 'Tallennus kesken',
    smtmOpenAzuriteUi: 'Avaa Azuriten selainkäyttöliittymä',
    azuriteTitle: 'Azuriten selainkäyttöliittymä (SMTM)',
    azuriteSubtitle: 'Vain luku -näkymä modelstatus-riveihin, blob-artefakteihin ja mallien latauksiin.',
    azuriteModelGroups: 'Malliryhmät',
    azuriteBlobArtifacts: 'Blob-artefaktit',
    azuriteFiles: 'Tiedostot',
    azuriteSearchPlaceholder: 'Suodata malleja',
    azuriteNoModels: 'Azurite-malleja ei löytynyt.',
    smtmRows: 'Rivejä',
    smtmLatest: 'Viimeisin aikaleima',
    smtmAge: 'Ikä',
    smtmValue: 'Arvo',
    smtmMinutesAgo: 'min sitten',
    smtmMinutesAhead: 'min eteenpäin',
    smtmHoursAgo: 't sitten',
    smtmDaysAgo: 'pv sitten',
    smtmStateLabels: {
      available: 'Saatavilla',
      trainable: 'Koulutettavissa',
      waiting_for_history: 'Odottaa historiaa',
      missing_base_data: 'Ei perusdataa',
      missing_machine_learning: 'ML-tietojoukko puuttuu',
      missing_prediction: 'Ennuste puuttuu',
      prediction_disabled: 'Ennuste tauolla',
      stale_prediction: 'Vanhentunut ennuste',
      open: 'Avoin',
      completed: 'Valmis',
      online: 'Verkossa',
      offline: 'Poissa verkosta',
      training: 'Koulutetaan',
      uploading: 'Ladataan',
      failed: 'Epäonnistui',
      unknown: 'Tuntematon',
      missing: 'Puuttuu'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Perusaikasarja on tyhjä',
      insufficient_history: 'Historiaa ei ole tarpeeksi',
      missing_machine_learning_frame: 'ML-tietojoukko puuttuu',
      missing_prediction_frame: 'Ennustesarja puuttuu',
      stale_prediction_frame: 'Ennustesarja on vanhentunut',
      missing_online_model: 'Ei verkossa olevaa mallia',
      model_offline: 'Malli on poissa verkosta',
      missing_model_blob: 'Mallin blob puuttuu',
      missing_model_header: 'Mallin otsake puuttuu',
      missing_modelstatus_entry: 'Modelstatus-rivi puuttuu',
      inference_not_writing_prediction: 'Päättely ei kirjoita ennusteita',
      prediction_disabled_by_admin: 'Ylläpitäjä keskeytti ennusteen'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'valmiit instrumentit ilman ennustetuotosta',
      instruments_waiting_for_history: 'instrumentit, jotka yhä odottavat historiaa',
      models_missing_artifacts: 'verkossa olevat mallit ilman täydellisiä artefakteja',
      no_online_models: 'Azuritessa ei ole verkossa olevia malleja',
      azurite_unavailable: 'Azuriten tallennustilan tila ei ole tällä hetkellä saatavilla'
    },
    mailTitle: 'Sähköpostiasetukset',
    usersTitle: 'Käyttäjähallinta',
    usersSubtitle: 'Tilit, roolit, tila ja 2FA Keycloakista. Tilin valinta avaa juuri sen tilin hallinnan.',
    usersHideCreate: 'Sulje lomake',
    usersCreateHint: 'Uusi tili alkaa pakollisella 2FA:lla ja aktivoituu heti kun se on määritetty.',
    usersFilterAllStatus: 'Kaikki tilat',
    usersFilterAllRoles: 'Kaikki roolit',
    usersManage: 'Hallitse',
    usersClose: 'Sulje',
    usersNoneFound: 'Käyttäjiä ei löytynyt.',
    usersPagePrev: 'Edellinen',
    usersPageNext: 'Seuraava',
    auditTitle: 'Auditointiloki',
    smtpHost: 'SMTP-palvelin',
    smtpPort: 'SMTP-portti',
    smtpSecurity: 'SMTP-suojaus',
    smtpUsername: 'SMTP-käyttäjä',
    smtpPassword: 'SMTP-salasana',
    fromEmail: 'Lähettäjän osoite',
    fromName: 'Lähettäjän nimi',
    replyToEmail: 'Vastausosoite',
    saveMailSettings: 'Tallenna sähköpostiasetukset',
    sendTestMail: 'Lähetä testiviesti',
    createUser: 'Luo käyttäjä',
    setPassword: 'Aseta salasana',
    setRoles: 'Aseta roolit',
    setStatus: 'Aseta tila',
    resetMfa: 'Nollaa 2FA',
    revokeSessions: 'Mitätöi istunnot',
    filterUsers: 'Suodata käyttäjiä',
    testRecipient: 'Testiviestin vastaanottaja',
    statusConfigured: 'Määritetty',
    statusMissing: 'Ei määritetty',
    userEmail: 'Sähköposti',
    userName: 'Käyttäjätunnus',
    userRoles: 'Roolit',
    userStatus: 'Tila',
    auditEvent: 'Tapahtuma',
    auditCreatedAt: 'Luotu',
    auditDetails: 'Tiedot',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Päätepiste',
    aiGatewayIdentitySource: 'Identiteetti tokenin claimista',
    aiGatewayBudgetSource: 'Alkuarvot tiedostossa',
    aiGatewayModels: 'Reititetyt mallit',
    aiGatewayModel: 'Malli',
    aiGatewayBackend: 'Taustapalvelu',
    aiGatewayBudgets: 'Token-budjetit',
    aiGatewayIdentity: 'Identiteetti',
    aiGatewayTokenBudget: 'Token-budjetti',
    aiGatewayWindow: 'Ikkuna',
    aiGatewayAnyIdentity: 'mikä tahansa identiteetti',
    aiGatewayAnyModel: 'mikä tahansa malli',
    aiUsageWindowStarted: 'Ikkuna alkaen',
    aiUsageRemaining: 'Jäljellä',
    aiUsageIdentities: 'Identiteetit',
    aiGatewaySubtitle: 'Envoy AI Gateway on ainoa tie malliin: reititetyt mallit, niiden taustapalvelut ja kunkin identiteetin token-budjetti.',
    aiGatewayHint: 'Budjetteja ohjataan täältä. Käyttöönottokerros vain asettaa alkuarvot uudelle klusterille.',
    aiUsageTitle: 'Tekoälyn käyttö identiteeteittäin',
    aiUsageSubtitle: 'Yhdyskäytävän kirjaamat tokenit kuluvassa ikkunassa.',
    sessionActiveUsers: 'Kirjautuneet käyttäjät',
    sessionActiveSessions: 'Aktiiviset istunnot',
    sessionMfaSessions: 'Vahvistetut istunnot',
    aiUsageTotalTokens: 'Tokeneita yhteensä',
    aiServicesTitle: 'Palveluyhteydet',
    aiServicesSubtitle: 'Linkit alustan API- ja hallintanäkymiin; jokainen kohde tarkistaa admin-roolin itse.',
    aiMailSubtitle: 'SMTP-asetukset, joilla Keycloak lähettää vahvistus- ja palautusviestit, sekä testilähetys.',
    tabOverview: 'Yleiskatsaus',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'Sähköpostin lähetys',
    tabUsers: 'Käyttäjät',
    tabAudit: 'Tarkastusloki',
    tabServiceLinks: 'Palveluyhteydet',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Alusta',
    platformTitle: 'Alustan tila',
    platformSubtitle: 'Jokainen pAIoneer Labs GmbH-työkuorma valmiine replikoineen, uudelleenkäynnistyksineen ja levykuvineen suoraan Kubernetesista.',
    platformHostPage: 'Hallitse instansseja sovellusisännässä',
    openVisitorMonitoring: 'Avaa kävijä-, markkinointi- ja SEO-seuranta',
    platformUnavailable: 'Alustan tila ei ole saatavilla',
    platformWorkloadsTotal: 'Työkuormat',
    platformDegradedTotal: 'Ei valmiina',
    platformRestartsTotal: 'Uudelleenkäynnistykset',
    platformWorkload: 'Työkuorma',
    platformNamespace: 'Nimiavaruus',
    platformReplicas: 'Replikat',
    platformRestarts: 'Uudelleenkäynnistykset',
    platformImage: 'Levykuva',
    platformState: 'Tila',
    platformStateReady: 'Valmis',
    platformStateDegraded: 'Heikentynyt',
    platformStateDown: 'Alhaalla',
    platformStateUnknown: 'Tuntematon',
    platformNodes: 'Solmut',
    platformOsImage: 'Käyttöjärjestelmä',
    platformKernel: 'Ydin',
    platformRuntime: 'Konttien ajoympäristö',
    platformKubelet: 'Kubelet',
    platformUsed: 'Käytössä nyt',
    platformReportedCapacity: 'Kubernetesin ilmoittama',
    platformConfiguredCap: 'Määritetty konttiraja',
    platformPressure: 'Kuormitusehdot',
    platformPressureNone: 'ei mitään',
    platformCpu: 'Suoritinytimet',
    platformNoWorkloads: 'Tämä nimiavaruus sisältää konfiguraatio-objekteja, ei työkuormia.',
    platformMemory: 'Muisti',
    platformEvents: 'Viimeisimmät varoitukset',
    platformEventsNone: 'Ei varoituksia.',
    platformEventObject: 'Kohde',
    platformEventReason: 'Syy',
    platformEventMessage: 'Viesti',
    platformEventLastSeen: 'Viimeksi nähty',
    platformMetricsMissing: 'Kulutustietoja ei ole: metrics-server ei vastaa.',
    aiGatewayBackends: 'Palvelevat taustapalvelut',
    gpuTitle: 'Näytönohjain',
    gpuNote: 'Näytönohjaimen moottorien kuormitus, niistä otetut tokenit identiteettiä ja Webex-bottia kohden sekä token-budjetit identiteettiä ja moottoria kohden.',
    gpuTokensWindow: 'Tokenit näytönohjaimella ikkunassa',
    gpuSinceStart: 'moottorin käynnistyksestä',
    gpuIdentities: 'Identiteettiä kohden, käynnissä oleva ikkuna',
    gpuBots: 'Webex-bottia ja agenttia kohden, 30 päivää',
    gpuBot: 'Webex-botti / agentti',
    gpuBudgetTitle: 'Budjetti identiteettiä kohden moottorille',
    gpuBudgetSet: 'Aseta budjetti',
    gpuBudgetHint: 'Tokeneita tunnissa moottorilla; yhdyskäytävä valvoo sitä. Se rajaa myös identiteettiä, jolla ei ole rajaa.',
    gpuNoneYet: 'Ei vielä kirjauksia.',
    gpuEngines: 'Moottorit',
    gpuEngine: 'Moottori',
    gpuEngineGold: 'Kulta-moottori',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Agentic RAG -sovelluksen ajoympäristö, tietopohja, koulutuksen valmistelu ja jäljitettävyys.',
    agenticRagBackendStatus: 'Taustajärjestelmän tila',
    agenticRagRuntimeMode: 'Ajotila',
    agenticRagKnowledgeMode: 'Tietotila',
    agenticRagDeploymentEnv: 'Käyttöönottoympäristö',
    agenticRagVectorStores: 'Vektorivarastot',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Dokumenttikokoelma',
    agenticRagQdrantCuratedCollection: 'Kuratoitujen kysymys-vastaus-parien kokoelma',
    agenticRagQdrantDashboard: 'Hallintanäkymä',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Avaa Swagger',
    agenticRagOpenPhoenix: 'Avaa Phoenix',
    agenticRagOpenQdrant: 'Avaa Qdrant',
    agenticRagKnowledgeTitle: 'Tietopohja',
    agenticRagKnowledgeSubtitle: 'Agentic RAG -sovelluksen dokumenttien ja kuratoitujen kysymys-vastaus-parien tila.',
    agenticRagDocuments: 'Dokumentit',
    agenticRagCuratedQaPairs: 'Kuratoidut kysymys-vastaus-parit',
    agenticRagTrainingTitle: 'Koulutuksen valmistelu',
    agenticRagTrainingSubtitle: 'Viimeisin generaattorin ajo ja kouluttajan viimeisin tila.',
    agenticRagLatestDataset: 'Viimeisin aineisto',
    agenticRagDatasetPairs: 'Kysymys-vastaus-parit',
    agenticRagDatasetDocuments: 'Käsitellyt dokumentit',
    agenticRagDatasetModifiedAt: 'Viimeksi muokattu',
    agenticRagLatestTrainerInput: 'Viimeisin kouluttajan syöte',
    agenticRagTrainerInputModifiedAt: 'Syöte muokattu',
    agenticRagLatestTrainerRun: 'Viimeisin kouluttajan ajo',
    agenticRagTrainerRunModifiedAt: 'Ajon yhteenveto muokattu',
    gpuEngineSilver: 'Hopea-moottori',
    gpuAssignment: 'Jako',
    gpuWho: 'Kuka',
    gpuRank: 'Sija',
    gpuRankHint: 'Sija 0 palvellaan ensin; kukin moottori palvelee sijan mukaan.',
    gpuLanes: 'Veridion Coren käynnissä olevat kutsut moottoria ja sijaa kohden',
    gpuInFlight: 'käynnissä',
    gpuWhoMainBotPeople: 'Pääbotti: keskustelut ihmisten kanssa',
    gpuWhoMainBotJudgements: 'Pääbotti: arviot samassa vuorossa',
    gpuWhoAutopilot: 'Autopilotti',
    gpuWhoAgents: 'Agentit, joita pääbotti ajaa',
    gpuWhoArchitect: 'Arkkitehti',
    gpuWhoChair: 'Kokouksen puheenjohtaja',
    gpuWhoOrchestrator: 'Yritysinstanssin orkestroija',
    gpuWhoColleagues: 'Tekoälykollegat: vuorot ja niiden arviot',
    gpuWhoMeetingWords: 'Tekoälykollegat: kokouspuheenvuorot',
    gpuWhoBackgroundReading: 'Taustapalvelu: bottien viestien lukeminen',
    gpuWhoMemory: 'Yrityksen muisti: hyväksyntä ja katsaukset',
    gpuWhoCoding: 'Koodaustehtävät: arviot ja oppiminen',
    gpuWhoResearch: 'Verkko- ja OSINT-tutkimus',
    gpuWhoKnowledgeBase: 'Yrityksen tietopankki: skannattujen sivujen lukeminen',
    gpuWhoPipeline: 'Pipelinen tarkistus IDD:tä vasten',
    gpuWhoSmtm: 'Veridion SMTM: SaaS-keskustelu ja tietopankki, viimeinen sija',
    gpuUnavailable: 'Näytönohjain ei vastaa',
    aiGatewaySource: 'Lähde',
    aiSourceGpu: 'Näytönohjain',
    aiGatewayMeter: 'Mittari',
    aiGatewayMeterIdentity: 'Jokainen identiteetti, laskettu',
    aiGatewayEngines: 'Moottorit näytönohjaimella',
    aiGatewayEnginesHint: 'Kunkin moottorin reaaliaikaiset luvut sen metriikoista: käynnissä ja jonossa olevat pyynnöt, välimuistin täyttöaste ja käynnistyksestä lähtien palvellut tokenit.',
    aiEngineRunning: 'Käynnissä',
    aiEngineWaiting: 'Jonossa',
    aiEngineCache: 'Välimuisti käytössä',
    aiEngineServed: 'Palvellut tokenit',
    aiEngineIdle: 'Ei pyyntöjä',
    aiEngineUnavailable: 'Moottori ei vastaa',
    aiGatewayServing: 'Valmis',
    aiBudgetControlTitle: 'Hallitse token-budjetteja',
    aiBudgetControlSubtitle: 'Oletusbudjetti koskee jokaista identiteettiä. Yksittäinen identiteetti voi saada oman kattonsa.',
    aiBudgetDefault: 'Oletusbudjetti',
    aiBudgetIdentity: 'Identiteetti',
    aiBudgetTokens: 'Tokenit',
    aiBudgetApply: 'Ota käyttöön',
    aiBudgetAdd: 'Aseta katto',
    aiBudgetRemove: 'Poista',
    aiBudgetSaved: 'Token-budjetti otettu käyttöön.',
    aiBudgetIdentityPlaceholder: 'Asiakastunnus, esim. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Ei rajaa',
    aiBudgetSetUnlimited: 'Poista raja',
    aiBudgetRestoreLimit: 'Palauta raja',
    aiUsageReset: 'Tyhjennä ikkuna',
    aiUsageResetDone: 'Kuluva ikkuna tyhjennetty.',
    userMfa: '2FA',
    userMfaOn: 'Määritetty',
    userMfaOff: 'Puuttuu',
    userCreatedAt: 'Luotu',
    mailSource: 'Hallitaan kohteessa',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: 'Kaupankäyntiavustajan keskusteluydin: ajoympäristö, työkalurekisteri, MCP-palvelimet ja toiminta.',
    veridionOpenPage: 'Avaa Veridion',
    veridionOpenDocs: 'Avaa Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Työkalut',
    veridionToolsTitle: 'Työkalurekisteri',
    veridionToolsSubtitle: 'Näyttää ladatut työkaluperheet ja niiden todellisen tilan.',
    veridionToolName: 'Työkalu',
    veridionToolRuntime: 'Ajoympäristö',
    veridionToolRisk: 'Riski',
    veridionToolEnabled: 'Käytössä',
    veridionNoTools: 'Veridion -työkaluja ei ole ladattu.',
    veridionRuntimeProfiles: 'Ajoympäristöprofiilit',
    veridionRegistryReloaded: 'Rekisteri ladattu uudelleen',
    veridionProvider: 'Tekoälypolku',
    veridionMcpTitle: 'MCP-palvelimet',
    veridionMcpSubtitle: 'Liitetyt ulkoiset työkalupalvelimet tiloineen ja työkalumäärineen.',
    veridionMcpServer: 'Palvelin',
    veridionMcpState: 'Tila',
    veridionMcpTools: 'Työkalut',
    veridionMcpLastSuccess: 'Viimeksi tavoitettu',
    veridionMcpConnected: 'yhdistetty',
    veridionMcpUnreachable: 'ei tavoitettavissa',
    veridionMcpDisabled: 'pois käytöstä',
    veridionMcpEmpty: 'MCP-palvelimia ei ole määritetty.',
    veridionActivityTitle: 'Tapahtumavirta',
    veridionActivitySubtitle: 'Orkestroijan ja sen työkalujen jäsennellyt ajonaikaiset tapahtumat.',
    veridionActivityEmpty: 'Toimintaa ei ole vielä kirjattu.',
    veridionActivitySource: 'Lähde',
    veridionActivitySurface: 'Pinta',
    veridionActivityEvent: 'Tapahtuma',
    veridionActivityTool: 'Työkalu',
    veridionActivityStatus: 'Tila',
    veridionActivitySummary: 'Yhteenveto',
    veridionUnavailable: 'Veridion ei ole tällä hetkellä saatavilla.',
    veridionNotConfigured: 'Veridion:ää ei ole vielä määritetty kokonaan Homepage-ajoympäristöön.',
    veridionRequestFailed: 'Veridion ei suorittanut pyydettyä ylläpitokutsua onnistuneesti.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'pAIoneer Labs GmbH:n Veridion-instanssi henkilöstölle Webexissä, YouTrackin ja oman tietopankin kanssa; sen mallikutsut kulkevat Envoy AI Gatewayn kautta.',
    companyWorkloads: 'Työkuormat',
    companyTokensWindow: 'Tokenit käynnissä olevassa ikkunassa',
    companyBudget: 'Budjetti',
    companyBudgetDefault: 'oletusbudjetti',
    companyCost30: 'Viimeisten 30 päivän kustannukset',
    openrouterTitle: 'OpenRouterin laskuttama',
    openrouterRemaining: 'Jäljellä oleva saldo',
    openrouterOf: '/',
    openrouterToday: 'Tänään',
    openrouterWeek: 'Tällä viikolla',
    openrouterMonth: 'Tässä kuussa',
    openrouterUnavailable: 'OpenRouteria ei voi lukea juuri nyt',
    openrouterNote: 'OpenRouterin laskutus alustan avaimelle, Yhdysvaltain dollareina; päivä ja viikko UTC-ajassa. Alla kirjatut arvot laskevat vain vastaukset, jotka ilmoittavat kustannuksensa, joten ne ovat pienempiä.',
    companyRequests30: 'Mallikutsut viimeisten 30 päivän ajalta',
    companyCostNote: 'Kustannukset Yhdysvaltain dollareina OpenRouterin pyyntökohtaisen ilmoituksen mukaan; Envoy AI Gateway kirjaa tokenit identiteetille {identity}.',
    companyCostNotReported: 'ei ilmoitettu',
    companyPartUnavailable: 'ei tavoitettavissa',
    companyWebexTitle: 'Webex-botti',
    companyWebexSubtitle: 'Webex kutsuu osoitetta webex.paioneer-labs.eu/hook; silta tarkistaa allekirjoituksen ja lähettäjän ja välittää Veridionille vain sallitut viestit.',
    companyWebexBot: 'Botti',
    companyWebexWebhook: 'Webhook',
    companyWebexRegistered: 'rekisteröity',
    companyWebexNotRegistered: 'ei rekisteröity',
    companyWebexAccess: 'Sallitut',
    companyWebexAnswered: 'Vastatut',
    companyWebexRejected: 'Hylätyt',
    companyWebexFailed: 'Epäonnistuneet',
    companyWebexRecent: 'Viimeisimmät toimitukset',
    companyWebexTime: 'Aika',
    companyWebexOutcome: 'Tulos',
    companyWebexReason: 'Syy',
    companyWebexSender: 'Lähettäjä',
    companyWebexEmpty: 'Ei toimituksia viimeisen käynnistyksen jälkeen.',
    companyWebexNotConfigured: 'Webex-silta ei ole tavoitettavissa tai sen tilan avain puuttuu hallinta-API:sta.',
    companyUsageTitle: 'Käyttö henkilöittäin',
    companyUsageSubtitle: 'Instanssin käyttökirjanpidon mallikutsut, tokenit ja kustannukset viimeisten 30 päivän ajalta.',
    companyUsagePerson: 'Henkilö',
    companyUsageCalls: 'Kutsut',
    companyUsageTokens: 'Tokenit',
    companyUsageCost: 'Kustannus (USD)',
    companyUsageEmpty: 'Ei mallikutsuja viimeisten 30 päivän aikana.',
    companyWebexSendTitle: 'Kirjoita bottina',
    companyWebexSendPerson: 'Henkilölle',
    companyWebexSendRoom: 'Botin tilaan',
    companyWebexSendEmail: 'Sähköpostiosoite Webexissä',
    companyWebexSendText: 'Viesti (Markdown)',
    companyWebexSendButton: 'Lähetä',
    companyWebexSendDone: 'Lähetetty.',
    companyWebexSendFailed: 'Epäonnistui',
    companyWebexRooms: 'Botin tilat',
    companyWebexRoomGroup: 'ryhmä',
    companyWebexRoomDirect: 'suora',
    companyWebexRoomsEmpty: 'Botti ei ole vielä yhdessäkään tilassa.',
    companyKnowledgeTitle: 'Tietopankki',
    companyKnowledgeSubtitle: 'Yritysinstanssin tietopankin asiakirjat (Agentic RAG); orkestroija hakee niistä, kun keskusteluvuoro niitä tarvitsee. Phoenix kirjaa jokaisen haun.',
    companyKnowledgeDocument: 'Asiakirja',
    companyKnowledgeSize: 'Koko',
    companyKnowledgeModified: 'Lisätty',
    companyKnowledgeDelete: 'Poista',
    companyKnowledgeDeleteConfirm: 'Poistetaanko {name} tietopankista?',
    companyKnowledgeUpload: 'Lisää asiakirja',
    companyKnowledgeUploading: 'Ladataan …',
    companyKnowledgeIntake: 'Käsittely',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'Tietopankki on tyhjä.',
    companyKnowledgeNotConfigured: 'Tietopankkia ei ole liitetty hallinta-API:in.',
    companyGuestsTitle: 'Vieraat, joilla on pääsy',
    companyGuestsHint: 'Jokainen osoite verkkotunnuksessa {domains} voi käyttää bottia. Yksittäiset ulkoiset osoitteet ylläpitäjät lisäävät tähän; muutos tulee voimaan heti.',
    companyGuestsEmail: 'Sähköpostiosoite',
    companyGuestsAdd: 'Lisää',
    companyGuestsRemove: 'Poista',
    companyGuestsRemoveConfirm: 'Poistetaanko käyttäjän {email} pääsy bottiin?',
    companyGuestsAddedBy: 'Lisännyt',
    companyGuestsAddedAt: 'Lisätty',
    companyGuestsEmpty: 'Vieraita ei ole lisätty.',
    companyGuestsNotPersistent: 'Luetteloa ei tallenneta: sillalla ei ole datahakemistoa.',
    companyGuestsLoadFailed: 'Tallennettua luetteloa ei voitu lukea; yhdelläkään vieraalla ei ole pääsyä ennen seuraavaa muutosta.',
    companyErrorRecipientNotAllowed: 'Tämä osoite ei voi vastata botille. Lisää se ensin vieraaksi ja lähetä sitten.',
    companyErrorDomainAllowed: 'Tämän verkkotunnuksen osoitteilla on jo pääsy.',
    companyErrorInvalidEmail: 'Virheellinen sähköpostiosoite.',
    companyErrorAlreadyListed: 'Osoite on jo luettelossa.',
    companyErrorStoreUnwritable: 'Luetteloa ei voitu tallentaa.',
    smtmFilterTitle: 'SMTM-instrumenttisuodatin',
    smtmFilterSubtitle: 'Tyhjä syöte näyttää kaikki instrumentit; useat instrumenttien nimet erotetaan pilkulla, esimerkiksi EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Instrumenttien nimet, pilkuilla eroteltuna',
    smtmFilterApply: 'Käytä suodatinta',
    smtmFilterClear: 'Tyhjennä suodatin',
    smtmReportingTitle: 'SMTM-signaaliraportointi',
    smtmReportingSubtitle: 'Näyttää hyväksytyt ostosignaalit, niiden exit-arvioinnin ja automaattisten ilmoitusten toimitustilan.',
    smtmReportingUnavailable: 'SMTM-raportointi ei ole saatavilla',
    smtmReportingQualifiedSignals: 'Hyväksytyt signaalit',
    smtmReportingOpenSignals: 'Avoimet signaalit',
    smtmReportingResolvedSignals: 'Ratkaistut signaalit',
    smtmReportingWins: 'Osumat',
    smtmReportingLosses: 'Tappiot',
    smtmReportingWinRate: 'Osumatarkkuus',
    smtmReportingAverageActualReturn: 'Keskim. toteutunut tuotto',
    smtmReportingNetActualReturn: 'Netto toteutunut tuotto',
    smtmReportingDeliveryFailed: 'Epäonnistuneet toimitukset',
    smtmReportingEntryTime: 'Sisääntuloaika',
    smtmReportingExitTime: 'Ulostuloaika',
    smtmReportingExpectedReturn: 'Odotettu tuotto',
    smtmReportingActualReturn: 'Toteutunut tuotto',
    smtmReportingSignalStatus: 'Signaalin tila',
    smtmReportingNoSignals: 'Hyväksyttyjä signaaleja ei ole vielä tallennettu.',
    smtmReportingPendingDeliveries: 'Odottavat toimitukset',
    smtmReportingFailedDeliveries: 'Epäonnistuneet toimitukset',
    smtmReportingDeliveryError: 'Toimitusvirhe',
    smtmTrainingTitle: 'SMTM-koulutus ja mallit',
    smtmTrainingSubtitle: 'Näyttää koulutuksen laadun, mallien tilan ja koulutuspalvelun julkaisemat artefaktit.',
    smtmTrainingUnavailable: 'SMTM-koulutus ei ole saatavilla',
    smtmTrainingModels: 'Mallit',
    smtmTrainingOnlineModels: 'Verkossa olevat mallit',
    smtmTrainingFailedModels: 'Epäonnistuneet mallit',
    smtmTrainingStaleModels: 'Vanhentuneet mallit',
    smtmTrainingAverageMae: 'Keskim. MAE',
    smtmTrainingAverageRmse: 'Keskim. RMSE',
    smtmTrainingAverageR2: 'Keskim. R²',
    smtmTrainingAverageMase: 'Keskim. MASE',
    smtmTrainingAverageHitRate: 'Keskim. suuntaosuma',
    smtmTrainingHitRate: 'Suuntaosuma',
    smtmTrainingLastSuccess: 'Viimeisin onnistunut koulutus',
    smtmTrainingResolution: 'Resoluutio / horisontti',
    smtmTrainingConsoleTitle: 'SMTM-koulutuskonsoli',
    smtmTrainingConsoleSubtitle: 'Koulutuspalvelun tulosteen suora seuranta.',
    smtmTrainingConsoleUnavailable: 'SMTM-koulutuskonsoli ei ole saatavilla',
    smtmTrainingConsoleEmpty: 'Koulutustulostetta ei ole vielä.',
    smtmRuntimeTitle: 'SMTM-ajoympäristö',
    smtmRuntimeSubtitle: 'Käynnissä olevan SMTM-järjestelmän yleinen horisontti, uudelleenrakennuksen tila ja ennusteportti.',
    smtmRuntimeUnavailable: 'SMTM-ajoympäristö ei ole saatavilla',
    smtmRuntimeForecastHorizon: 'Ennustehorisontti',
    smtmRuntimeResolution: 'Resoluutio',
    smtmRuntimeConfigVersion: 'Asetusversio',
    smtmRuntimePredictionGate: 'Ennusteportti',
    smtmRuntimeRebuild: 'Uudelleenrakennus',
    smtmRuntimeStateOpen: 'auki',
    smtmRuntimeStateClosed: 'kiinni',
    smtmRuntimeStateActive: 'aktiivinen',
    smtmRuntimeStateIdle: 'jouten',
    smtmRuntimeForecastHorizonMinutes: 'Ennustehorisontti minuutteina',
    smtmRuntimeResolutionMinutes: 'Resoluutio minuutteina',
    smtmRuntimeRequireCompletedBars: 'Vaadi valmiit kynttilät',
    smtmRuntimePredictionGateOpen: 'Ennusteportti auki',
    smtmRuntimeRebuildActive: 'Uudelleenrakennus aktiivinen',
    smtmRuntimeSaving: 'Tallennetaan ajoympäristöä...',
    smtmRuntimeSave: 'Tallenna ajoympäristön asetukset',
    smtmRuntimeReset: 'Hylkää ajoympäristön muutokset',
    smtmRuntimeSaved: 'SMTM-ajoympäristön asetukset tallennettu.',
    smtmTrainingRows: 'Koulutus-/testirivit',
    smtmTrainingMetrics: 'Mittarit',
    smtmTrainingIssues: 'Koulutuksen ongelmat',
    smtmTrainingLlmFeatures: 'LLM-piirteet',
    smtmTrainingNoModels: 'Välimuistissa ei ole koulutusmalleja.',
    smtmDirection: 'Suunta',
    smtmSentiment: 'Sentimentti',
    smtmDeliveryStage: 'Vaihe',
    smtmDeliveryRecipient: 'Vastaanottaja',
    mailSettingsSaved: 'Sähköpostiasetukset tallennettu.',
    mailTestSent: 'Testiviesti lähetetty.',
    userCreatedSuccess: 'Käyttäjä luotiin onnistuneesti.',
    userUpdatedSuccess: 'Käyttäjä päivitettiin onnistuneesti.',
    userDeletedSuccess: 'Käyttäjä poistettiin onnistuneesti.',
    deleteUser: 'Poista käyttäjä',
    roleLabels: {
      admin: 'Ylläpitäjä',
      pro: 'Pro',
      tester: 'Testaaja',
      user: 'Käyttäjä'
    },
    statusLabels: {
      pending_email_verification: 'Sähköpostin vahvistus kesken',
      pending_mfa: '2FA kesken',
      active: 'Aktiivinen',
      locked: 'Lukittu',
      disabled: 'Poistettu käytöstä'
    }
  },
  footer: {
    managingDirectors: 'Toimitusjohtajat',
    servicesTitle: 'Palvelut',
    legal: { title: 'Oikeudelliset tiedot', imprint: 'Oikeudellinen ilmoitus', privacy: 'Tietosuojaseloste', aiTransparency: 'Tekoälyn läpinäkyvyys', cookieSettings: 'Evästeasetukset', terms: 'Käyttöehdot' },
    copyright: 'Kaikki oikeudet pidätetään.'
  },
  auth: {
    validating: 'Validoidaan...',
    errors: {
      registrationFailed: 'Rekisteröinti epäonnistui: ',
      unknownError: 'Tuntematon virhe'
    }
  },
  account: {
    username: 'Käyttäjänimi',
    email: 'Sähköposti',
    roles: 'Roolit',
    manageText: 'Salasanaa, kaksivaiheista tunnistautumista, aktiivisia istuntoja ja sähköpostiosoitetta hallitaan tilinhallinnassa.',
    manageButton: 'Avaa tilinhallinta',
    signedOut: 'Et ole kirjautunut sisään.'
  },
  cookies: {
    title: 'Tietosuoja-asetukset',
    description: 'Analysoimme kävijätilastoja koneoppimisen menetelmillä parantaaksemme verkkosivustoamme. Suostumuksellasi käsittelemme tätä varten käyttö- ja laitetietoja, myös IP-osoitettasi, ja tunnistamme selaimesi myöhemmillä käynneillä. Suostumus on vapaaehtoinen, ja sen voi perua milloin tahansa kohdassa ”{settings}”. Lisätietoja, myös siirroista kolmansiin maihin, on tietosuojaselosteessa.',
    necessary: {
      title: 'Välttämättömät',
      description: 'Tarvitaan verkkosivuston toimintaan, esimerkiksi kielivalintaan ja tämän valinnan tallentamiseen.'
    },
    statistics: {
      title: 'Tilastot',
      description: 'Sivujen katselut ja sivuston käyttö ilman tunnistamista ja tallentamatta IP-osoitetta.'
    },
    marketing: {
      title: 'Analyysi ja koneoppiminen',
      description: 'Tunnistaminen myöhemmillä käynneillä sekä IP-osoitteen (likimääräinen sijainti, verkko-operaattori, organisaatio) ja laitteen ominaisuuksien analysointi; säilytetään enintään kaksitoista kuukautta viimeisen käynnin jälkeen. Tällöin IP-osoitteesi siirretään myös internetrekistereille Yhdysvalloissa, Australiassa ja Mauritiuksella, joiden osalta tietosuojan riittävää tasoa ei ole todettu; on olemassa riski, että paikalliset viranomaiset pääsevät käsiksi tietoihin ja että sinun on vaikeampi toteuttaa oikeuksiasi.'
    },
    acceptAll: 'Hyväksy kaikki',
    rejectAll: 'Vain välttämättömät',
    settings: 'Asetukset',
    save: 'Tallenna valinta',
    alwaysOn: 'Aina käytössä'
  },
  pages: {
    teaching: {
      hero: { title: 'Reunatekoäly- ja EU AI Act -koulutus', subtitle: 'Tekoälykonsultointi yrityksille • Reunalaskennan kehitystyö • Lainmukainen toteutus' },
      intro: 'Erikoistuneita tekoälykoulutuksia yritysjohdolle, projektipäälliköille ja kehitystiimeille. Strategisesta konsultoinnista tekniseen toteutukseen – EU AI Actin vaatimusten mukaisesti.',
      eu_ai_act: { title: 'EU AI Act -vaatimustenmukaisuus ja reunalaskenta', subtitle: 'Juridisesti kestävä tekoälytoteutus paikallisella tietojenkäsittelyllä', description: 'EU:n tekoälyasetus (EU AI Act) asettaa tiukat säännöt tekoälyn käytölle Euroopassa. Reunalaskenta (edge computing) on tähän ihanteellinen ratkaisu: arkaluonteiset tiedot pysyvät paikallisina, vaatimustenmukaisuus yksinkertaistuu ja tekoälyjärjestelmien hallinta säilyy omissa käsissäsi.', benefits: ['Tietosuoja paikallisen käsittelyn ansiosta', 'Yksinkertaisempi vaatimustenmukaisuuden hallinta', 'Täysi hallinta tekoälyn päätöksiin', 'Läpinäkyvyys ja jäljitettävyys', 'Pienemmät oikeudelliset riskit', 'Riippumattomuus pilvipalveluntarjoajista'], highlight: 'Reunalaskenta + EU AI Act = juridisesti kestävää tekoälyä ilman kompromisseja' },
      offerings: { title: 'Koulutustarjonta', categories: [{ title: 'Tekoäly ja koneoppiminen', icon: 'brain', topics: ['Generatiivinen tekoäly ja suuret kielimallit (reuna ja pilvi)', 'Perinteinen koneoppiminen (reunalaskentaan optimoitu)', 'Syväoppiminen ja neuroverkot (käyttöönotto reunalaitteissa)', 'Konenäkö ja NLP (reunalaskentaan soveltuvat ratkaisut)', 'RAG-järjestelmät ja LLM-mallien hienosäätö (reuna ja pilvi)', 'Autonomiset tekoälyagentit (reunalaskenta)', 'EU AI Act -vaatimustenmukaisuus ja oikeusvarmuus'] }, { title: 'Datatiede ja tilastotiede', icon: 'chart', topics: ['Kuvaileva tilastotiede ja tilastollinen päättely', 'Datan mallinnus ja analyysi', 'Aikasarja-analyysi', 'Ekonometria liiketalous- ja kansantaloustieteeseen', 'Biostatistiikka luonnontieteisiin', 'A/B-testaus ja koesuunnittelu'] }, { title: 'Ohjelmistoarkkitehtuuri ja tietoturva', icon: 'shield', topics: ['Modulaariset arkkitehtuurit', 'Löyhä kytkentä ja Clean Code', 'Mikropalveluiden suunnittelu', 'Tietoturva ja vaatimustenmukaisuus', 'DevOps ja CI/CD', 'Pilviarkkitehtuurit'] }] },
      target_groups: { title: 'Kohderyhmät', groups: [{ title: 'Yritysjohto ja päätöksentekijät', description: 'Strateginen tekoälykonsultointi, kustannusanalyysi ja investointipäätökset', formats: ['Johdon katsaukset', 'ROI-analyysit', 'Strategiakonsultointi'], focus: 'Kannattavuuslaskelmat (business case), EU AI Act -vaatimustenmukaisuus, budjettisuunnittelu' }, { title: 'Projektipäälliköt ja esihenkilöt', description: 'Tekoälyprojektien johtaminen, teknologiavalinnat ja toteutusstrategiat', formats: ['Työpajat projektijohdolle', 'Teknologia-arvioinnit', 'Tiekartan laatiminen'], focus: 'Projektisuunnittelu, toimittajavalinta, riskienhallinta' }, { title: 'IT-kehittäjät ja insinöörit', description: 'Käytännönläheinen reunatekoälyn kehitys, tekninen toteutus ja käyttöönotto', formats: ['Tekniset syväsukellukset', 'Koodikatselmoinnit', 'Arkkitehtuurityöpajat'], focus: 'Reunalaskenta, LLM-mallien hienosäätö, järjestelmäintegraatio' }, { title: 'Liiketoimintayksiköiden asiantuntijat', description: 'Tekoälyn ymmärtäminen, kehotetekniikat ja käytännön soveltaminen omassa työssä', formats: ['Käyttäjäkoulutus', 'Kehotetyöpajat', 'Käyttötapausten kehittäminen'], focus: 'Käytännön soveltaminen, integrointi työnkulkuihin, tuottavuuden parantaminen' }, { title: 'Opiskelijat ja tutkijat', description: 'Yliopisto-opetus, tukiopetus ja tieteellisten projektien ohjaus', formats: ['Luennot', 'Tutorointi', 'Opinnäytetöiden ohjaus'], focus: 'Tilastotiede, ekonometria, tutkimusmenetelmät' }] },
      expertise: { title: 'Tekninen asiantuntemus', items: ['Strategisten tekoälytiekarttojen laatiminen yrityksille', 'Reunatekoälyjärjestelmät RAG/GRAG-arkkitehtuureilla ja LoRA/QLoRA-hienosäädöllä', 'EU AI Act -vaatimustenmukaisuusstrategiat ja juridisesti kestävä toteutus', 'ROI-analyysit ja investointisuunnittelu tekoälyprojekteille', 'Autonomiset tekoälyagentit työkaluineen ja päättelykykyineen', 'Muutosjohtaminen tekoälyn käyttöönotossa organisaatioissa', 'Pilvi- ja on-premises-strategiat (Azure, STACKIT)', 'Kehotesuunnittelu ja työnkulkujen optimointi'] },
      technologies: { title: 'Teknologiapino', list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata' },
      clients: { title: 'Toimialat ja instituutiot', sectors: ['Sairausvakuutusala', 'Kustannusala', 'Pankit ja fintech', 'Teollisuus ja IoT', 'Tutkimus ja yliopistot', 'Konsultointi', 'Startup-yritykset'] },
      workshops: { title: 'Koulutusmuodot', formats: [{ title: 'Johdon katsaus', duration: '2–4 tuntia', description: 'Strateginen yleiskatsaus yritysjohdolle, painopisteinä ROI ja EU AI Act' }, { title: 'Työpaja projektijohdolle', duration: '1–2 päivää', description: 'Projektipäälliköiden koulutus tekoälyn käyttöönottoon ja muutosjohtamiseen' }, { title: 'Tekninen syväsukellus', duration: '2–5 päivää', description: 'Käytännönläheinen reunatekoälyn kehitys IT-tiimeille ja insinööreille' }, { title: 'Käyttäjäkoulutus', duration: '0,5–1 päivää', description: 'Tekoälyn käytännön soveltaminen liiketoimintayksiköiden asiantuntijoille' }, { title: 'Yksilövalmennus', duration: 'Tarpeen mukaan', description: 'Henkilökohtainen ohjaus ja projektituki' }] },
      sidebar: {languagesLabel: 'Kielet:', languagesValue: 'DE / EN / NL', focusLabel: 'Painopiste:', specializationTitle: 'Erikoistuminen', specializationItems: ['Reunatekoäly paikalliseen tietojenkäsittelyyn ilman pilviriippuvuutta', 'EU AI Actin mukainen toteutus oikeusvarmuuden takaamiseksi'], benefitsTitle: 'Hyödyt', benefits: ['Räätälöity kohderyhmän mukaan', 'Heti sovellettavissa', 'ROI-painotteinen', 'Etänä tai paikan päällä'] },
      cta: { title: 'Oletko valmis strategiseen tekoälytransformaatioon?', description: 'Johdon konsultoinnista tekniseen toteutukseen – keskustellaan juuri sinun vaatimuksistasi.', button: 'Pyydä konsultaatiota', email: 'info@paioneer.eu', subject: 'Koulutustiedustelu' }
    },
    agenticdev: {
      seo: { title: 'Intent-Driven Development (IDD) agenttiseen koodaukseen | pAIoneer Labs GmbH', description: 'Intent-Driven Development tekee tekoälyavusteisesta ohjelmistokehityksestä hallittavaa: merkityksestä, päätöksistä ja skenaarioista tulee agenttisen koodauksen operatiivisia artefakteja.', keywords: 'Intent-Driven Development, Intent Driven Development, IDD, Agentic Coding, agenttinen koodaus, agenttinen ohjelmistokehitys, tekoälyavusteinen ohjelmistokehitys, vibekoodaus, Spec-Driven Development, kehotesuunnittelu, vaatimusmäärittely tekoälyn avulla', ogTitle: 'Intent-Driven Development: merkitys ennen toteutusta', ogDescription: 'IDD tekee kontekstista operatiivista ennen kuin koodia kirjoitetaan: Intent, Decisions ja Scenarios muodostavat agenttisen ohjelmistokehityksen projektimuistin.', twitterTitle: 'Intent-Driven Development (IDD) agenttiseen koodaukseen', twitterDescription: 'Hallittavaa koodia kehotekaaoksen sijaan: IDD tekee merkityksestä, päätöksistä ja skenaarioista operatiivisia artefakteja.', url: 'https://paioneer-labs.eu/agenticdev', structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intent-Driven Development (IDD) agenttiseen koodaukseen', serviceType: 'Agenttinen ohjelmistokehitys ja tekoälyavusteiset kehitysprosessit', description: 'Konsultointi ja toteutus: Intent-Driven Development, IDD Vault -projektimuistit, agenttisen koodauksen työnkulut ja todennettava tekoälyavusteinen ohjelmistokehitys.', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' } },
      hero: { eyebrow: 'Agenttinen koodaus tarvitsee eksplisiittisen kontekstin', title: 'Intent-Driven Development', claim: 'Merkitys ennen toteutusta.', lead: 'Tekoäly kirjoittaa koodia. IDD varmistaa, että se työskentelee oikean ongelman parissa. Intent-Driven Development tekee tavoitteista, rajoista, päätöksistä ja skenaarioista agenttisen ohjelmistokehityksen operatiivisia artefakteja.' },
      implicitContextProblem: { title: 'Riskinä on implisiittinen konteksti', intro: 'Tekoälyavusteisen ohjelmistokehityksen todellinen riski ei ole puuttuva koodi. Riski on konteksti, joka jää piiloon jonkun päähän, keskusteluhistoriaan tai hajallaan oleviin tiketteihin.', items: [{ title: 'Epäselvä toimeksianto', description: 'Kehotteet kuvaavat usein ratkaisun, mutta eivät tavoitetta, ei-tavoitteita, onnistumiskriteerejä eivätkä oletuksia. Tekoäly työskentelee silloin nopeasti, mutta ei välttämättä oikeaan suuntaan.' }, { title: 'Sattumanvarainen arkkitehtuuri', description: 'Teknologiapäätökset syntyvät ohimennen: tietojen tallennus, mallivalinta, virhetilanteet ja tuotantokäyttö ratkeavat implisiittisesti sen sijaan, että niitä ohjattaisiin tietoisesti.' }, { title: 'Tulos, jota ei voi todentaa', description: 'Ilman skenaarioita ja hyväksymiskriteerejä jää epäselväksi, toimiiko koodi todella oikein vai näyttääkö se vain uskottavalta.' }], resolution: 'IDD ratkaisee juuri tämän ongelman: ensin merkitys tehdään operatiiviseksi, ja vasta sitten siitä johdetaan koodi.' },
      antiVibeCoding: { title: 'Vibekoodaus ei ole kehitysprosessi', description: 'Demoihin voi riittää pelkkä tuntuma. Se ei riitä ohjelmistoon, johon liittyy tuotantokäyttöä, ylläpitoa, tietoturvaa, kustannuksia ja vastuuta. Agentit eivät tarvitse lisää fiilistä vaan eksplisiittisen kontekstin.', contrasts: ['Vibekoodaus luo liikettä. IDD luo suunnan.', 'Kehotteet tuottavat vastauksia. IDD luo projektimuistin.', 'Agenttinen koodaus ilman IDD:tä jää pelkäksi tekemiseksi. IDD:n avulla agenttisesta koodauksesta tulee hallittavaa kehitystä.'] },
      principle: { title: 'Dokumentaatio ei ole sivutuote', thesis: 'IDD:ssä dokumentaatio on operatiivinen artefakti.', description: 'Dokumentaatiota ei tehdä raportointia varten. Se on työtila, jossa tavoitteet, rajat, päätökset ja odotettu käyttäytyminen tehdään eksplisiittisiksi ennen kuin agentit toteuttavat mitään.', pillarsTitle: 'Intent. Decisions. Scenarios. Code.', pillarsIntro: 'IDD ei pelkistä ohjelmistokehitystä kehotteiksi. Se tekee hankkeen merkityksestä eksplisiittisen ja johtaa siitä todennettavan toteutuksen.', pillars: [{ title: 'Intent', description: 'Mitä halutaan saavuttaa, mikä rajataan nimenomaisesti pois ja mistä onnistuminen tunnistetaan?' }, { title: 'Decisions', description: 'Mitä tärkeitä päätöksiä on tehty, missä kontekstissa ja millaisin seurauksin?' }, { title: 'Scenarios', description: 'Millaista käyttäytymistä odotetaan normaalitapauksissa, reunatapauksissa, virhetilanteissa ja hyväksymistilanteissa?' }, { title: 'Code', description: 'Toteutus syntyy dokumentoidusta merkityksestä, ja se tarkistetaan skenaarioita ja todennusvaiheita vasten.' }] },
      vault: { title: 'IDD Vault: projektimuisti kehotehistorian sijaan', description: 'IDD Vault säilyttää olennaisen kontekstin siellä, missä agentit ja ihmiset voivat käyttää sitä uudelleen. Tiedostoja ei ole enempää kuin tarvitaan. Jokaisella tiedostolla on selkeä tehtävä.', rule: 'Vähän artefakteja. Selkeä tarkoitus. Pysyvä konteksti.', effect: 'Vault estää ratkaisevaa kontekstia katoamasta keskusteluun, jonkun päähän tai hajallaan oleviin tiketteihin.', treeLines: ['/project', '  /idd_vault', '    intent.md       # tavoite, ei-tavoitteet, onnistumiskriteerit, oletukset', '    decisions.md    # päätökset: konteksti, perustelut, seuraukset', '    scenarios.md    # käyttäytyminen, reunatapaukset, hyväksymiskriteerit', '  /code', '  AGENTS.md         # säännöt ja odotukset koodiagenteille', '  README.md         # aloitus, asennus, toimintatapa, rajat'] },
      outputs: { title: 'Ei tekstiä. Hallittavaa koodia.', description: 'IDD-tiedostot eivät ole raportti. Ne ovat syöte konkreettiseen toteutustyöhön ja havaintojen palauttamiseen takaisin projektiin.', items: [{ file: 'intent.md', result: 'Rajaus', description: 'Päätepisteet, tietomalli, onnistumiskriteerit, ei-tavoitteet ja oletukset tulevat näkyviin kehitystyön kehyksenä.' }, { file: 'decisions.md', result: 'Arkkitehtuuri', description: 'Teknologia, tuotantokäyttö, tietojen tallennus, mallivalinta ja kompromissit perustellaan sen sijaan, että niistä päätettäisiin ohimennen.' }, { file: 'scenarios.md', result: 'Testit', description: 'Hyväksymistestit, virhetilanteet, tilasiirtymät ja reunatapaukset syntyvät ennen toteutusta tai sen aikana.' }, { file: 'AGENTS.md', result: 'Koodin laatu', description: 'Säännöt, suunnittelumallit, rajoitteet, migraatiot, OpenAPI ja odotetut tulokset tehdään agenteille eksplisiittisiksi.' }, { file: 'README.md', result: 'Aloituskohta', description: 'Asennus, toimintatapa, rajat ja esimerkkikulut pysyvät ymmärrettävinä ihmisille ja agenteille.' }, { file: 'Koodi', result: 'Palautesilmukka', description: 'Toteutuksen ja todentamisen havainnot palaavat Vaultiin, testeihin ja seuraavaan iteraatioon.' }] },
      comparison: { title: 'IDD alkaa ennen spesifikaatiota', intro: 'Spec-Driven Development on vahva, kun tavoite on jo teknisesti täsmällinen ja vakaa. IDD alkaa aiemmin: siitä, missä toimialue, oletukset, kompromissit ja virhetilanteet on vasta tehtävä eksplisiittisiksi.', columns: ['Lähestymistapa', 'Keskiössä', 'Vahvuus', 'Rajoite'], rows: [{ approach: 'Kehotteet (prompting)', center: 'Syöte mallille', strength: 'Nopea ja suora', limit: 'Hetkellinen, epätäydellinen ja vaikeasti todennettava' }, { approach: 'Vibekoodaus', center: 'Tuntuma ja iterointi', strength: 'Hyödyllinen kokeiluissa ja demoissa', limit: 'Ei luotettavaa ohjausta ohjelmistolle, josta on kannettava vastuu' }, { approach: 'Spec-Driven Development', center: 'Tekninen sopimus', strength: 'Johdonmukaisuus jo määriteltyyn spesifikaatioon nähden', limit: 'Väärä ongelma voidaan toteuttaa muodollisesti oikein' }, { approach: 'Intent-Driven Development', center: 'Merkitys, tavoite ja päätökset', strength: 'Selkeyttää kontekstin, kompromissit ja rajat ennen toteutusta', limit: 'Vaatii kontekstin ja validoinnin kurinalaista ylläpitoa' }], summary: 'Spesifikaatiot kertovat, minkä on teknisesti pädettävä. IDD perustelee, miksi juuri tähän suuntaan kannattaa rakentaa.' },
      workflow: { title: 'Selkeytä. Päätä. Muotoile. Rakenna. Palauta havainnot.', description: 'IDD ei ole vesiputousmalli. IDD on pientä, hallittua iterointia pysyvän kontekstin varassa.', steps: [{ title: 'Selkeytä tarkoitus (intent)', description: 'Tavoitteet, ei-tavoitteet, onnistumiskriteerit ja oletukset tehdään näkyviksi ennen kuin koodia kirjoitetaan.' }, { title: 'Dokumentoi päätökset', description: 'Arkkitehtuuri- ja tuotepäätökset kirjataan konteksteineen, perusteluineen ja seurauksineen.' }, { title: 'Muotoile skenaariot', description: 'Normaali käyttäytyminen, reunatapaukset, virhetilanteet ja hyväksymiskriteerit kuvataan todennettavassa muodossa.' }, { title: 'Anna agenttien toteuttaa', description: 'Tekoälyagentit työskentelevät eksplisiittisen kontekstin pohjalta irrallisten kehotteiden sijaan.' }, { title: 'Todenna ja palauta havainnot', description: 'Koodista, testeistä ja tuotantokäytöstä saadut havainnot päivittävät Vaultin ja seuraavan iteraation.' }] },
      impact: { title: 'Miksi tällä on merkitystä oikeissa projekteissa', description: 'IDD kytkee tekoälyavusteisen kehityksen tiimeihin, tuotantokäyttöön ja laadunvarmistukseen.', items: ['Vähemmän uudelleentyötä, koska tavoitteet ja ei-tavoitteet ovat näkyvissä.', 'Parempi arkkitehtuuri, koska päätökset on perusteltu.', 'Paremmat testit, koska skenaariot ovat olemassa ennen koodia.', 'Parempi yhteistyö, koska konteksti ei katoa keskusteluun.', 'Paremmat agenttien tulokset, koska jokainen vaihe perustuu eksplisiittisiin artefakteihin.'] },
      contact: { title: 'Tuo IDD agenttisiin kehitysprosesseihin', description: 'Jos tekoälyavusteisen kehityksen halutaan olevan enemmän kuin kokeilua, se tarvitsee operatiivisen kontekstimallin.', details: 'Autamme rakentamaan IDD Vaulteja, agenttisääntöjä, skenaarioita ja todennettavia kehitystyönkulkuja.', button: 'Keskustellaan IDD:stä', subject: 'Keskustelu Intent-Driven Developmentista', email: 'info@paioneer.eu' }
    },
    impressum: injectPersonalData('fi', baseTranslationFI)
  }
};
